{
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "pageOffset": {
      "nextOffset": "COVCELQ4KICg47zZoJXjVDCnEzgC",
      "widgetOffset": {
        "NewListingView_Topical_Fullbleed": "",
        "NewListingView_category_bar_chicletranking_TwoRows": "",
        "NewListingView_category_bar_chicletranking_TwoRows_Rendition": "",
        "Restaurant_Group_WebView_SEO_PB_Theme": "",
        "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo": "10",
        "inlineFacetFilter": "",
        "restaurantCountWidget": ""
      }
    },
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "header": {
              "headerStyling": {
                "padding": {
                  "left": 16,
                  "top": 14,
                  "bottom": 2
                }
              }
            },
            "layout": {
              "rows": 1,
              "columns": 2,
              "horizontalScrollEnabled": true,
              "shouldSnap": true,
              "itemSpacing": 10,
              "widgetPadding": {},
              "containerStyle": {
                "containerPadding": {
                  "left": 16,
                  "top": 12,
                  "right": 16,
                  "bottom": 12
                }
              },
              "scrollBar": {
                "scrollThumbColor": "#E46D47",
                "scrollTrackColor": "#E4E4E4",
                "width": 54,
                "height": 4,
                "scrollStyling": {
                  "padding": {
                    "top": 6,
                    "bottom": 12
                  }
                }
              },
              "autoScrollConfig": {
                "isScrollEnabled": true,
                "autoScrollDuration": 4,
                "autoScrollResetDuration": 4
              },
              "dotScrollBar": {
                "activeColor": "#36393E",
                "inactiveColor": "#66686E",
                "activeSize": 16,
                "inactiveMediumSize": 7,
                "inactiveSmallSize": 4,
                "dotSpacing": 8,
                "windowSize": 5,
                "showCount": true,
                "textColor": "#FFFFFF",
                "scrollStyling": {
                  "padding": {
                    "top": 6,
                    "bottom": 12
                  }
                }
              }
            },
            "imageGridCards": {
              "info": [
                {
                  "id": "1539059",
                  "imageId": "rng/md/carousel/production/7c92c3744ea5da6c0204cb8ec2918410",
                  "action": {
                    "link": "https://www.swiggy.com/collections/99942?collection_id=99942&type=rcv2",
                    "text": "Gourmet LN/DN",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "GOURMET lunch",
                    "altTextCta": "Order now"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=99942",
                  "frequencyCapping": {}
                },
                {
                  "id": "1524700",
                  "imageId": "rng/md/carousel/production/967140f5e000b2f1e35f54a7c965e7dc",
                  "action": {
                    "link": "swiggy://fusion-landing?id=theCokepage&show_location=true",
                    "text": "Coke",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "Coke",
                    "altTextCta": "Order Now"
                  },
                  "entityId": "swiggy://fusion-landing?id=theCokepage&show_location=true",
                  "frequencyCapping": {},
                  "isManualAds": true
                }
              ],
              "style": {
                "width": {
                  "type": "TYPE_RELATIVE",
                  "value": 0.95238,
                  "reference": "RELATIVE_DIMENSION_REFERENCE_CONTAINER_WIDTH"
                },
                "height": {
                  "type": "TYPE_RELATIVE",
                  "value": 0.59685,
                  "reference": "RELATIVE_DIMENSION_REFERENCE_WIDTH"
                }
              }
            },
            "id": "topical_banner",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.ImageInfoLayoutCard",
                "info": [
                  {
                    "id": "1539059",
                    "imageId": "rng/md/carousel/production/7c92c3744ea5da6c0204cb8ec2918410",
                    "action": {
                      "link": "https://www.swiggy.com/collections/99942?collection_id=99942&type=rcv2",
                      "text": "Gourmet LN/DN",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "GOURMET lunch",
                      "altTextCta": "Order now"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=99942",
                    "frequencyCapping": {}
                  },
                  {
                    "id": "1524700",
                    "imageId": "rng/md/carousel/production/967140f5e000b2f1e35f54a7c965e7dc",
                    "action": {
                      "link": "swiggy://fusion-landing?id=theCokepage&show_location=true",
                      "text": "Coke",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "Coke",
                      "altTextCta": "Order Now"
                    },
                    "entityId": "swiggy://fusion-landing?id=theCokepage&show_location=true",
                    "frequencyCapping": {},
                    "isManualAds": true
                  }
                ],
                "style": {
                  "width": {
                    "type": "TYPE_RELATIVE",
                    "value": 0.95238,
                    "reference": "RELATIVE_DIMENSION_REFERENCE_CONTAINER_WIDTH"
                  },
                  "height": {
                    "type": "TYPE_RELATIVE",
                    "value": 0.59685,
                    "reference": "RELATIVE_DIMENSION_REFERENCE_WIDTH"
                  }
                }
              }
            }
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "header": {
              "title": "What's on your mind?",
              "headerStyling": {
                "padding": {
                  "left": 16,
                  "top": 16,
                  "bottom": 4
                }
              }
            },
            "layout": {
              "rows": 1,
              "columns": 10,
              "horizontalScrollEnabled": true,
              "itemSpacing": 24,
              "widgetPadding": {},
              "containerStyle": {
                "containerPadding": {
                  "left": 8,
                  "top": 8,
                  "right": 12,
                  "bottom": 4
                }
              },
              "scrollBar": {},
              "widgetTheme": {
                "defaultMode": {
                  "backgroundColour": "#FFFFFF",
                  "theme": "THEME_TYPE_LIGHT"
                },
                "darkMode": {
                  "theme": "THEME_TYPE_DARK"
                }
              }
            },
            "imageGridCards": {
              "info": [
                {
                  "id": "750592",
                  "imageId": "v1675667625/PC_Creative%20refresh/Biryani_2.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/83649?collection_id=83649&searchQuery=biryani&tags=layout_CCS_Biryani&type=rcv2",
                    "text": "Biryani",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurants curated for biryani",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=83649&tags=layout_CCS_Biryani&searchQuery=biryani",
                  "frequencyCapping": {}
                },
                {
                  "id": "750584",
                  "imageId": "v1675667626/PC_Creative%20refresh/South_Indian_4.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/83646?collection_id=83646&tags=layout_CCS_SouthIndian&type=rcv2",
                    "text": "South Indian",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurants curated for south indian",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=83646&tags=layout_CCS_SouthIndian",
                  "frequencyCapping": {}
                },
                {
                  "id": "750572",
                  "imageId": "v1674029858/PC_Creative%20refresh/3D_bau/banners_new/Pure_Veg.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/80439?collection_id=80439&tags=layout_CCS_PureVeg&type=rcv2",
                    "text": "Pure Veg",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurants curated for veg",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=80439&tags=layout_CCS_PureVeg",
                  "frequencyCapping": {}
                },
                {
                  "id": "750580",
                  "imageId": "v1674029856/PC_Creative%20refresh/3D_bau/banners_new/Pizza.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/83644?collection_id=83644&tags=layout_CCS_Pizza&type=rcv2",
                    "text": "pizzas",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurants curated for pizza",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=83644&tags=layout_CCS_Pizza",
                  "frequencyCapping": {}
                },
                {
                  "id": "749874",
                  "imageId": "v1674029845/PC_Creative%20refresh/3D_bau/banners_new/Cakes.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/83656?collection_id=83656&tags=layout_CCS_Cake&type=rcv2",
                    "text": "Cakes",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurant curated for cakes",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=83656&tags=layout_CCS_Cake",
                  "frequencyCapping": {}
                },
                {
                  "id": "750597",
                  "imageId": "v1674029851/PC_Creative%20refresh/3D_bau/banners_new/Ice_Creams.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/83650?collection_id=83650&tags=layout_CCS_IceCreams&type=rcv2",
                    "text": "Ice Cream",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurants curated for icecream",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=83650&tags=layout_CCS_IceCreams",
                  "frequencyCapping": {}
                },
                {
                  "id": "750205",
                  "imageId": "v1674029853/PC_Creative%20refresh/3D_bau/banners_new/Parotta.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/80478?collection_id=80478&tags=layout_BAU_Contextual%2Cparotta&type=rcv2",
                    "text": "Parotta",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurant curated for parotta",
                    "altTextCta": "open"
                  },
                  "entityId": "80478",
                  "frequencyCapping": {}
                },
                {
                  "id": "762797",
                  "imageId": "v1674029845/PC_Creative%20refresh/3D_bau/banners_new/Burger.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/83637?collection_id=83637&tags=layout_CCS_Burger&type=rcv2",
                    "text": "Burgers",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurants curated for burger",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=83637&tags=layout_CCS_Burger",
                  "frequencyCapping": {}
                },
                {
                  "id": "750223",
                  "imageId": "v1674029858/PC_Creative%20refresh/3D_bau/banners_new/Rolls.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/83670?collection_id=83670&tags=layout_CCS_Rolls&type=rcv2",
                    "text": "Rolls",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurants curated for roll",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=83670&tags=layout_CCS_Rolls",
                  "frequencyCapping": {}
                },
                {
                  "id": "750132",
                  "imageId": "v1674029850/PC_Creative%20refresh/3D_bau/banners_new/Dosa.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/80426?collection_id=80426&tags=layout_CCS_Dosa&type=rcv2",
                    "text": "Dosa",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurants curated for dosa",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=80426&tags=layout_CCS_Dosa",
                  "frequencyCapping": {}
                },
                {
                  "id": "750588",
                  "imageId": "v1674029848/PC_Creative%20refresh/3D_bau/banners_new/Chinese.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/83647?collection_id=83647&tags=layout_CCS_Chinese&type=rcv2",
                    "text": "Chinese",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurant curated for chinese",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=83647&tags=layout_CCS_Chinese",
                  "frequencyCapping": {}
                },
                {
                  "id": "750239",
                  "imageId": "v1674029858/PC_Creative%20refresh/3D_bau/banners_new/Shakes.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/83674?collection_id=83674&tags=layout_CCS_Shakes&type=rcv2",
                    "text": "Shake",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurant curated for shakes",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=83674&tags=layout_CCS_Shakes",
                  "frequencyCapping": {}
                },
                {
                  "id": "750582",
                  "imageId": "v1675667625/PC_Creative%20refresh/North_Indian_4.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/83645?collection_id=83645&tags=layout_CCS_NorthIndian&type=rcv2",
                    "text": "North Indian",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurants curated for north indian",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=83645&tags=layout_CCS_NorthIndian",
                  "frequencyCapping": {}
                },
                {
                  "id": "750207",
                  "imageId": "v1674029854/PC_Creative%20refresh/3D_bau/banners_new/Pasta.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/80480?collection_id=80480&tags=layout_BAU_Contextual%2Cpasta%2Cads_pc_pasta&type=rcv2",
                    "text": "Pasta",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurant curated for pasta",
                    "altTextCta": "open"
                  },
                  "entityId": "80480",
                  "frequencyCapping": {}
                },
                {
                  "id": "750562",
                  "imageId": "v1674029842/PC_Creative%20refresh/3D_bau/banners_new/Vada.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/80427?collection_id=80427&tags=layout_BAU_Contextual%2Cvada&type=rcv2",
                    "text": "Vada",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurants curated for vada",
                    "altTextCta": "open"
                  },
                  "entityId": "80427",
                  "frequencyCapping": {}
                },
                {
                  "id": "750249",
                  "imageId": "v1674029859/PC_Creative%20refresh/3D_bau/banners_new/Shawarma.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/80403?collection_id=80403&tags=layout_Shawarma_Contextual&type=rcv2",
                    "text": "Shawarma",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurant curated for shawarma",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=80403&tags=layout_Shawarma_Contextual",
                  "frequencyCapping": {}
                },
                {
                  "id": "750237",
                  "imageId": "v1674029855/PC_Creative%20refresh/3D_bau/banners_new/Poori.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/80378?collection_id=80378&tags=layout_BAU_Contextual%2Cpoori&type=rcv2",
                    "text": "Poori",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurant curated for poori",
                    "altTextCta": "open"
                  },
                  "entityId": "80378",
                  "frequencyCapping": {}
                },
                {
                  "id": "750636",
                  "imageId": "v1674029853/PC_Creative%20refresh/3D_bau/banners_new/Kebabs.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/80452?collection_id=80452&tags=layout_BAU_Contextual%2Ckebab%2Cads_pc_kebab&type=rcv2",
                    "text": "Kebabs",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurant curated for kebabs",
                    "altTextCta": "open"
                  },
                  "entityId": "80452",
                  "frequencyCapping": {}
                },
                {
                  "id": "750644",
                  "imageId": "v1674029846/PC_Creative%20refresh/3D_bau/banners_new/Idli.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/80441?collection_id=80441&searchContext=idli&tags=layout_CCS_Idli&type=rcv2",
                    "text": "Idli",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurants curated for idly",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=80441&tags=layout_CCS_Idli&searchContext=idli",
                  "frequencyCapping": {}
                },
                {
                  "id": "750203",
                  "imageId": "v1674029853/PC_Creative%20refresh/3D_bau/banners_new/Paratha.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/80476?collection_id=80476&tags=layout_BAU_Contextual%2Cparatha%2Cads_pc_paratha&type=rcv2",
                    "text": "Paratha",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurants curated for paratha",
                    "altTextCta": "open"
                  },
                  "entityId": "80476",
                  "frequencyCapping": {}
                }
              ],
              "style": {
                "width": {
                  "type": "TYPE_RELATIVE",
                  "value": 0.2941,
                  "reference": "RELATIVE_DIMENSION_REFERENCE_CONTAINER_WIDTH"
                },
                "height": {
                  "type": "TYPE_RELATIVE",
                  "value": 1.2444,
                  "reference": "RELATIVE_DIMENSION_REFERENCE_WIDTH"
                }
              }
            },
            "id": "whats_on_your_mind",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.ImageInfoLayoutCard",
                "info": [
                  {
                    "id": "750592",
                    "imageId": "v1675667625/PC_Creative%20refresh/Biryani_2.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/83649?collection_id=83649&searchQuery=biryani&tags=layout_CCS_Biryani&type=rcv2",
                      "text": "Biryani",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurants curated for biryani",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=83649&tags=layout_CCS_Biryani&searchQuery=biryani",
                    "frequencyCapping": {}
                  },
                  {
                    "id": "750584",
                    "imageId": "v1675667626/PC_Creative%20refresh/South_Indian_4.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/83646?collection_id=83646&tags=layout_CCS_SouthIndian&type=rcv2",
                      "text": "South Indian",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurants curated for south indian",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=83646&tags=layout_CCS_SouthIndian",
                    "frequencyCapping": {}
                  },
                  {
                    "id": "750572",
                    "imageId": "v1674029858/PC_Creative%20refresh/3D_bau/banners_new/Pure_Veg.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/80439?collection_id=80439&tags=layout_CCS_PureVeg&type=rcv2",
                      "text": "Pure Veg",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurants curated for veg",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=80439&tags=layout_CCS_PureVeg",
                    "frequencyCapping": {}
                  },
                  {
                    "id": "750580",
                    "imageId": "v1674029856/PC_Creative%20refresh/3D_bau/banners_new/Pizza.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/83644?collection_id=83644&tags=layout_CCS_Pizza&type=rcv2",
                      "text": "pizzas",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurants curated for pizza",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=83644&tags=layout_CCS_Pizza",
                    "frequencyCapping": {}
                  },
                  {
                    "id": "749874",
                    "imageId": "v1674029845/PC_Creative%20refresh/3D_bau/banners_new/Cakes.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/83656?collection_id=83656&tags=layout_CCS_Cake&type=rcv2",
                      "text": "Cakes",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurant curated for cakes",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=83656&tags=layout_CCS_Cake",
                    "frequencyCapping": {}
                  },
                  {
                    "id": "750597",
                    "imageId": "v1674029851/PC_Creative%20refresh/3D_bau/banners_new/Ice_Creams.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/83650?collection_id=83650&tags=layout_CCS_IceCreams&type=rcv2",
                      "text": "Ice Cream",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurants curated for icecream",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=83650&tags=layout_CCS_IceCreams",
                    "frequencyCapping": {}
                  },
                  {
                    "id": "750205",
                    "imageId": "v1674029853/PC_Creative%20refresh/3D_bau/banners_new/Parotta.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/80478?collection_id=80478&tags=layout_BAU_Contextual%2Cparotta&type=rcv2",
                      "text": "Parotta",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurant curated for parotta",
                      "altTextCta": "open"
                    },
                    "entityId": "80478",
                    "frequencyCapping": {}
                  },
                  {
                    "id": "762797",
                    "imageId": "v1674029845/PC_Creative%20refresh/3D_bau/banners_new/Burger.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/83637?collection_id=83637&tags=layout_CCS_Burger&type=rcv2",
                      "text": "Burgers",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurants curated for burger",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=83637&tags=layout_CCS_Burger",
                    "frequencyCapping": {}
                  },
                  {
                    "id": "750223",
                    "imageId": "v1674029858/PC_Creative%20refresh/3D_bau/banners_new/Rolls.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/83670?collection_id=83670&tags=layout_CCS_Rolls&type=rcv2",
                      "text": "Rolls",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurants curated for roll",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=83670&tags=layout_CCS_Rolls",
                    "frequencyCapping": {}
                  },
                  {
                    "id": "750132",
                    "imageId": "v1674029850/PC_Creative%20refresh/3D_bau/banners_new/Dosa.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/80426?collection_id=80426&tags=layout_CCS_Dosa&type=rcv2",
                      "text": "Dosa",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurants curated for dosa",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=80426&tags=layout_CCS_Dosa",
                    "frequencyCapping": {}
                  },
                  {
                    "id": "750588",
                    "imageId": "v1674029848/PC_Creative%20refresh/3D_bau/banners_new/Chinese.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/83647?collection_id=83647&tags=layout_CCS_Chinese&type=rcv2",
                      "text": "Chinese",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurant curated for chinese",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=83647&tags=layout_CCS_Chinese",
                    "frequencyCapping": {}
                  },
                  {
                    "id": "750239",
                    "imageId": "v1674029858/PC_Creative%20refresh/3D_bau/banners_new/Shakes.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/83674?collection_id=83674&tags=layout_CCS_Shakes&type=rcv2",
                      "text": "Shake",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurant curated for shakes",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=83674&tags=layout_CCS_Shakes",
                    "frequencyCapping": {}
                  },
                  {
                    "id": "750582",
                    "imageId": "v1675667625/PC_Creative%20refresh/North_Indian_4.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/83645?collection_id=83645&tags=layout_CCS_NorthIndian&type=rcv2",
                      "text": "North Indian",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurants curated for north indian",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=83645&tags=layout_CCS_NorthIndian",
                    "frequencyCapping": {}
                  },
                  {
                    "id": "750207",
                    "imageId": "v1674029854/PC_Creative%20refresh/3D_bau/banners_new/Pasta.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/80480?collection_id=80480&tags=layout_BAU_Contextual%2Cpasta%2Cads_pc_pasta&type=rcv2",
                      "text": "Pasta",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurant curated for pasta",
                      "altTextCta": "open"
                    },
                    "entityId": "80480",
                    "frequencyCapping": {}
                  },
                  {
                    "id": "750562",
                    "imageId": "v1674029842/PC_Creative%20refresh/3D_bau/banners_new/Vada.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/80427?collection_id=80427&tags=layout_BAU_Contextual%2Cvada&type=rcv2",
                      "text": "Vada",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurants curated for vada",
                      "altTextCta": "open"
                    },
                    "entityId": "80427",
                    "frequencyCapping": {}
                  },
                  {
                    "id": "750249",
                    "imageId": "v1674029859/PC_Creative%20refresh/3D_bau/banners_new/Shawarma.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/80403?collection_id=80403&tags=layout_Shawarma_Contextual&type=rcv2",
                      "text": "Shawarma",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurant curated for shawarma",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=80403&tags=layout_Shawarma_Contextual",
                    "frequencyCapping": {}
                  },
                  {
                    "id": "750237",
                    "imageId": "v1674029855/PC_Creative%20refresh/3D_bau/banners_new/Poori.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/80378?collection_id=80378&tags=layout_BAU_Contextual%2Cpoori&type=rcv2",
                      "text": "Poori",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurant curated for poori",
                      "altTextCta": "open"
                    },
                    "entityId": "80378",
                    "frequencyCapping": {}
                  },
                  {
                    "id": "750636",
                    "imageId": "v1674029853/PC_Creative%20refresh/3D_bau/banners_new/Kebabs.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/80452?collection_id=80452&tags=layout_BAU_Contextual%2Ckebab%2Cads_pc_kebab&type=rcv2",
                      "text": "Kebabs",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurant curated for kebabs",
                      "altTextCta": "open"
                    },
                    "entityId": "80452",
                    "frequencyCapping": {}
                  },
                  {
                    "id": "750644",
                    "imageId": "v1674029846/PC_Creative%20refresh/3D_bau/banners_new/Idli.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/80441?collection_id=80441&searchContext=idli&tags=layout_CCS_Idli&type=rcv2",
                      "text": "Idli",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurants curated for idly",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=80441&tags=layout_CCS_Idli&searchContext=idli",
                    "frequencyCapping": {}
                  },
                  {
                    "id": "750203",
                    "imageId": "v1674029853/PC_Creative%20refresh/3D_bau/banners_new/Paratha.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/80476?collection_id=80476&tags=layout_BAU_Contextual%2Cparatha%2Cads_pc_paratha&type=rcv2",
                      "text": "Paratha",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurants curated for paratha",
                      "altTextCta": "open"
                    },
                    "entityId": "80476",
                    "frequencyCapping": {}
                  }
                ],
                "style": {
                  "width": {
                    "type": "TYPE_RELATIVE",
                    "value": 0.2941,
                    "reference": "RELATIVE_DIMENSION_REFERENCE_CONTAINER_WIDTH"
                  },
                  "height": {
                    "type": "TYPE_RELATIVE",
                    "value": 1.2444,
                    "reference": "RELATIVE_DIMENSION_REFERENCE_WIDTH"
                  }
                }
              }
            }
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "header": {
              "title": "Top restaurant chains in Coimbatore",
              "action": {},
              "headerStyling": {
                "padding": {
                  "left": 16,
                  "top": 28,
                  "bottom": 18
                }
              }
            },
            "layout": {
              "rows": 1,
              "columns": 20,
              "horizontalScrollEnabled": true,
              "itemSpacing": 32,
              "widgetPadding": {},
              "containerStyle": {
                "containerPadding": {
                  "left": 16,
                  "right": 12,
                  "bottom": 12
                }
              },
              "scrollBar": {
                "scrollThumbColor": "#E46D47",
                "scrollTrackColor": "#02060C",
                "width": 54,
                "height": 4,
                "scrollStyling": {
                  "padding": {
                    "top": 6,
                    "bottom": 24
                  }
                }
              },
              "widgetTheme": {
                "defaultMode": {
                  "backgroundColour": "#1B3028",
                  "theme": "THEME_TYPE_DARK"
                },
                "darkMode": {
                  "backgroundColour": "#1B3028",
                  "theme": "THEME_TYPE_DARK"
                }
              }
            },
            "id": "top_brands_for_you",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.FavouriteRestaurantInfoWithStyle",
                "restaurants": [
                  {
                    "info": {
                      "id": "63640",
                      "name": "Akshaya Park Restaurant",
                      "cloudinaryImageId": "cs4wx6q3iijtfosxue7n",
                      "locality": "Mettupalayam Road",
                      "areaName": "Thudiyalur",
                      "costForTwo": "₹200 for two",
                      "cuisines": ["Indian", "Chinese"],
                      "avgRating": 4.3,
                      "parentId": "7153",
                      "avgRatingString": "4.3",
                      "totalRatingsString": "10K+",
                      "sla": {
                        "deliveryTime": 34,
                        "lastMileTravel": 3,
                        "serviceability": "SERVICEABLE",
                        "slaString": "34 mins",
                        "lastMileTravelString": "3.0 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-12-24 22:30:00",
                        "opened": true
                      },
                      "badges": {
                        "textExtendedBadges": [
                          {
                            "iconId": "guiltfree/GF_Logo_android_3x",
                            "shortDescription": "options available",
                            "fontColor": "#7E808C"
                          }
                        ]
                      },
                      "isOpen": true,
                      "aggregatedDiscountInfoV2": {},
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "",
                                  "fontColor": "#7E808C",
                                  "iconId": "guiltfree/GF_Logo_android_3x",
                                  "shortDescription": "options available"
                                }
                              }
                            ]
                          }
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {},
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/akshaya-park-restaurant-mettupalayam-road-thudiyalur-coimbatore-63640",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "130193",
                      "name": "Domino's Pizza",
                      "cloudinaryImageId": "nwlbdiasm74wahpifhye",
                      "locality": "Sreevatsa Garden",
                      "areaName": "Thudiyalur",
                      "costForTwo": "₹400 for two",
                      "cuisines": ["Pizzas", "Italian", "Pastas", "Desserts"],
                      "avgRating": 4.4,
                      "parentId": "2456",
                      "avgRatingString": "4.4",
                      "totalRatingsString": "5K+",
                      "sla": {
                        "deliveryTime": 25,
                        "serviceability": "SERVICEABLE",
                        "slaString": "25 mins",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-12-24 22:55:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "₹150 OFF",
                        "subHeader": "ABOVE ₹299",
                        "discountTag": "FLAT DEAL"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {},
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/dominos-pizza-sreevatsa-garden-thudiyalur-coimbatore-130193",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "337623",
                      "name": "KFC",
                      "cloudinaryImageId": "f01666ac73626461d7455d9c24005cd4",
                      "locality": "Mettupalayam Road",
                      "areaName": "Thudiyalur",
                      "costForTwo": "₹400 for two",
                      "cuisines": [
                        "Burgers",
                        "Biryani",
                        "American",
                        "Snacks",
                        "Fast Food"
                      ],
                      "avgRating": 4.3,
                      "parentId": "547",
                      "avgRatingString": "4.3",
                      "totalRatingsString": "5K+",
                      "sla": {
                        "deliveryTime": 20,
                        "lastMileTravel": 4.6,
                        "serviceability": "SERVICEABLE",
                        "slaString": "20 mins",
                        "lastMileTravelString": "4.6 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-12-25 00:00:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "aggregatedDiscountInfoV2": {},
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {},
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/kfc-mettupalayam-road-thudiyalur-coimbatore-337623",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "63636",
                      "name": "Yummy Restaurant",
                      "cloudinaryImageId": "pfmlkpqt5bbeufqqkmkt",
                      "locality": "Mettupalayam Road",
                      "areaName": "Kavundampalayam",
                      "costForTwo": "₹200 for two",
                      "cuisines": ["Indian"],
                      "avgRating": 4.5,
                      "parentId": "5051",
                      "avgRatingString": "4.5",
                      "totalRatingsString": "10K+",
                      "sla": {
                        "deliveryTime": 27,
                        "lastMileTravel": 6.9,
                        "serviceability": "SERVICEABLE",
                        "slaString": "27 mins",
                        "lastMileTravelString": "6.9 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-12-24 23:00:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "15% OFF",
                        "subHeader": "ABOVE ₹700",
                        "discountTag": "FLAT DEAL"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {},
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/yummy-restaurant-mettupalayam-road-kavundampalayam-coimbatore-63636",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "431523",
                      "name": "Pizza Hut",
                      "cloudinaryImageId": "2b4f62d606d1b2bfba9ba9e5386fabb7",
                      "locality": "Mettupalayam Road",
                      "areaName": "Thudiyalur",
                      "costForTwo": "₹350 for two",
                      "cuisines": ["Pizzas"],
                      "avgRating": 4.3,
                      "parentId": "721",
                      "avgRatingString": "4.3",
                      "totalRatingsString": "1K+",
                      "sla": {
                        "deliveryTime": 29,
                        "lastMileTravel": 4.6,
                        "serviceability": "SERVICEABLE",
                        "slaString": "29 mins",
                        "lastMileTravelString": "4.6 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-12-25 00:59:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "ITEMS",
                        "subHeader": "AT ₹179"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {},
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/pizza-hut-mettupalayam-road-thudiyalur-coimbatore-431523",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "440603",
                      "name": "EatFit - All Things Healthy",
                      "cloudinaryImageId": "6126c9b45de2cb222405c1af8a321e74",
                      "locality": "SRP Nagar",
                      "areaName": "Saibaba Colony",
                      "costForTwo": "₹270 for two",
                      "cuisines": [
                        "Chinese",
                        "Healthy Food",
                        "Tandoor",
                        "Pizzas",
                        "North Indian",
                        "Thalis",
                        "Biryani"
                      ],
                      "avgRating": 4.3,
                      "parentId": "76139",
                      "avgRatingString": "4.3",
                      "totalRatingsString": "1K+",
                      "sla": {
                        "deliveryTime": 35,
                        "lastMileTravel": 9.3,
                        "serviceability": "SERVICEABLE",
                        "slaString": "35 mins",
                        "lastMileTravelString": "9.3 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-12-24 23:59:00",
                        "opened": true
                      },
                      "badges": {
                        "textExtendedBadges": [
                          {
                            "iconId": "guiltfree/GF_Logo_android_3x",
                            "shortDescription": "brand",
                            "fontColor": "#7E808C"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "",
                                  "fontColor": "#7E808C",
                                  "iconId": "guiltfree/GF_Logo_android_3x",
                                  "shortDescription": "brand"
                                }
                              }
                            ]
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "ITEMS",
                        "subHeader": "AT ₹179"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {},
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/eatfit-all-things-healthy-srp-nagar-saibaba-colony-coimbatore-440603",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "61501",
                      "name": "Hyderabad Biriyani Hotel",
                      "cloudinaryImageId": "upaeed1jlrygqaxxuosd",
                      "locality": "Nagapattinam",
                      "areaName": "Kavundampalayam",
                      "costForTwo": "₹200 for two",
                      "cuisines": ["Hyderabadi", "Biryani"],
                      "avgRating": 4.4,
                      "parentId": "4969",
                      "avgRatingString": "4.4",
                      "totalRatingsString": "5K+",
                      "sla": {
                        "deliveryTime": 21,
                        "lastMileTravel": 4.7,
                        "serviceability": "SERVICEABLE",
                        "slaString": "21 mins",
                        "lastMileTravelString": "4.7 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-12-24 21:00:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "aggregatedDiscountInfoV2": {},
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {},
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/hyderabad-biriyani-hotel-nagapattinam-kavundampalayam-coimbatore-61501",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "51024",
                      "name": "CakeBee",
                      "cloudinaryImageId": "65b0afdfd0e1b35d8bd8784d9ad5f265",
                      "locality": "Bharathi Park",
                      "areaName": "Saibaba Colony",
                      "costForTwo": "₹250 for two",
                      "cuisines": ["Bakery", "Continental", "Italian"],
                      "avgRating": 4.5,
                      "parentId": "22417",
                      "avgRatingString": "4.5",
                      "totalRatingsString": "1K+",
                      "sla": {
                        "deliveryTime": 32,
                        "lastMileTravel": 9.4,
                        "serviceability": "SERVICEABLE",
                        "slaString": "32 mins",
                        "lastMileTravelString": "9.4 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-12-25 00:00:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "aggregatedDiscountInfoV2": {},
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {},
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/cakebee-bharathi-park-saibaba-colony-coimbatore-51024",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "60958",
                      "name": "Denmarrk Drive-Inn Restaurant",
                      "cloudinaryImageId": "kotlytcyvkm5c5sl86mk",
                      "locality": "Sathy Road",
                      "areaName": "Ganapathy",
                      "costForTwo": "₹200 for two",
                      "cuisines": [
                        "Tandoor",
                        "North Indian",
                        "Chinese",
                        "Kebabs",
                        "Juices",
                        "Arabian"
                      ],
                      "avgRating": 4.3,
                      "parentId": "4907",
                      "avgRatingString": "4.3",
                      "totalRatingsString": "10K+",
                      "sla": {
                        "deliveryTime": 38,
                        "lastMileTravel": 10.8,
                        "serviceability": "SERVICEABLE",
                        "slaString": "38 mins",
                        "lastMileTravelString": "10.8 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-12-24 23:00:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "₹125 OFF",
                        "subHeader": "ABOVE ₹199",
                        "discountTag": "FLAT DEAL"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {},
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/denmarrk-drive-inn-restaurant-sathy-road-ganapathy-coimbatore-60958",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "676829",
                      "name": "Covai Anganan Biriyani House",
                      "cloudinaryImageId": "375f8d233613b205ab37f42d110edc88",
                      "locality": "sathy road",
                      "areaName": "Coi Ganapathy",
                      "costForTwo": "₹200 for two",
                      "cuisines": [
                        "South Indian",
                        "Biryani",
                        "Andhra",
                        "Desserts"
                      ],
                      "avgRating": 4.1,
                      "parentId": "230662",
                      "avgRatingString": "4.1",
                      "totalRatingsString": "500+",
                      "sla": {
                        "deliveryTime": 39,
                        "lastMileTravel": 11.1,
                        "serviceability": "SERVICEABLE",
                        "slaString": "39 mins",
                        "lastMileTravelString": "11.1 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-12-24 23:00:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "aggregatedDiscountInfoV2": {},
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {},
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/covai-anganan-biriyani-house-sathy-road-coi-ganapathy-coimbatore-676829",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "50457",
                      "name": "Burger King",
                      "cloudinaryImageId": "e33e1d3ba7d6b2bb0d45e1001b731fcf",
                      "locality": "Prozone Mall",
                      "areaName": "Saravanampatti",
                      "costForTwo": "₹350 for two",
                      "cuisines": ["Burgers", "American"],
                      "avgRating": 4.3,
                      "parentId": "166",
                      "avgRatingString": "4.3",
                      "totalRatingsString": "10K+",
                      "sla": {
                        "deliveryTime": 41,
                        "lastMileTravel": 11.6,
                        "serviceability": "SERVICEABLE",
                        "slaString": "41 mins",
                        "lastMileTravelString": "11.6 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-12-25 00:00:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "60% OFF",
                        "subHeader": "UPTO ₹120"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {},
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/burger-king-prozone-mall-saravanampatti-coimbatore-50457",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "654259",
                      "name": "Istah Shawarmas",
                      "cloudinaryImageId": "0a37282845f641a5995d866285767803",
                      "locality": "Dr Rajendra Prasad Road",
                      "areaName": "Gandhipuram",
                      "costForTwo": "₹300 for two",
                      "cuisines": [
                        "Mediterranean",
                        "Snacks",
                        "Biryani",
                        "Grill",
                        "Kebabs",
                        "Arabian",
                        "Lebanese",
                        "Beverages",
                        "Desserts",
                        "Italian",
                        "Turkish"
                      ],
                      "avgRating": 4.2,
                      "parentId": "468195",
                      "avgRatingString": "4.2",
                      "totalRatingsString": "1K+",
                      "sla": {
                        "deliveryTime": 50,
                        "lastMileTravel": 11.1,
                        "serviceability": "SERVICEABLE",
                        "slaString": "50 mins",
                        "lastMileTravelString": "11.1 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-12-24 23:30:00",
                        "opened": true
                      },
                      "badges": {
                        "imageBadges": [
                          {
                            "imageId": "v1690360529/Ratnesh_Badges/Only_on_swiggy_badge_4x.png",
                            "description": "OnlyOnSwiggy"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "OnlyOnSwiggy",
                                  "imageId": "v1690360529/Ratnesh_Badges/Only_on_swiggy_badge_4x.png"
                                }
                              }
                            ]
                          },
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "₹150 OFF",
                        "subHeader": "ABOVE ₹399",
                        "discountTag": "FLAT DEAL"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {},
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/istah-shawarmas-dr-rajendra-prasad-road-gandhipuram-coimbatore-654259",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "654253",
                      "name": "Gobble: Pastas & Burgers",
                      "cloudinaryImageId": "df5118be546e687f45758da0433a1649",
                      "locality": "Ganapathy Village",
                      "areaName": "Gandhipuram",
                      "costForTwo": "₹200 for two",
                      "cuisines": [
                        "Burgers",
                        "Pastas",
                        "American",
                        "Continental",
                        "Snacks"
                      ],
                      "avgRating": 4.2,
                      "parentId": "391931",
                      "avgRatingString": "4.2",
                      "totalRatingsString": "1K+",
                      "sla": {
                        "deliveryTime": 47,
                        "lastMileTravel": 11.1,
                        "serviceability": "SERVICEABLE",
                        "slaString": "47 mins",
                        "lastMileTravelString": "11.1 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-12-24 23:30:00",
                        "opened": true
                      },
                      "badges": {
                        "imageBadges": [
                          {
                            "imageId": "v1690360529/Ratnesh_Badges/Only_on_swiggy_badge_4x.png",
                            "description": "OnlyOnSwiggy"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "OnlyOnSwiggy",
                                  "imageId": "v1690360529/Ratnesh_Badges/Only_on_swiggy_badge_4x.png"
                                }
                              }
                            ]
                          },
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "60% OFF",
                        "subHeader": "UPTO ₹100"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {},
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/gobble-pastas-and-burgers-ganapathy-village-gandhipuram-coimbatore-654253",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "69592",
                      "name": "SK Supercook",
                      "cloudinaryImageId": "iskv0nc46sjc0cskvjup",
                      "locality": "Marudhamalai Road",
                      "areaName": "Vadavalli",
                      "costForTwo": "₹200 for two",
                      "cuisines": ["North Indian"],
                      "avgRating": 4.3,
                      "parentId": "8364",
                      "avgRatingString": "4.3",
                      "totalRatingsString": "10K+",
                      "sla": {
                        "deliveryTime": 43,
                        "lastMileTravel": 11.7,
                        "serviceability": "SERVICEABLE",
                        "slaString": "43 mins",
                        "lastMileTravelString": "11.7 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-12-24 16:00:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "aggregatedDiscountInfoV2": {},
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {},
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/sk-supercook-marudhamalai-road-vadavalli-coimbatore-69592",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "194296",
                      "name": "LunchBox - Meals and Thalis",
                      "cloudinaryImageId": "xrmshencqbjkbamgb2sj",
                      "locality": "Poombugar Nagar Rd",
                      "areaName": "Saravanamapatti Village",
                      "costForTwo": "₹300 for two",
                      "cuisines": [
                        "Biryani",
                        "North Indian",
                        "Punjabi",
                        "Healthy Food",
                        "Desserts",
                        "Beverages"
                      ],
                      "avgRating": 4.5,
                      "parentId": "4925",
                      "avgRatingString": "4.5",
                      "totalRatingsString": "1K+",
                      "sla": {
                        "deliveryTime": 40,
                        "lastMileTravel": 10,
                        "serviceability": "SERVICEABLE",
                        "slaString": "40 mins",
                        "lastMileTravelString": "10.0 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-12-24 23:59:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "ITEMS",
                        "subHeader": "AT ₹159"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {},
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/lunchbox-meals-and-thalis-poombugar-nagar-rd-saravanamapatti-village-coimbatore-194296",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "194273",
                      "name": "Faasos - Wraps, Rolls & Shawarma",
                      "cloudinaryImageId": "af33b81798b11deba338e94b7585d348",
                      "locality": "Poombugar Nagar Rd",
                      "areaName": "Saravanamapatti Village",
                      "costForTwo": "₹500 for two",
                      "cuisines": [
                        "Kebabs",
                        "Fast Food",
                        "Snacks",
                        "North Indian",
                        "American",
                        "Healthy Food",
                        "Desserts",
                        "Beverages"
                      ],
                      "avgRating": 4.4,
                      "parentId": "21809",
                      "avgRatingString": "4.4",
                      "totalRatingsString": "5K+",
                      "sla": {
                        "deliveryTime": 39,
                        "lastMileTravel": 10,
                        "serviceability": "SERVICEABLE",
                        "slaString": "39 mins",
                        "lastMileTravelString": "10.0 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-12-24 23:59:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "₹125 OFF",
                        "subHeader": "ABOVE ₹299",
                        "discountTag": "FLAT DEAL"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {},
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/faasos-wraps-rolls-and-shawarma-poombugar-nagar-rd-saravanamapatti-village-coimbatore-194273",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "51014",
                      "name": "A2B - Adyar Ananda Bhavan",
                      "cloudinaryImageId": "jlqmqtcbgxu3ype0idyq",
                      "locality": "Bharathiyar Road",
                      "areaName": "Gandhipuram",
                      "costForTwo": "₹300 for two",
                      "cuisines": [
                        "South Indian",
                        "North Indian",
                        "Sweets",
                        "Chinese"
                      ],
                      "avgRating": 4.5,
                      "veg": true,
                      "parentId": "22",
                      "avgRatingString": "4.5",
                      "totalRatingsString": "10K+",
                      "sla": {
                        "deliveryTime": 57,
                        "lastMileTravel": 12.1,
                        "serviceability": "SERVICEABLE",
                        "slaString": "57 mins",
                        "lastMileTravelString": "12.1 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-12-24 22:45:00",
                        "opened": true
                      },
                      "badges": {
                        "imageBadges": [
                          {
                            "imageId": "v1690360529/Ratnesh_Badges/Only_on_swiggy_badge_4x.png",
                            "description": "OnlyOnSwiggy"
                          },
                          {
                            "imageId": "v1695133679/badges/Pure_Veg111.png",
                            "description": "pureveg"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "OnlyOnSwiggy",
                                  "imageId": "v1690360529/Ratnesh_Badges/Only_on_swiggy_badge_4x.png"
                                }
                              },
                              {
                                "attributes": {
                                  "description": "pureveg",
                                  "imageId": "v1695133679/badges/Pure_Veg111.png"
                                }
                              }
                            ]
                          },
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "₹125 OFF",
                        "subHeader": "ABOVE ₹199",
                        "discountTag": "FLAT DEAL"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {},
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/a2b-adyar-ananda-bhavan-bharathiyar-road-gandhipuram-coimbatore-51014",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "50374",
                      "name": "Dindigul Thalappakatti",
                      "cloudinaryImageId": "zf7sbwdhivqxkkz0irs3",
                      "locality": "Ram Nagar",
                      "areaName": "Ram Nagar",
                      "costForTwo": "₹400 for two",
                      "cuisines": [
                        "Biryani",
                        "Barbecue",
                        "South Indian",
                        "Chinese"
                      ],
                      "avgRating": 4.2,
                      "parentId": "332",
                      "avgRatingString": "4.2",
                      "totalRatingsString": "5K+",
                      "sla": {
                        "deliveryTime": 43,
                        "lastMileTravel": 10.9,
                        "serviceability": "SERVICEABLE",
                        "slaString": "43 mins",
                        "lastMileTravelString": "10.9 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-12-25 01:00:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "aggregatedDiscountInfoV2": {},
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {},
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/dindigul-thalappakatti-ram-nagar-coimbatore-50374",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "194294",
                      "name": "The Good Bowl",
                      "cloudinaryImageId": "6e04be27387483a7c00444f8e8241108",
                      "locality": "Poombugar Nagar Rd",
                      "areaName": "Saravanamapatti Village",
                      "costForTwo": "₹400 for two",
                      "cuisines": [
                        "Biryani",
                        "North Indian",
                        "Pastas",
                        "Punjabi",
                        "Desserts",
                        "Beverages"
                      ],
                      "avgRating": 4.3,
                      "parentId": "7918",
                      "avgRatingString": "4.3",
                      "totalRatingsString": "1K+",
                      "sla": {
                        "deliveryTime": 37,
                        "lastMileTravel": 10,
                        "serviceability": "SERVICEABLE",
                        "slaString": "37 mins",
                        "lastMileTravelString": "10.0 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-12-24 23:59:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "₹175 OFF",
                        "subHeader": "ABOVE ₹799",
                        "discountTag": "FLAT DEAL"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {},
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/the-good-bowl-poombugar-nagar-rd-saravanamapatti-village-coimbatore-194294",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "56505",
                      "name": "McDonald's",
                      "cloudinaryImageId": "bb7ae131544c7d37e10fc5faf76f09d6",
                      "locality": "Prozone Mall",
                      "areaName": "Ganapathy",
                      "costForTwo": "₹400 for two",
                      "cuisines": ["Burgers", "Beverages", "Cafe", "Desserts"],
                      "avgRating": 4.3,
                      "parentId": "630",
                      "avgRatingString": "4.3",
                      "totalRatingsString": "5K+",
                      "sla": {
                        "deliveryTime": 39,
                        "lastMileTravel": 11.6,
                        "serviceability": "SERVICEABLE",
                        "slaString": "39 mins",
                        "lastMileTravelString": "11.6 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-12-24 21:45:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "aggregatedDiscountInfoV2": {},
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {},
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/mcdonalds-prozone-mall-ganapathy-coimbatore-56505",
                      "type": "WEBLINK"
                    }
                  }
                ],
                "theme": "Restaurant_Group_WebView_SEO_PB_Theme",
                "widgetType": "WIDGET_TYPE_POPULAR_BRANDS",
                "style": {
                  "width": {
                    "type": "TYPE_RELATIVE",
                    "value": 0.41111112,
                    "reference": "RELATIVE_DIMENSION_REFERENCE_DEVICE_WIDTH"
                  },
                  "height": {
                    "type": "TYPE_RELATIVE",
                    "value": 0.7027027,
                    "reference": "RELATIVE_DIMENSION_REFERENCE_WIDTH"
                  },
                  "layoutAlignment": "LAYOUT_ALIGNMENT_LEFT"
                },
                "collectionId": "84124"
              }
            }
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.seo.widgets.v1.BasicContent",
            "title": "Restaurants with online food delivery in Coimbatore",
            "id": "popular_restaurants_title"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.InlineViewFilterSortWidget",
            "sortConfigs": [
              {
                "key": "relevance",
                "title": "Relevance (Default)",
                "selected": true,
                "defaultSelection": true
              },
              {
                "key": "deliveryTimeAsc",
                "title": "Delivery Time"
              },
              {
                "key": "modelBasedRatingDesc",
                "title": "Rating"
              },
              {
                "key": "costForTwoAsc",
                "title": "Cost: Low to High"
              },
              {
                "key": "costForTwoDesc",
                "title": "Cost: High to Low"
              }
            ],
            "restaurantCount": 829,
            "facetList": [
              {
                "label": "Delivery Time",
                "id": "deliveryTime",
                "selection": "SELECT_TYPE_MULTISELECT",
                "facetInfo": [
                  {
                    "label": "Fast Delivery",
                    "id": "deliveryTimefacetquery1",
                    "analytics": {},
                    "openFilter": true
                  }
                ],
                "viewType": "VIEW_TYPE_HALF_CARD",
                "subLabel": "Filter by"
              },
              {
                "label": "Cuisines",
                "id": "catalog_cuisines",
                "selection": "SELECT_TYPE_MULTISELECT",
                "facetInfo": [
                  {
                    "label": "American",
                    "id": "query_american",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Andhra",
                    "id": "query_andhra",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Arabian",
                    "id": "query_arabian",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Asian",
                    "id": "query_asian",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Bakery",
                    "id": "query_bakery",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Barbecue",
                    "id": "query_barbecue",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Bengali",
                    "id": "query_bengali",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Beverages",
                    "id": "query_beverages",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Biryani",
                    "id": "query_biryani",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Burgers",
                    "id": "query_burgers",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Burmese",
                    "id": "query_burmese",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Cafe",
                    "id": "query_cafe",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Chaat",
                    "id": "query_chaat",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Chettinad",
                    "id": "query_chettinad",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Chinese",
                    "id": "query_chinese",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Combo",
                    "id": "query_combo",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Continental",
                    "id": "query_continental",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Desserts",
                    "id": "query_desserts",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "European",
                    "id": "query_european",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Fast Food",
                    "id": "query_fast_food",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Grill",
                    "id": "query_grill",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Gujarati",
                    "id": "query_gujarati",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Haleem",
                    "id": "query_haleem",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Healthy Food",
                    "id": "query_healthy_food",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Home Food",
                    "id": "query_home_food",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Hyderabadi",
                    "id": "query_hyderabadi",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Ice Cream",
                    "id": "query_ice_cream",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Ice Cream Cakes",
                    "id": "query_ice_cream_cakes",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Indian",
                    "id": "query_indian",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Italian",
                    "id": "query_italian",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Italian-American",
                    "id": "query_italian-american",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Jain",
                    "id": "query_jain",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Juices",
                    "id": "query_juices",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Kebabs",
                    "id": "query_kebabs",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Kerala",
                    "id": "query_kerala",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Lebanese",
                    "id": "query_lebanese",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Limited Stocks",
                    "id": "query_limited_stocks",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Lucknowi",
                    "id": "query_lucknowi",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Maharashtrian",
                    "id": "query_maharashtrian",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Mangalorean",
                    "id": "query_mangalorean",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Mediterranean",
                    "id": "query_mediterranean",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Mexican",
                    "id": "query_mexican",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Mughlai",
                    "id": "query_mughlai",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "North Indian",
                    "id": "query_north_indian",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Paan",
                    "id": "query_paan",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Pan-Asian",
                    "id": "query_pan-asian",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Pastas",
                    "id": "query_pastas",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Pizzas",
                    "id": "query_pizzas",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Punjabi",
                    "id": "query_punjabi",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Rajasthani",
                    "id": "query_rajasthani",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Rolls & Wraps",
                    "id": "query_rolls_&_wraps",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Salads",
                    "id": "query_salads",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Seafood",
                    "id": "query_seafood",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Snacks",
                    "id": "query_snacks",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "South Indian",
                    "id": "query_south_indian",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Street Food",
                    "id": "query_street_food",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Sweets",
                    "id": "query_sweets",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Tandoor",
                    "id": "query_tandoor",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Thalis",
                    "id": "query_thalis",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Tibetan",
                    "id": "query_tibetan",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Turkish",
                    "id": "query_turkish",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Waffle",
                    "id": "query_waffle",
                    "analytics": {},
                    "openFilter": true
                  }
                ],
                "viewType": "VIEW_TYPE_HALF_CARD",
                "canSearch": true,
                "subLabel": "Filter by cuisine",
                "openFilter": true
              },
              {
                "label": "Explore",
                "id": "explore",
                "selection": "SELECT_TYPE_MULTISELECT",
                "facetInfo": [
                  {
                    "label": "New on Swiggy",
                    "id": "newfacetquery1",
                    "analytics": {},
                    "openFilter": true
                  }
                ],
                "viewType": "VIEW_TYPE_HALF_CARD"
              },
              {
                "label": "Ratings",
                "id": "rating",
                "selection": "SELECT_TYPE_MULTISELECT",
                "facetInfo": [
                  {
                    "label": "Ratings 4.5+",
                    "id": "ratingfacetquery3",
                    "analytics": {}
                  },
                  {
                    "label": "Ratings 4.0+",
                    "id": "ratingfacetquery4",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Ratings 3.5+",
                    "id": "ratingfacetquery5",
                    "analytics": {}
                  }
                ],
                "viewType": "VIEW_TYPE_HALF_CARD",
                "subLabel": "Filter by"
              },
              {
                "label": "Veg/Non-Veg",
                "id": "isVeg",
                "selection": "SELECT_TYPE_SINGLESELECT",
                "facetInfo": [
                  {
                    "label": "Pure Veg",
                    "id": "isVegfacetquery2",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Non Veg",
                    "id": "isVegfacetquery3",
                    "analytics": {}
                  }
                ],
                "viewType": "VIEW_TYPE_FLATTENED",
                "subLabel": "Filter by"
              },
              {
                "label": "Offers",
                "id": "restaurantOfferMultiTd",
                "selection": "SELECT_TYPE_SINGLESELECT",
                "facetInfo": [
                  {
                    "label": "Offers",
                    "id": "restaurantOfferMultiTdfacetquery3",
                    "analytics": {},
                    "openFilter": true
                  }
                ],
                "viewType": "VIEW_TYPE_FLATTENED",
                "subLabel": "Restaurants with"
              },
              {
                "label": "Cost for two",
                "id": "costForTwo",
                "selection": "SELECT_TYPE_MULTISELECT",
                "facetInfo": [
                  {
                    "label": "Rs. 300-Rs. 600",
                    "id": "costForTwofacetquery3",
                    "analytics": {},
                    "openFilter": true
                  },
                  {
                    "label": "Greater than Rs. 600",
                    "id": "costForTwofacetquery4",
                    "analytics": {}
                  },
                  {
                    "label": "Less than Rs. 300",
                    "id": "costForTwofacetquery5",
                    "analytics": {},
                    "openFilter": true
                  }
                ],
                "viewType": "VIEW_TYPE_HALF_CARD",
                "subLabel": "Filter by"
              }
            ]
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "layout": {
              "columns": 4
            },
            "id": "restaurant_grid_listing",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.FavouriteRestaurantInfoWithStyle",
                "restaurants": [
                  {
                    "info": {
                      "id": "65609",
                      "name": "Ravuthar Biriyani Hotel",
                      "cloudinaryImageId": "h1opsucvsj0ciculk5mr",
                      "locality": "Vimal Complex Bus Stand",
                      "areaName": "Thudiyalur",
                      "costForTwo": "₹200 for two",
                      "cuisines": ["Biryani"],
                      "avgRating": 4.3,
                      "parentId": "18400",
                      "avgRatingString": "4.3",
                      "totalRatingsString": "10K+",
                      "sla": {
                        "deliveryTime": 15,
                        "lastMileTravel": 2.5,
                        "serviceability": "SERVICEABLE",
                        "slaString": "15 mins",
                        "lastMileTravelString": "2.5 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-12-24 23:00:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "₹125 OFF",
                        "subHeader": "ABOVE ₹199",
                        "discountTag": "FLAT DEAL"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-887ce4ba-440e-42a4-91d5-727f4138ecc7"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/ravuthar-biriyani-hotel-vimal-complex-bus-stand-thudiyalur-coimbatore-65609",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "75479",
                      "name": "Hotel Sathar Rowther",
                      "cloudinaryImageId": "nrt2ciafcuhcqi2jximw",
                      "locality": "Mtp Road",
                      "areaName": "Thudiyalur",
                      "costForTwo": "₹200 for two",
                      "cuisines": ["North Indian", "South Indian"],
                      "avgRating": 4.3,
                      "parentId": "12037",
                      "avgRatingString": "4.3",
                      "totalRatingsString": "10K+",
                      "sla": {
                        "deliveryTime": 17,
                        "lastMileTravel": 2.5,
                        "serviceability": "SERVICEABLE",
                        "slaString": "17 mins",
                        "lastMileTravelString": "2.5 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-12-24 23:00:00",
                        "opened": true
                      },
                      "badges": {
                        "textExtendedBadges": [
                          {
                            "iconId": "guiltfree/GF_Logo_android_3x",
                            "shortDescription": "options available",
                            "fontColor": "#7E808C"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "",
                                  "fontColor": "#7E808C",
                                  "iconId": "guiltfree/GF_Logo_android_3x",
                                  "shortDescription": "options available"
                                }
                              }
                            ]
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "15% OFF",
                        "subHeader": "UPTO ₹45"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-887ce4ba-440e-42a4-91d5-727f4138ecc7"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/hotel-sathar-rowther-mtp-road-thudiyalur-coimbatore-75479",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "709343",
                      "name": "Nagerkovil Arya Bhavan",
                      "cloudinaryImageId": "609f28d1cd1ef94d1eb6d7788bc4e566",
                      "locality": "Peelamedu",
                      "areaName": "Koundampalayam",
                      "costForTwo": "₹250 for two",
                      "cuisines": [
                        "Chinese",
                        "South Indian",
                        "Beverages",
                        "Biryani"
                      ],
                      "avgRating": 4.6,
                      "veg": true,
                      "parentId": "353249",
                      "avgRatingString": "4.6",
                      "totalRatingsString": "1K+",
                      "sla": {
                        "deliveryTime": 24,
                        "lastMileTravel": 5.6,
                        "serviceability": "SERVICEABLE",
                        "slaString": "24 mins",
                        "lastMileTravelString": "5.6 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-12-24 22:40:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "₹125 OFF",
                        "subHeader": "ABOVE ₹199",
                        "discountTag": "FLAT DEAL"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-887ce4ba-440e-42a4-91d5-727f4138ecc7"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/nagerkovil-arya-bhavan-peelamedu-koundampalayam-coimbatore-709343",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "413575",
                      "name": "Sri Sai Amuthaas (Veg)",
                      "cloudinaryImageId": "5f18dd695041e0ba1e8ee09811030674",
                      "locality": "Mettupalayam Road",
                      "areaName": "Thudiyalur",
                      "costForTwo": "₹100 for two",
                      "cuisines": [
                        "South Indian",
                        "North Indian",
                        "Chinese",
                        "Beverages"
                      ],
                      "avgRating": 4.5,
                      "veg": true,
                      "parentId": "454172",
                      "avgRatingString": "4.5",
                      "totalRatingsString": "1K+",
                      "sla": {
                        "deliveryTime": 15,
                        "lastMileTravel": 1,
                        "serviceability": "SERVICEABLE",
                        "slaString": "15 mins",
                        "lastMileTravelString": "1.0 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-12-24 22:20:00",
                        "opened": true
                      },
                      "badges": {
                        "textExtendedBadges": [
                          {
                            "iconId": "guiltfree/GF_Logo_android_3x",
                            "shortDescription": "options available",
                            "fontColor": "#7E808C"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "",
                                  "fontColor": "#7E808C",
                                  "iconId": "guiltfree/GF_Logo_android_3x",
                                  "shortDescription": "options available"
                                }
                              }
                            ]
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "₹125 OFF",
                        "subHeader": "ABOVE ₹199",
                        "discountTag": "FLAT DEAL"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-887ce4ba-440e-42a4-91d5-727f4138ecc7"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/sri-sai-amuthaas-veg-mettupalayam-road-thudiyalur-coimbatore-413575",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "740700",
                      "name": "Ammayi Veedu Pot Cook",
                      "cloudinaryImageId": "21b14e6c22678db398d9b9e5d0f937ac",
                      "locality": "Sathy Main Road",
                      "areaName": "Saravanampatti",
                      "costForTwo": "₹300 for two",
                      "cuisines": [
                        "South Indian",
                        "Chinese",
                        "Biryani",
                        "Snacks"
                      ],
                      "avgRating": 4.4,
                      "parentId": "12505",
                      "avgRatingString": "4.4",
                      "totalRatingsString": "100+",
                      "sla": {
                        "deliveryTime": 29,
                        "lastMileTravel": 9.9,
                        "serviceability": "SERVICEABLE",
                        "slaString": "29 mins",
                        "lastMileTravelString": "9.9 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-12-24 23:00:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "aggregatedDiscountInfoV2": {},
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "isNewlyOnboarded": true,
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-887ce4ba-440e-42a4-91d5-727f4138ecc7"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/ammayi-veedu-pot-cook-sathy-main-road-saravanampatti-coimbatore-740700",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "405679",
                      "name": "SS Hyderabad Briyani",
                      "cloudinaryImageId": "asbyjuhrwvofb89kdold",
                      "locality": "Dr. Rajendra Prasad Road",
                      "areaName": "Gandhipuram",
                      "costForTwo": "₹600 for two",
                      "cuisines": ["Biryani", "South Indian", "Seafood"],
                      "avgRating": 4.6,
                      "parentId": "4824",
                      "avgRatingString": "4.6",
                      "totalRatingsString": "10K+",
                      "sla": {
                        "deliveryTime": 36,
                        "lastMileTravel": 10.4,
                        "serviceability": "SERVICEABLE",
                        "slaString": "36 mins",
                        "lastMileTravelString": "10.4 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-12-24 23:00:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "₹125 OFF",
                        "subHeader": "ABOVE ₹199",
                        "discountTag": "FLAT DEAL"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-887ce4ba-440e-42a4-91d5-727f4138ecc7"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/ss-hyderabad-briyani-dr-rajendra-prasad-road-gandhipuram-coimbatore-405679",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "449314",
                      "name": "Vintage Home",
                      "cloudinaryImageId": "e9ef719ce266c34889e5ab0adbc09bda",
                      "locality": "Kumaran Mills",
                      "areaName": "Periyanaikanpalayam",
                      "costForTwo": "₹200 for two",
                      "cuisines": [
                        "Biryani",
                        "Chettinad",
                        "South Indian",
                        "Limited Stocks",
                        "Indian",
                        "Grill",
                        "Tandoor",
                        "Barbecue",
                        "Chinese",
                        "Juices"
                      ],
                      "avgRating": 3.9,
                      "parentId": "270367",
                      "avgRatingString": "3.9",
                      "totalRatingsString": "1K+",
                      "sla": {
                        "deliveryTime": 20,
                        "lastMileTravel": 1.2,
                        "serviceability": "SERVICEABLE",
                        "slaString": "20 mins",
                        "lastMileTravelString": "1.2 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-12-24 23:00:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "50% OFF",
                        "subHeader": "UPTO ₹100"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-887ce4ba-440e-42a4-91d5-727f4138ecc7"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/vintage-home-kumaran-mills-periyanaikanpalayam-coimbatore-449314",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "604228",
                      "name": "Big Bowl",
                      "cloudinaryImageId": "c99751d54e4e1847186c62b3309c1327",
                      "locality": "P&T Colony Road",
                      "areaName": "Sivanadha Colony",
                      "costForTwo": "₹250 for two",
                      "cuisines": [
                        "North Indian",
                        "Chinese",
                        "Tibetan",
                        "Desserts"
                      ],
                      "avgRating": 4.2,
                      "parentId": "434792",
                      "avgRatingString": "4.2",
                      "totalRatingsString": "500+",
                      "sla": {
                        "deliveryTime": 35,
                        "lastMileTravel": 8.4,
                        "serviceability": "SERVICEABLE",
                        "slaString": "35 mins",
                        "lastMileTravelString": "8.4 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-12-25 02:00:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "ITEMS",
                        "subHeader": "AT ₹169"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-887ce4ba-440e-42a4-91d5-727f4138ecc7"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/big-bowl-p-and-t-colony-road-sivanadha-colony-coimbatore-604228",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "440610",
                      "name": "Great Indian Khichdi by EatFit",
                      "cloudinaryImageId": "6e44fd7f1e5cd9967edfe47c10247671",
                      "locality": "SRP Nagar II",
                      "areaName": "Saibaba Colony",
                      "costForTwo": "₹200 for two",
                      "cuisines": [
                        "Home Food",
                        "Indian",
                        "North Indian",
                        "Healthy Food",
                        "Snacks",
                        "Desserts",
                        "Rajasthani",
                        "South Indian",
                        "Maharashtrian",
                        "Sweets"
                      ],
                      "avgRating": 4.2,
                      "veg": true,
                      "parentId": "319582",
                      "avgRatingString": "4.2",
                      "totalRatingsString": "500+",
                      "sla": {
                        "deliveryTime": 34,
                        "lastMileTravel": 9.3,
                        "serviceability": "SERVICEABLE",
                        "slaString": "34 mins",
                        "lastMileTravelString": "9.3 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2023-12-24 23:59:00",
                        "opened": true
                      },
                      "badges": {
                        "imageBadges": [
                          {
                            "imageId": "v1695133679/badges/Pure_Veg111.png",
                            "description": "pureveg"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "pureveg",
                                  "imageId": "v1695133679/badges/Pure_Veg111.png"
                                }
                              }
                            ]
                          },
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "ITEMS",
                        "subHeader": "AT ₹159"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-887ce4ba-440e-42a4-91d5-727f4138ecc7"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/great-indian-khichdi-by-eatfit-srp-nagar-ii-saibaba-colony-coimbatore-440610",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "194280",
                      "name": "Oven Story Pizza - Standout Toppings",
                      "cloudinaryImageId": "b39e4312ae2e9f65c3b58faaed83f488",
                      "locality": "Poombugar Nagar Rd",
                      "areaName": "Saravanamapatti Village",
                      "costForTwo": "₹400 for two",
                      "cuisines": [
                        "Pizzas",
                        "Pastas",
                        "Italian",
                        "Desserts",
                        "Beverages"
                      ],
                      "avgRating": 4.3,
                      "parentId": "3534",
                      "avgRatingString": "4.3",
                      "totalRatingsString": "1K+",
                      "sla": {
                        "deliveryTime": 44,
                        "lastMileTravel": 10,
                        "serviceability": "SERVICEABLE",
                        "slaString": "44 mins",
                        "lastMileTravelString": "10.0 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-06 23:59:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "₹125 OFF",
                        "subHeader": "ABOVE ₹299",
                        "discountTag": "FLAT DEAL"
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/oven-story-pizza-standout-toppings-poombugar-nagar-rd-saravanamapatti-village-coimbatore-194280",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "405679",
                      "name": "SS Hyderabad Briyani",
                      "cloudinaryImageId": "asbyjuhrwvofb89kdold",
                      "locality": "Dr. Rajendra Prasad Road",
                      "areaName": "Gandhipuram",
                      "costForTwo": "₹600 for two",
                      "cuisines": ["Biryani", "South Indian", "Seafood"],
                      "avgRating": 4.6,
                      "parentId": "4824",
                      "avgRatingString": "4.6",
                      "totalRatingsString": "10K+",
                      "sla": {
                        "deliveryTime": 38,
                        "lastMileTravel": 10.4,
                        "serviceability": "SERVICEABLE",
                        "slaString": "38 mins",
                        "lastMileTravelString": "10.4 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-06 23:00:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "₹100 OFF",
                        "subHeader": "ABOVE ₹349",
                        "discountTag": "FLAT DEAL"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/ss-hyderabad-briyani-dr-rajendra-prasad-road-gandhipuram-coimbatore-405679",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "225166",
                      "name": "Kwality Walls Frozen Dessert and Ice Cream Shop",
                      "cloudinaryImageId": "wranvdl9x5t52l0tx7vz",
                      "locality": "Mettupalayam Road",
                      "areaName": "Thudiyalur",
                      "costForTwo": "₹150 for two",
                      "cuisines": ["Desserts", "Ice Cream", "Ice Cream Cakes"],
                      "avgRating": 4.6,
                      "veg": true,
                      "parentId": "582",
                      "avgRatingString": "4.6",
                      "totalRatingsString": "1K+",
                      "sla": {
                        "deliveryTime": 23,
                        "lastMileTravel": 2.6,
                        "serviceability": "SERVICEABLE",
                        "slaString": "23 mins",
                        "lastMileTravelString": "2.6 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-06 23:00:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "50% OFF",
                        "subHeader": "UPTO ₹100"
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/kwality-walls-frozen-dessert-and-ice-cream-shop-mettupalayam-road-thudiyalur-coimbatore-225166",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "130193",
                      "name": "Domino's Pizza",
                      "cloudinaryImageId": "nwlbdiasm74wahpifhye",
                      "locality": "Sreevatsa Garden",
                      "areaName": "Thudiyalur",
                      "costForTwo": "₹400 for two",
                      "cuisines": ["Pizzas", "Italian", "Pastas", "Desserts"],
                      "avgRating": 4.5,
                      "parentId": "2456",
                      "avgRatingString": "4.5",
                      "totalRatingsString": "5K+",
                      "sla": {
                        "deliveryTime": 25,
                        "serviceability": "SERVICEABLE",
                        "slaString": "25 mins",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-06 22:59:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "30% OFF",
                        "subHeader": "UPTO ₹75"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/dominos-pizza-sreevatsa-garden-thudiyalur-coimbatore-130193",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "63639",
                      "name": "Polar Bear",
                      "cloudinaryImageId": "57262fe3839f0bff174f3d7e7cc8a2b4",
                      "locality": "Mettupalayam Road",
                      "areaName": "Thudiyalur",
                      "costForTwo": "₹200 for two",
                      "cuisines": ["Desserts"],
                      "avgRating": 4.7,
                      "veg": true,
                      "parentId": "726",
                      "avgRatingString": "4.7",
                      "totalRatingsString": "1K+",
                      "sla": {
                        "deliveryTime": 28,
                        "lastMileTravel": 3,
                        "serviceability": "SERVICEABLE",
                        "slaString": "28 mins",
                        "lastMileTravelString": "3.0 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-06 23:00:00",
                        "opened": true
                      },
                      "badges": {
                        "imageBadges": [
                          {
                            "imageId": "v1695133679/badges/Pure_Veg111.png",
                            "description": "pureveg"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "pureveg",
                                  "imageId": "v1695133679/badges/Pure_Veg111.png"
                                }
                              }
                            ]
                          },
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/polar-bear-mettupalayam-road-thudiyalur-coimbatore-63639",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "194294",
                      "name": "The Good Bowl",
                      "cloudinaryImageId": "6e04be27387483a7c00444f8e8241108",
                      "locality": "Poombugar Nagar Rd",
                      "areaName": "Saravanamapatti Village",
                      "costForTwo": "₹400 for two",
                      "cuisines": [
                        "Biryani",
                        "North Indian",
                        "Pastas",
                        "Punjabi",
                        "Desserts",
                        "Beverages"
                      ],
                      "avgRating": 4.4,
                      "parentId": "7918",
                      "avgRatingString": "4.4",
                      "totalRatingsString": "1K+",
                      "sla": {
                        "deliveryTime": 39,
                        "lastMileTravel": 10,
                        "serviceability": "SERVICEABLE",
                        "slaString": "39 mins",
                        "lastMileTravelString": "10.0 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-06 23:59:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "₹125 OFF",
                        "subHeader": "ABOVE ₹399",
                        "discountTag": "FLAT DEAL"
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/the-good-bowl-poombugar-nagar-rd-saravanamapatti-village-coimbatore-194294",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "440603",
                      "name": "EatFit - All Things Healthy",
                      "cloudinaryImageId": "6126c9b45de2cb222405c1af8a321e74",
                      "locality": "SRP Nagar",
                      "areaName": "Saibaba Colony",
                      "costForTwo": "₹270 for two",
                      "cuisines": [
                        "Chinese",
                        "Healthy Food",
                        "Tandoor",
                        "Pizzas",
                        "North Indian",
                        "Thalis",
                        "Biryani"
                      ],
                      "avgRating": 4.3,
                      "parentId": "76139",
                      "avgRatingString": "4.3",
                      "totalRatingsString": "1K+",
                      "sla": {
                        "deliveryTime": 42,
                        "lastMileTravel": 9.3,
                        "serviceability": "SERVICEABLE",
                        "slaString": "42 mins",
                        "lastMileTravelString": "9.3 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-06 23:59:00",
                        "opened": true
                      },
                      "badges": {
                        "textExtendedBadges": [
                          {
                            "iconId": "guiltfree/GF_Logo_android_3x",
                            "shortDescription": "brand",
                            "fontColor": "#7E808C"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "",
                                  "fontColor": "#7E808C",
                                  "iconId": "guiltfree/GF_Logo_android_3x",
                                  "shortDescription": "brand"
                                }
                              }
                            ]
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "₹150 OFF",
                        "subHeader": "ABOVE ₹499",
                        "discountTag": "FLAT DEAL"
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/eatfit-all-things-healthy-srp-nagar-saibaba-colony-coimbatore-440603",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "537056",
                      "name": "Baskin Robbins - Ice Cream Desserts",
                      "cloudinaryImageId": "85ccae4e3576f9330af102c46ca85395",
                      "locality": "Bharathi Park",
                      "areaName": "Saibaba Colony",
                      "costForTwo": "₹250 for two",
                      "cuisines": ["Desserts", "Ice Cream"],
                      "avgRating": 4.6,
                      "veg": true,
                      "parentId": "5588",
                      "avgRatingString": "4.6",
                      "totalRatingsString": "100+",
                      "sla": {
                        "deliveryTime": 39,
                        "lastMileTravel": 9.8,
                        "serviceability": "SERVICEABLE",
                        "slaString": "39 mins",
                        "lastMileTravelString": "9.8 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-06 23:00:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "10% OFF",
                        "subHeader": "ABOVE ₹1000",
                        "discountTag": "FLAT DEAL"
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/baskin-robbins-ice-cream-desserts-bharathi-park-saibaba-colony-coimbatore-537056",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "569819",
                      "name": "Hotel Sri Amuthaas",
                      "cloudinaryImageId": "wd52y7oulnzfsjrgism9",
                      "locality": "Mettupalyam Road",
                      "areaName": "Periyanaikanpalayam",
                      "costForTwo": "₹200 for two",
                      "cuisines": [
                        "South Indian",
                        "North Indian",
                        "Chinese",
                        "Juices",
                        "Beverages"
                      ],
                      "avgRating": 4.3,
                      "veg": true,
                      "parentId": "300280",
                      "avgRatingString": "4.3",
                      "totalRatingsString": "100+",
                      "sla": {
                        "deliveryTime": 29,
                        "lastMileTravel": 2.1,
                        "serviceability": "SERVICEABLE",
                        "slaString": "29 mins",
                        "lastMileTravelString": "2.1 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-06 22:30:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "₹125 OFF",
                        "subHeader": "ABOVE ₹249",
                        "discountTag": "FLAT DEAL"
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/hotel-sri-amuthaas-mettupalyam-road-periyanaikanpalayam-coimbatore-569819",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "57943",
                      "name": "Ragam Cake Shop",
                      "cloudinaryImageId": "usrvlttot0ztusqr1xmc",
                      "locality": "Cheran Colony",
                      "areaName": "Thudiyalur",
                      "costForTwo": "₹150 for two",
                      "cuisines": ["Desserts"],
                      "avgRating": 4.4,
                      "parentId": "5067",
                      "avgRatingString": "4.4",
                      "totalRatingsString": "1K+",
                      "sla": {
                        "deliveryTime": 22,
                        "lastMileTravel": 2.4,
                        "serviceability": "SERVICEABLE",
                        "slaString": "22 mins",
                        "lastMileTravelString": "2.4 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-06 22:00:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/ragam-cake-shop-cheran-colony-thudiyalur-coimbatore-57943",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "614321",
                      "name": "Subway",
                      "cloudinaryImageId": "1ace5fa65eff3e1223feb696c956b38b",
                      "locality": "Bharathi Park Road",
                      "areaName": "Saibaba Colony",
                      "costForTwo": "₹350 for two",
                      "cuisines": ["Salads", "Snacks", "Desserts", "Beverages"],
                      "avgRating": 4.3,
                      "parentId": "2",
                      "avgRatingString": "4.3",
                      "totalRatingsString": "1K+",
                      "sla": {
                        "deliveryTime": 47,
                        "lastMileTravel": 10.2,
                        "serviceability": "SERVICEABLE",
                        "slaString": "47 mins",
                        "lastMileTravelString": "10.2 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-07 01:00:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "₹100 OFF",
                        "subHeader": "ABOVE ₹599",
                        "discountTag": "FLAT DEAL"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/subway-bharathi-park-road-saibaba-colony-coimbatore-614321",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "605079",
                      "name": "Sri Krishna Sweets",
                      "cloudinaryImageId": "35e32a75524a100c411bd7b6693d8b74",
                      "areaName": "Thudiyalur",
                      "costForTwo": "₹300 for two",
                      "cuisines": [
                        "Sweets",
                        "Snacks",
                        "South Indian",
                        "Indian"
                      ],
                      "avgRating": 4.7,
                      "veg": true,
                      "parentId": "193908",
                      "avgRatingString": "4.7",
                      "totalRatingsString": "100+",
                      "sla": {
                        "deliveryTime": 23,
                        "lastMileTravel": 2.5,
                        "serviceability": "SERVICEABLE",
                        "slaString": "23 mins",
                        "lastMileTravelString": "2.5 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-06 22:00:00",
                        "opened": true
                      },
                      "badges": {
                        "imageBadges": [
                          {
                            "imageId": "v1695133679/badges/Pure_Veg111.png",
                            "description": "pureveg"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "pureveg",
                                  "imageId": "v1695133679/badges/Pure_Veg111.png"
                                }
                              }
                            ]
                          },
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/sri-krishna-sweets-thudiyalur-coimbatore-605079",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "709343",
                      "name": "Nagerkovil Arya Bhavan",
                      "cloudinaryImageId": "609f28d1cd1ef94d1eb6d7788bc4e566",
                      "locality": "Peelamedu",
                      "areaName": "Koundampalayam",
                      "costForTwo": "₹250 for two",
                      "cuisines": [
                        "Chinese",
                        "South Indian",
                        "Beverages",
                        "Biryani"
                      ],
                      "avgRating": 4.6,
                      "veg": true,
                      "parentId": "353249",
                      "avgRatingString": "4.6",
                      "totalRatingsString": "1K+",
                      "sla": {
                        "deliveryTime": 33,
                        "lastMileTravel": 5.6,
                        "serviceability": "SERVICEABLE",
                        "slaString": "33 mins",
                        "lastMileTravelString": "5.6 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-06 22:40:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/nagerkovil-arya-bhavan-peelamedu-koundampalayam-coimbatore-709343",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "740700",
                      "name": "Ammayi Veedu Pot Cook",
                      "cloudinaryImageId": "21b14e6c22678db398d9b9e5d0f937ac",
                      "locality": "Sathy Main Road",
                      "areaName": "Saravanampatti",
                      "costForTwo": "₹300 for two",
                      "cuisines": [
                        "South Indian",
                        "Chinese",
                        "Biryani",
                        "Snacks"
                      ],
                      "avgRating": 4.4,
                      "parentId": "12505",
                      "avgRatingString": "4.4",
                      "totalRatingsString": "100+",
                      "sla": {
                        "deliveryTime": 35,
                        "lastMileTravel": 9.9,
                        "serviceability": "SERVICEABLE",
                        "slaString": "35 mins",
                        "lastMileTravelString": "9.9 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-06 23:00:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "isNewlyOnboarded": true,
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/ammayi-veedu-pot-cook-sathy-main-road-saravanampatti-coimbatore-740700",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "440610",
                      "name": "Great Indian Khichdi by EatFit",
                      "cloudinaryImageId": "6e44fd7f1e5cd9967edfe47c10247671",
                      "locality": "SRP Nagar II",
                      "areaName": "Saibaba Colony",
                      "costForTwo": "₹200 for two",
                      "cuisines": [
                        "Home Food",
                        "Indian",
                        "North Indian",
                        "Healthy Food",
                        "Snacks",
                        "Desserts",
                        "Rajasthani",
                        "South Indian",
                        "Maharashtrian",
                        "Sweets"
                      ],
                      "avgRating": 4.3,
                      "veg": true,
                      "parentId": "319582",
                      "avgRatingString": "4.3",
                      "totalRatingsString": "500+",
                      "sla": {
                        "deliveryTime": 41,
                        "lastMileTravel": 9.3,
                        "serviceability": "SERVICEABLE",
                        "slaString": "41 mins",
                        "lastMileTravelString": "9.3 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-06 23:59:00",
                        "opened": true
                      },
                      "badges": {
                        "imageBadges": [
                          {
                            "imageId": "v1695133679/badges/Pure_Veg111.png",
                            "description": "pureveg"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "pureveg",
                                  "imageId": "v1695133679/badges/Pure_Veg111.png"
                                }
                              }
                            ]
                          },
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "₹100 OFF",
                        "subHeader": "ABOVE ₹299",
                        "discountTag": "FLAT DEAL"
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/great-indian-khichdi-by-eatfit-srp-nagar-ii-saibaba-colony-coimbatore-440610",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "352196",
                      "name": "Thoopu Kari Virunthu",
                      "cloudinaryImageId": "xrujobtxddz2snghfu7p",
                      "locality": "EB Colony",
                      "areaName": "Saravanampatty",
                      "costForTwo": "₹300 for two",
                      "cuisines": ["Chinese", "North Indian", "South Indian"],
                      "avgRating": 4.1,
                      "parentId": "215884",
                      "avgRatingString": "4.1",
                      "totalRatingsString": "1K+",
                      "sla": {
                        "deliveryTime": 39,
                        "lastMileTravel": 11.2,
                        "serviceability": "SERVICEABLE",
                        "slaString": "39 mins",
                        "lastMileTravelString": "11.2 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-06 16:00:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "20% OFF",
                        "subHeader": "ABOVE ₹700",
                        "discountTag": "FLAT DEAL"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/thoopu-kari-virunthu-eb-colony-saravanampatty-coimbatore-352196",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "243140",
                      "name": "The Biryani Life",
                      "cloudinaryImageId": "p69deqgobhejxnjfzm9g",
                      "locality": "Poombugar Nagar Rd",
                      "areaName": "Saravanamapatti Village",
                      "costForTwo": "₹250 for two",
                      "cuisines": [
                        "Biryani",
                        "Mughlai",
                        "Lucknowi",
                        "Hyderabadi",
                        "Kebabs",
                        "Desserts",
                        "Beverages"
                      ],
                      "avgRating": 4,
                      "parentId": "8496",
                      "avgRatingString": "4.0",
                      "totalRatingsString": "1K+",
                      "sla": {
                        "deliveryTime": 39,
                        "lastMileTravel": 10,
                        "serviceability": "SERVICEABLE",
                        "slaString": "39 mins",
                        "lastMileTravelString": "10.0 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-06 23:59:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/the-biryani-life-poombugar-nagar-rd-saravanamapatti-village-coimbatore-243140",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "194293",
                      "name": "Sweet Truth - Cake and Desserts",
                      "cloudinaryImageId": "81cf6bfe2760a45a0caf2e28716ca4d7",
                      "locality": "Poombugar Nagar Rd",
                      "areaName": "Saravanamapatti Village",
                      "costForTwo": "₹450 for two",
                      "cuisines": ["Snacks", "Bakery", "Desserts", "Beverages"],
                      "avgRating": 4.6,
                      "parentId": "4444",
                      "avgRatingString": "4.6",
                      "totalRatingsString": "1K+",
                      "sla": {
                        "deliveryTime": 38,
                        "lastMileTravel": 10,
                        "serviceability": "SERVICEABLE",
                        "slaString": "38 mins",
                        "lastMileTravelString": "10.0 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-06 23:59:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "₹125 OFF",
                        "subHeader": "ABOVE ₹399",
                        "discountTag": "FLAT DEAL"
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/sweet-truth-cake-and-desserts-poombugar-nagar-rd-saravanamapatti-village-coimbatore-194293",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "264246",
                      "name": "Chai Kings",
                      "cloudinaryImageId": "bfzbfcm0vsec3exrx0p6",
                      "locality": "EB Colony",
                      "areaName": "Kalapatti",
                      "costForTwo": "₹150 for two",
                      "cuisines": ["Beverages", "Snacks", "Bakery"],
                      "avgRating": 4.5,
                      "parentId": "2627",
                      "avgRatingString": "4.5",
                      "totalRatingsString": "1K+",
                      "sla": {
                        "deliveryTime": 32,
                        "lastMileTravel": 7.6,
                        "serviceability": "SERVICEABLE",
                        "slaString": "32 mins",
                        "lastMileTravelString": "7.6 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-06 21:00:00",
                        "opened": true
                      },
                      "badges": {
                        "textExtendedBadges": [
                          {
                            "iconId": "guiltfree/GF_Logo_android_3x",
                            "shortDescription": "options available",
                            "fontColor": "#7E808C"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "",
                                  "fontColor": "#7E808C",
                                  "iconId": "guiltfree/GF_Logo_android_3x",
                                  "shortDescription": "options available"
                                }
                              }
                            ]
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "40% OFF",
                        "subHeader": "UPTO ₹80"
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/chai-kings-eb-colony-kalapatti-coimbatore-264246",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "542850",
                      "name": "Meat and Eat",
                      "cloudinaryImageId": "wvchd9fhfal6rcbjfumd",
                      "locality": "Vcs Nagar",
                      "areaName": "Kavundampalayam",
                      "costForTwo": "₹300 for two",
                      "cuisines": ["Continental", "American", "Beverages"],
                      "avgRating": 4.3,
                      "parentId": "632",
                      "avgRatingString": "4.3",
                      "totalRatingsString": "500+",
                      "sla": {
                        "deliveryTime": 39,
                        "lastMileTravel": 4.4,
                        "serviceability": "SERVICEABLE",
                        "slaString": "39 mins",
                        "lastMileTravelString": "4.4 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-06 23:30:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "40% OFF",
                        "subHeader": "UPTO ₹80"
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/meat-and-eat-vcs-nagar-kavundampalayam-coimbatore-542850",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "612091",
                      "name": "Magizham Restaurant",
                      "cloudinaryImageId": "uypbl3q8pj8hzkfudpzc",
                      "locality": "Saravanampatti",
                      "areaName": "Saravanampatti",
                      "costForTwo": "₹500 for two",
                      "cuisines": [
                        "South Indian",
                        "Chinese",
                        "Beverages",
                        "Indian",
                        "Biryani"
                      ],
                      "avgRating": 4.2,
                      "parentId": "365306",
                      "avgRatingString": "4.2",
                      "totalRatingsString": "1K+",
                      "sla": {
                        "deliveryTime": 30,
                        "lastMileTravel": 6.8,
                        "serviceability": "SERVICEABLE",
                        "slaString": "30 mins",
                        "lastMileTravelString": "6.8 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-06 15:00:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "20% OFF",
                        "subHeader": "UPTO ₹50"
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/magizham-restaurant-saravanampatti-coimbatore-612091",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "99209",
                      "name": "Green Banana Restaurant",
                      "cloudinaryImageId": "6259476768f011bbb5a5b85f316375be",
                      "locality": "EB Colony",
                      "areaName": "Saravanampatty",
                      "costForTwo": "₹150 for two",
                      "cuisines": ["Kerala", "Biryani", "Indian", "Beverages"],
                      "avgRating": 4.4,
                      "parentId": "18263",
                      "avgRatingString": "4.4",
                      "totalRatingsString": "5K+",
                      "sla": {
                        "deliveryTime": 29,
                        "lastMileTravel": 7.8,
                        "serviceability": "SERVICEABLE",
                        "slaString": "29 mins",
                        "lastMileTravelString": "7.8 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-06 22:30:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/green-banana-restaurant-eb-colony-saravanampatty-coimbatore-99209",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "55997",
                      "name": "Curry Factory",
                      "cloudinaryImageId": "hbukq36jwzzdj5mftmlh",
                      "locality": "Kalapatti",
                      "areaName": "Saravanampatti",
                      "costForTwo": "₹200 for two",
                      "cuisines": ["Biryani", "South Indian", "Chettinad"],
                      "avgRating": 4.4,
                      "parentId": "18432",
                      "avgRatingString": "4.4",
                      "totalRatingsString": "5K+",
                      "sla": {
                        "deliveryTime": 30,
                        "lastMileTravel": 8.2,
                        "serviceability": "SERVICEABLE",
                        "slaString": "30 mins",
                        "lastMileTravelString": "8.2 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-06 16:00:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/curry-factory-kalapatti-saravanampatti-coimbatore-55997",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "398620",
                      "name": "The donuts",
                      "cloudinaryImageId": "htdpooqawtfowky834mo",
                      "locality": "Thudiyalur",
                      "areaName": "Thudiyalur",
                      "costForTwo": "₹150 for two",
                      "cuisines": ["Bakery"],
                      "avgRating": 4.4,
                      "parentId": "4734",
                      "avgRatingString": "4.4",
                      "totalRatingsString": "100+",
                      "sla": {
                        "deliveryTime": 27,
                        "lastMileTravel": 4.6,
                        "serviceability": "SERVICEABLE",
                        "slaString": "27 mins",
                        "lastMileTravelString": "4.6 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-06 21:00:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/the-donuts-thudiyalur-coimbatore-398620",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "611039",
                      "name": "Cakes by Chocolates",
                      "cloudinaryImageId": "e3acybce4hxgjenzslea",
                      "locality": "EB Colony",
                      "areaName": "Saravanampatty",
                      "costForTwo": "₹250 for two",
                      "cuisines": [
                        "Italian-American",
                        "Fast Food",
                        "Snacks",
                        "Beverages"
                      ],
                      "avgRating": 4.8,
                      "parentId": "18083",
                      "avgRatingString": "4.8",
                      "totalRatingsString": "100+",
                      "sla": {
                        "deliveryTime": 29,
                        "lastMileTravel": 8.2,
                        "serviceability": "SERVICEABLE",
                        "slaString": "29 mins",
                        "lastMileTravelString": "8.2 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-06 22:30:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "10% OFF",
                        "subHeader": "ABOVE ₹1200",
                        "discountTag": "FLAT DEAL"
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/cakes-by-chocolates-eb-colony-saravanampatty-coimbatore-611039",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "100148",
                      "name": "BQ Restaurant",
                      "cloudinaryImageId": "kcnofmyiwnvsvz337bnc",
                      "locality": "Edayarpalayam Vadavalli Road",
                      "areaName": "Vadavalli",
                      "costForTwo": "₹150 for two",
                      "cuisines": ["North Indian", "South Indian"],
                      "avgRating": 4.3,
                      "parentId": "18261",
                      "avgRatingString": "4.3",
                      "totalRatingsString": "10K+",
                      "sla": {
                        "deliveryTime": 39,
                        "lastMileTravel": 10.7,
                        "serviceability": "SERVICEABLE",
                        "slaString": "39 mins",
                        "lastMileTravelString": "10.7 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-06 23:00:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "₹125 OFF",
                        "subHeader": "ABOVE ₹249",
                        "discountTag": "FLAT DEAL"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/bq-restaurant-edayarpalayam-road-vadavalli-coimbatore-100148",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "89076",
                      "name": "Hotel Sree Ram",
                      "cloudinaryImageId": "n8f6a6fyaijpnw8hvq7k",
                      "locality": "Sathy Road",
                      "areaName": "Saravanampatty",
                      "costForTwo": "₹200 for two",
                      "cuisines": ["South Indian", "Chinese"],
                      "avgRating": 4.5,
                      "parentId": "102592",
                      "avgRatingString": "4.5",
                      "totalRatingsString": "1K+",
                      "sla": {
                        "deliveryTime": 37,
                        "lastMileTravel": 11,
                        "serviceability": "SERVICEABLE",
                        "slaString": "37 mins",
                        "lastMileTravelString": "11.0 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-06 12:00:00",
                        "opened": true
                      },
                      "badges": {
                        "textExtendedBadges": [
                          {
                            "iconId": "guiltfree/GF_Logo_android_3x",
                            "shortDescription": "options available",
                            "fontColor": "#7E808C"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "",
                                  "fontColor": "#7E808C",
                                  "iconId": "guiltfree/GF_Logo_android_3x",
                                  "shortDescription": "options available"
                                }
                              }
                            ]
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "10% OFF",
                        "subHeader": "ABOVE ₹600",
                        "discountTag": "FLAT DEAL"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/hotel-sree-ram-sathy-road-saravanampatty-coimbatore-89076",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "365043",
                      "name": "1C Dinning",
                      "cloudinaryImageId": "rmdx1yuytgrntijd40dc",
                      "locality": "Marudhamalai Road",
                      "areaName": "Vadavalli",
                      "costForTwo": "₹250 for two",
                      "cuisines": ["Indian"],
                      "avgRating": 4.2,
                      "parentId": "23001",
                      "avgRatingString": "4.2",
                      "totalRatingsString": "1K+",
                      "sla": {
                        "deliveryTime": 39,
                        "lastMileTravel": 11.8,
                        "serviceability": "SERVICEABLE",
                        "slaString": "39 mins",
                        "lastMileTravelString": "11.8 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-06 23:00:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "15% OFF",
                        "subHeader": "UPTO ₹100"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/1c-dinning-marudhamalai-road-vadavalli-coimbatore-365043",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "79607",
                      "name": "Pandiyanadu Restaurant",
                      "cloudinaryImageId": "kcw0i90pxuh0bmfvozyw",
                      "locality": "EB Colony",
                      "areaName": "Saravanampatty",
                      "costForTwo": "₹250 for two",
                      "cuisines": [
                        "South Indian",
                        "North Indian",
                        "Biryani",
                        "Chettinad",
                        "Beverages"
                      ],
                      "avgRating": 4.3,
                      "parentId": "18359",
                      "avgRatingString": "4.3",
                      "totalRatingsString": "10K+",
                      "sla": {
                        "deliveryTime": 39,
                        "lastMileTravel": 11.4,
                        "serviceability": "SERVICEABLE",
                        "slaString": "39 mins",
                        "lastMileTravelString": "11.4 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-06 23:59:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "15% OFF",
                        "subHeader": "ABOVE ₹800",
                        "discountTag": "FLAT DEAL"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/pandiyanadu-restaurant-eb-colony-saravanampatty-coimbatore-79607",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "379392",
                      "name": "Azhagar Mess",
                      "cloudinaryImageId": "pbi50smmh60lk8v44vxu",
                      "locality": "Tatabad",
                      "areaName": "Saibaba Colony",
                      "costForTwo": "₹300 for two",
                      "cuisines": ["South Indian", "Indian"],
                      "avgRating": 4.5,
                      "veg": true,
                      "parentId": "38429",
                      "avgRatingString": "4.5",
                      "totalRatingsString": "100+",
                      "sla": {
                        "deliveryTime": 35,
                        "lastMileTravel": 9.8,
                        "serviceability": "SERVICEABLE",
                        "slaString": "35 mins",
                        "lastMileTravelString": "9.8 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-06 15:30:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/azhagar-mess-tatabad-saibaba-colony-coimbatore-379392",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "69108",
                      "name": "Hotel Sri Nargani's",
                      "cloudinaryImageId": "wu14k2nu9xiudzfk053i",
                      "locality": "Marudhamalai Road",
                      "areaName": "Vadavalli",
                      "costForTwo": "₹200 for two",
                      "cuisines": ["South Indian"],
                      "avgRating": 4.4,
                      "veg": true,
                      "parentId": "18392",
                      "avgRatingString": "4.4",
                      "totalRatingsString": "10K+",
                      "sla": {
                        "deliveryTime": 37,
                        "lastMileTravel": 11.5,
                        "serviceability": "SERVICEABLE",
                        "slaString": "37 mins",
                        "lastMileTravelString": "11.5 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-06 22:15:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "10% OFF",
                        "subHeader": "ABOVE ₹500",
                        "discountTag": "FLAT DEAL"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/hotel-sri-narganis-marudhamalai-road-vadavalli-coimbatore-69108",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "419995",
                      "name": "Hotel Chola",
                      "cloudinaryImageId": "nspi5y64vqqlviocyz93",
                      "locality": "Rathinapuri",
                      "areaName": "Gandhipuram",
                      "costForTwo": "₹150 for two",
                      "cuisines": ["South Indian", "Chinese"],
                      "avgRating": 4,
                      "parentId": "4714",
                      "avgRatingString": "4.0",
                      "totalRatingsString": "1K+",
                      "sla": {
                        "deliveryTime": 41,
                        "lastMileTravel": 9.9,
                        "serviceability": "SERVICEABLE",
                        "slaString": "41 mins",
                        "lastMileTravelString": "9.9 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-07 00:00:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/hotel-chola-rathinapuri-gandhipuram-coimbatore-419995",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "121243",
                      "name": "Green Leaf Restaurant",
                      "cloudinaryImageId": "hmqq6183dkge6ltyuhig",
                      "locality": "Keeranatham",
                      "areaName": "Kalapatti",
                      "costForTwo": "₹200 for two",
                      "cuisines": ["Biryani", "Kerala", "Indian", "Beverages"],
                      "avgRating": 4.4,
                      "parentId": "18207",
                      "avgRatingString": "4.4",
                      "totalRatingsString": "10K+",
                      "sla": {
                        "deliveryTime": 32,
                        "lastMileTravel": 9.4,
                        "serviceability": "SERVICEABLE",
                        "slaString": "32 mins",
                        "lastMileTravelString": "9.4 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-06 23:00:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/green-leaf-restaurant-keeranatham-kalapatti-coimbatore-121243",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "51024",
                      "name": "CakeBee",
                      "cloudinaryImageId": "65b0afdfd0e1b35d8bd8784d9ad5f265",
                      "locality": "Bharathi Park",
                      "areaName": "Saibaba Colony",
                      "costForTwo": "₹250 for two",
                      "cuisines": ["Bakery", "Continental", "Italian"],
                      "avgRating": 4.5,
                      "parentId": "22417",
                      "avgRatingString": "4.5",
                      "totalRatingsString": "1K+",
                      "sla": {
                        "deliveryTime": 39,
                        "lastMileTravel": 9.4,
                        "serviceability": "SERVICEABLE",
                        "slaString": "39 mins",
                        "lastMileTravelString": "9.4 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-06 22:00:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/cakebee-bharathi-park-saibaba-colony-coimbatore-51024",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "494991",
                      "name": "Pongalur Sri Annapoornis sweets",
                      "cloudinaryImageId": "duzvazcltnndxus9oxgy",
                      "locality": "Vinayagapuram",
                      "areaName": "Kalapatti",
                      "costForTwo": "₹200 for two",
                      "cuisines": ["Sweets"],
                      "avgRating": 4.7,
                      "veg": true,
                      "parentId": "11250",
                      "avgRatingString": "4.7",
                      "totalRatingsString": "100+",
                      "sla": {
                        "deliveryTime": 34,
                        "lastMileTravel": 10,
                        "serviceability": "SERVICEABLE",
                        "slaString": "34 mins",
                        "lastMileTravelString": "10.0 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-06 20:30:00",
                        "opened": true
                      },
                      "badges": {
                        "imageBadges": [
                          {
                            "imageId": "v1695133679/badges/Pure_Veg111.png",
                            "description": "pureveg"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "pureveg",
                                  "imageId": "v1695133679/badges/Pure_Veg111.png"
                                }
                              }
                            ]
                          },
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/pongalur-sri-annapoornis-sweets-vinayagapuram-kalapatti-coimbatore-494991",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "118757",
                      "name": "The South Indian Coffee House",
                      "cloudinaryImageId": "xeji4hyekzxvwwc7l4zl",
                      "locality": "RS Puram",
                      "areaName": "Saibaba Colony",
                      "costForTwo": "₹200 for two",
                      "cuisines": ["South Indian"],
                      "avgRating": 4.4,
                      "veg": true,
                      "parentId": "4905",
                      "avgRatingString": "4.4",
                      "totalRatingsString": "1K+",
                      "sla": {
                        "deliveryTime": 38,
                        "lastMileTravel": 9.1,
                        "serviceability": "SERVICEABLE",
                        "slaString": "38 mins",
                        "lastMileTravelString": "9.1 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-06 20:00:00",
                        "opened": true
                      },
                      "badges": {
                        "imageBadges": [
                          {
                            "imageId": "v1695133679/badges/Pure_Veg111.png",
                            "description": "pureveg"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "pureveg",
                                  "imageId": "v1695133679/badges/Pure_Veg111.png"
                                }
                              }
                            ]
                          },
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "₹125 OFF",
                        "subHeader": "ABOVE ₹249",
                        "discountTag": "FLAT DEAL"
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/the-south-indian-coffee-house-rs-puram-saibaba-colony-coimbatore-118757",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "698268",
                      "name": "FB Cakes",
                      "cloudinaryImageId": "08b86c9aecbce029d60719c2230fadd2",
                      "locality": "Ward-1",
                      "areaName": "Thudiyalur",
                      "costForTwo": "₹500 for two",
                      "cuisines": ["Bakery", "Sweets", "Snacks"],
                      "avgRating": 4.5,
                      "parentId": "245423",
                      "avgRatingString": "4.5",
                      "totalRatingsString": "100+",
                      "sla": {
                        "deliveryTime": 29,
                        "lastMileTravel": 4.7,
                        "serviceability": "SERVICEABLE",
                        "slaString": "29 mins",
                        "lastMileTravelString": "4.7 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-06 23:59:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "₹150 OFF",
                        "subHeader": "ABOVE ₹699",
                        "discountTag": "FLAT DEAL"
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/fb-cakes-ward-1-thudiyalur-coimbatore-698268",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "380157",
                      "name": "Biggies Burger",
                      "cloudinaryImageId": "262ed2bd91ed3e73e7a1bd299b2cc4da",
                      "locality": "Thudiyalur Road",
                      "areaName": "Saravanampatty",
                      "costForTwo": "₹300 for two",
                      "cuisines": ["American", "Fast Food", "Beverages"],
                      "avgRating": 4.3,
                      "parentId": "45723",
                      "avgRatingString": "4.3",
                      "totalRatingsString": "1K+",
                      "sla": {
                        "deliveryTime": 34,
                        "lastMileTravel": 7.9,
                        "serviceability": "SERVICEABLE",
                        "slaString": "34 mins",
                        "lastMileTravelString": "7.9 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-06 23:59:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/biggies-burger-thudiyalur-road-saravanampatty-coimbatore-380157",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "722365",
                      "name": "Big Fat Burger",
                      "cloudinaryImageId": "49734adfd36beaa783cc2ddd61ed7aa4",
                      "locality": "Keeranatham new road",
                      "areaName": "Saravanampatti",
                      "costForTwo": "₹250 for two",
                      "cuisines": ["Burgers"],
                      "avgRating": 4.3,
                      "parentId": "18031",
                      "avgRatingString": "4.3",
                      "totalRatingsString": "100+",
                      "sla": {
                        "deliveryTime": 41,
                        "lastMileTravel": 9.2,
                        "serviceability": "SERVICEABLE",
                        "slaString": "41 mins",
                        "lastMileTravelString": "9.2 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-06 23:59:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/big-fat-burger-keeranatham-new-road-saravanampatti-coimbatore-722365",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "332719",
                      "name": "Drunken Monkey",
                      "cloudinaryImageId": "zz7ib5d9hfjir1qsbult",
                      "locality": "Thudiyalur",
                      "areaName": "Saravanampatty",
                      "costForTwo": "₹250 for two",
                      "cuisines": ["Healthy Food", "Beverages", "Juices"],
                      "avgRating": 4.5,
                      "veg": true,
                      "parentId": "1729",
                      "avgRatingString": "4.5",
                      "totalRatingsString": "500+",
                      "sla": {
                        "deliveryTime": 37,
                        "lastMileTravel": 8.2,
                        "serviceability": "SERVICEABLE",
                        "slaString": "37 mins",
                        "lastMileTravelString": "8.2 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-06 23:00:00",
                        "opened": true
                      },
                      "badges": {
                        "imageBadges": [
                          {
                            "imageId": "v1695133679/badges/Pure_Veg111.png",
                            "description": "pureveg"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "pureveg",
                                  "imageId": "v1695133679/badges/Pure_Veg111.png"
                                }
                              }
                            ]
                          },
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "₹100 OFF",
                        "subHeader": "ABOVE ₹749",
                        "discountTag": "FLAT DEAL"
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/drunken-monkey-thudiyalur-saravanampatty-coimbatore-332719",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "440611",
                      "name": "Home Plate by EatFit",
                      "cloudinaryImageId": "1d578bb732e03c6f591790eb7d2d88e2",
                      "locality": "SRP Nagar II",
                      "areaName": "Saibaba Colony",
                      "costForTwo": "₹250 for two",
                      "cuisines": [
                        "North Indian",
                        "Home Food",
                        "Healthy Food",
                        "Indian",
                        "Punjabi",
                        "South Indian",
                        "Rajasthani",
                        "Maharashtrian",
                        "Snacks",
                        "Desserts",
                        "Beverages"
                      ],
                      "avgRating": 4.2,
                      "parentId": "301197",
                      "avgRatingString": "4.2",
                      "totalRatingsString": "500+",
                      "sla": {
                        "deliveryTime": 40,
                        "lastMileTravel": 9.3,
                        "serviceability": "SERVICEABLE",
                        "slaString": "40 mins",
                        "lastMileTravelString": "9.3 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-06 23:59:00",
                        "opened": true
                      },
                      "badges": {
                        "textExtendedBadges": [
                          {
                            "iconId": "guiltfree/GF_Logo_android_3x",
                            "shortDescription": "options available",
                            "fontColor": "#7E808C"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "",
                                  "fontColor": "#7E808C",
                                  "iconId": "guiltfree/GF_Logo_android_3x",
                                  "shortDescription": "options available"
                                }
                              }
                            ]
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "ITEMS",
                        "subHeader": "AT ₹159"
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/home-plate-by-eatfit-srp-nagar-ii-saibaba-colony-coimbatore-440611",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "582498",
                      "name": "Cheesecakes By CakeZone",
                      "cloudinaryImageId": "76d5f4055f9d5796bc7b72dfba8bd92b",
                      "locality": "SRP Nagar II",
                      "areaName": "NSR Road",
                      "costForTwo": "₹200 for two",
                      "cuisines": ["Desserts", "Bakery"],
                      "avgRating": 4.3,
                      "veg": true,
                      "parentId": "348057",
                      "avgRatingString": "4.3",
                      "totalRatingsString": "100+",
                      "sla": {
                        "deliveryTime": 39,
                        "lastMileTravel": 9.3,
                        "serviceability": "SERVICEABLE",
                        "slaString": "39 mins",
                        "lastMileTravelString": "9.3 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-07 01:00:00",
                        "opened": true
                      },
                      "badges": {
                        "imageBadges": [
                          {
                            "imageId": "newg.png",
                            "description": "Gourmet"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "Gourmet",
                                  "imageId": "newg.png"
                                }
                              }
                            ]
                          },
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "₹125 OFF",
                        "subHeader": "ABOVE ₹399",
                        "discountTag": "FLAT DEAL"
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/cheesecakes-by-cakezone-srp-nagar-ii-nsr-road-coimbatore-582498",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "114850",
                      "name": "Cream & Fudge",
                      "cloudinaryImageId": "un8ls7ixf0xvmcvt9kbg",
                      "areaName": "Saravanampatti",
                      "costForTwo": "₹200 for two",
                      "cuisines": ["Ice Cream", "Desserts", "Beverages"],
                      "avgRating": 4.4,
                      "veg": true,
                      "parentId": "6644",
                      "avgRatingString": "4.4",
                      "totalRatingsString": "1K+",
                      "sla": {
                        "deliveryTime": 34,
                        "lastMileTravel": 9.2,
                        "serviceability": "SERVICEABLE",
                        "slaString": "34 mins",
                        "lastMileTravelString": "9.2 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-07 00:00:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "₹150 OFF",
                        "subHeader": "ABOVE ₹999",
                        "discountTag": "FLAT DEAL"
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/cream-and-fudge-saravanampatti-coimbatore-114850",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "440607",
                      "name": "Aligarh House -Mughlai Biryani",
                      "cloudinaryImageId": "ef0e1cdb0fc48b9ff93b4366c1221036",
                      "locality": "NSR Road",
                      "areaName": "Saibaba Colony",
                      "costForTwo": "₹400 for two",
                      "cuisines": [
                        "Biryani",
                        "Mughlai",
                        "Kebabs",
                        "North Indian",
                        "Lucknowi",
                        "Fast Food",
                        "Desserts",
                        "Beverages"
                      ],
                      "avgRating": 4,
                      "parentId": "346372",
                      "avgRatingString": "4.0",
                      "totalRatingsString": "500+",
                      "sla": {
                        "deliveryTime": 38,
                        "lastMileTravel": 9.3,
                        "serviceability": "SERVICEABLE",
                        "slaString": "38 mins",
                        "lastMileTravelString": "9.3 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-06 23:59:00",
                        "opened": true
                      },
                      "badges": {},
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {},
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/aligarh-house-mughlai-biryani-nsr-road-saibaba-colony-coimbatore-440607",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "575385",
                      "name": "Madurai Famous Jigarthanda",
                      "cloudinaryImageId": "s8lznihszdzekpghe9wt",
                      "locality": "Saibaba Kovil",
                      "areaName": "Saibaba Colony",
                      "costForTwo": "₹150 for two",
                      "cuisines": ["Beverages"],
                      "avgRating": 4.4,
                      "veg": true,
                      "parentId": "129012",
                      "avgRatingString": "4.4",
                      "totalRatingsString": "100+",
                      "sla": {
                        "deliveryTime": 38,
                        "lastMileTravel": 8.8,
                        "serviceability": "SERVICEABLE",
                        "slaString": "38 mins",
                        "lastMileTravelString": "8.8 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-01-06 22:25:00",
                        "opened": true
                      },
                      "badges": {
                        "imageBadges": [
                          {
                            "imageId": "v1695133679/badges/Pure_Veg111.png",
                            "description": "pureveg"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "pureveg",
                                  "imageId": "v1695133679/badges/Pure_Veg111.png"
                                }
                              }
                            ]
                          },
                          "textBased": {},
                          "textExtendedBadges": {}
                        }
                      },
                      "loyaltyDiscoverPresentationInfo": {
                        "logoCtx": {
                          "text": "BENEFITS",
                          "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                        },
                        "freedelMessage": "FREE DELIVERY"
                      },
                      "orderabilityCommunication": {
                        "title": {},
                        "subTitle": {},
                        "message": {},
                        "customIcon": {}
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {},
                          "video": {}
                        }
                      },
                      "reviewsSummary": {},
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                      "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/madurai-famous-jigarthanda-saibaba-kovil-saibaba-colony-coimbatore-575385",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                        "id": "84887",
                        "name": "Aasife Biriyani",
                        "cloudinaryImageId": "4c60f16916c90b6249c1e27f28bbb8e4",
                        "locality": "Sathy Road",
                        "areaName": "Saravanampatty",
                        "costForTwo": "₹200 for two",
                        "cuisines": [
                            "Biryani",
                            "North Indian",
                            "Chettinad",
                            "Chinese",
                            "Juices"
                        ],
                        "avgRating": 4.2,
                        "parentId": "1265",
                        "avgRatingString": "4.2",
                        "totalRatingsString": "5K+",
                        "sla": {
                            "deliveryTime": 43,
                            "lastMileTravel": 11.5,
                            "serviceability": "SERVICEABLE",
                            "slaString": "43 mins",
                            "lastMileTravelString": "11.5 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-06 23:00:00",
                            "opened": true
                        },
                        "badges": {},
                        "isOpen": true,
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {},
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "aggregatedDiscountInfoV3": {
                            "header": "10% OFF",
                            "subHeader": "ABOVE ₹900",
                            "discountTag": "FLAT DEAL"
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/aasife-biriyani-sathy-road-saravanampatty-coimbatore-84887",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                },
                {
                    "info": {
                        "id": "639425",
                        "name": "Dum Safar Biryani by Barbeque Nation",
                        "cloudinaryImageId": "47eee43e59a6d49b0f6d9a2b0e523f47",
                        "locality": "Raja Street",
                        "areaName": "Town Hall",
                        "costForTwo": "₹500 for two",
                        "cuisines": [
                            "Biryani",
                            "Kebabs",
                            "Tandoor",
                            "Indian",
                            "Desserts"
                        ],
                        "avgRating": 4.1,
                        "parentId": "351013",
                        "avgRatingString": "4.1",
                        "totalRatingsString": "50+",
                        "sla": {
                            "deliveryTime": 47,
                            "lastMileTravel": 12.8,
                            "serviceability": "SERVICEABLE",
                            "slaString": "47 mins",
                            "lastMileTravelString": "12.8 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-06 23:30:00",
                            "opened": true
                        },
                        "badges": {},
                        "isOpen": true,
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {},
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "aggregatedDiscountInfoV3": {
                            "header": "₹100 OFF",
                            "subHeader": "ABOVE ₹549",
                            "discountTag": "FLAT DEAL"
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/dum-safar-biryani-by-barbeque-nation-raja-street-town-hall-coimbatore-639425",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                },
                {
                    "info": {
                        "id": "756260",
                        "name": "Olio - The Wood Fired Pizzeria",
                        "cloudinaryImageId": "4b44c7921b1b6073a4ffa58b38f8def1",
                        "locality": "Ramanandha Nagar",
                        "areaName": "Saravanampatty",
                        "costForTwo": "₹300 for two",
                        "cuisines": [
                            "Pizzas",
                            "Pastas",
                            "Fast Food",
                            "Snacks",
                            "Beverages"
                        ],
                        "avgRating": 4.2,
                        "parentId": "11633",
                        "avgRatingString": "4.2",
                        "totalRatingsString": "100+",
                        "sla": {
                            "deliveryTime": 69,
                            "lastMileTravel": 10.2,
                            "serviceability": "SERVICEABLE",
                            "slaString": "69 mins",
                            "lastMileTravelString": "10.2 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-06 23:59:00",
                            "opened": true
                        },
                        "badges": {
                            "imageBadges": [
                                {
                                    "imageId": "newg.png",
                                    "description": "Gourmet"
                                }
                            ]
                        },
                        "isOpen": true,
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {
                                    "badgeObject": [
                                        {
                                            "attributes": {
                                                "description": "Gourmet",
                                                "imageId": "newg.png"
                                            }
                                        }
                                    ]
                                },
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "aggregatedDiscountInfoV3": {
                            "header": "₹125 OFF",
                            "subHeader": "ABOVE ₹249",
                            "discountTag": "FLAT DEAL"
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "isNewlyOnboarded": true,
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/olio-the-wood-fired-pizzeria-ramanandha-nagar-saravanampatty-coimbatore-756260",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                },
                {
                    "info": {
                        "id": "789295",
                        "name": "Khalids Biriyani",
                        "cloudinaryImageId": "f594f4f63d3e00e93203f02d40e38d24",
                        "locality": "Nsr Road",
                        "areaName": "Sai Baba Colony",
                        "costForTwo": "₹500 for two",
                        "cuisines": [
                            "Biryani",
                            "South Indian",
                            "Chinese",
                            "Seafood",
                            "Barbecue",
                            "Tandoor",
                            "Kebabs"
                        ],
                        "avgRating": 4.2,
                        "parentId": "11840",
                        "avgRatingString": "4.2",
                        "totalRatingsString": "100+",
                        "sla": {
                            "deliveryTime": 40,
                            "lastMileTravel": 8.8,
                            "serviceability": "SERVICEABLE",
                            "slaString": "40 mins",
                            "lastMileTravelString": "8.8 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-06 23:00:00",
                            "opened": true
                        },
                        "badges": {},
                        "isOpen": true,
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {},
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "aggregatedDiscountInfoV3": {
                            "header": "₹100 OFF",
                            "subHeader": "ABOVE ₹299",
                            "discountTag": "FLAT DEAL"
                        },
                        "loyaltyDiscoverPresentationInfo": {
                            "logoCtx": {
                                "text": "BENEFITS",
                                "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                            },
                            "freedelMessage": "FREE DELIVERY"
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "isNewlyOnboarded": true,
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/khalids-biriyani-nsr-road-sai-baba-colony-coimbatore-789295",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                },
                {
                    "info": {
                        "id": "188539",
                        "name": "Kebabistaan",
                        "cloudinaryImageId": "2b93b3b52a307c3ae0a45a869876998a",
                        "locality": "Thudiyalur Road",
                        "areaName": "Saravanampatty",
                        "costForTwo": "₹300 for two",
                        "cuisines": [
                            "Beverages",
                            "Chinese",
                            "Kebabs",
                            "Tandoor",
                            "Grill",
                            "Biryani",
                            "Mughlai",
                            "Arabian",
                            "Lebanese",
                            "North Indian",
                            "Salads",
                            "Desserts"
                        ],
                        "avgRating": 3.9,
                        "parentId": "8877",
                        "avgRatingString": "3.9",
                        "totalRatingsString": "1K+",
                        "sla": {
                            "deliveryTime": 42,
                            "lastMileTravel": 9.2,
                            "serviceability": "SERVICEABLE",
                            "slaString": "42 mins",
                            "lastMileTravelString": "9.2 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-07 02:00:00",
                            "opened": true
                        },
                        "badges": {},
                        "isOpen": true,
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {},
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "aggregatedDiscountInfoV3": {
                            "header": "₹125 OFF",
                            "subHeader": "ABOVE ₹599",
                            "discountTag": "FLAT DEAL"
                        },
                        "loyaltyDiscoverPresentationInfo": {
                            "logoCtx": {
                                "text": "BENEFITS",
                                "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                            },
                            "freedelMessage": "FREE DELIVERY"
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/kebabistaan-thudiyalur-road-saravanampatty-coimbatore-188539",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                },
                {
                    "info": {
                        "id": "125768",
                        "name": "Night Out",
                        "cloudinaryImageId": "x9sormed4oudyhf0boiu",
                        "locality": "Puliakulam Road",
                        "areaName": "Lakshmi Mills",
                        "costForTwo": "₹250 for two",
                        "cuisines": [
                            "North Indian",
                            "Chinese",
                            "Tandoor",
                            "Biryani",
                            "Kebabs",
                            "South Indian",
                            "Barbecue",
                            "Italian",
                            "Beverages"
                        ],
                        "avgRating": 3.8,
                        "parentId": "6995",
                        "avgRatingString": "3.8",
                        "totalRatingsString": "10K+",
                        "sla": {
                            "deliveryTime": 60,
                            "lastMileTravel": 13.9,
                            "serviceability": "SERVICEABLE",
                            "slaString": "60 mins",
                            "lastMileTravelString": "13.9 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-06 23:59:00",
                            "opened": true
                        },
                        "badges": {},
                        "isOpen": true,
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {},
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "aggregatedDiscountInfoV3": {
                            "header": "₹125 OFF",
                            "subHeader": "ABOVE ₹199",
                            "discountTag": "FLAT DEAL"
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/night-out-puliakulam-road-lakshmi-mills-coimbatore-125768",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                },
                {
                    "info": {
                        "id": "566381",
                        "name": "Faasos' Signature Wraps & Rolls",
                        "cloudinaryImageId": "c583ca6ce40b426797a78ae2ac91f2ec",
                        "locality": "Poombugar Nagar Rd",
                        "areaName": "Saravanamapatti Village",
                        "costForTwo": "₹350 for two",
                        "cuisines": [
                            "Fast Food",
                            "Snacks",
                            "North Indian",
                            "Desserts",
                            "Beverages"
                        ],
                        "avgRating": 4.6,
                        "parentId": "340366",
                        "avgRatingString": "4.6",
                        "totalRatingsString": "100+",
                        "sla": {
                            "deliveryTime": 43,
                            "lastMileTravel": 10,
                            "serviceability": "SERVICEABLE",
                            "slaString": "43 mins",
                            "lastMileTravelString": "10.0 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-06 23:59:00",
                            "opened": true
                        },
                        "badges": {},
                        "isOpen": true,
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {},
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "aggregatedDiscountInfoV3": {
                            "header": "₹125 OFF",
                            "subHeader": "ABOVE ₹349",
                            "discountTag": "FLAT DEAL"
                        },
                        "loyaltyDiscoverPresentationInfo": {
                            "logoCtx": {
                                "text": "BENEFITS",
                                "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                            },
                            "freedelMessage": "FREE DELIVERY"
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/faasos-signature-wraps-and-rolls-poombugar-nagar-rd-saravanamapatti-village-coimbatore-566381",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                },
                {
                    "info": {
                        "id": "690587",
                        "name": "Ovenfresh Cakes And Desserts",
                        "cloudinaryImageId": "c466e7bdaf57fcc6072ec76facfc99a7",
                        "locality": "SRP Nagar",
                        "areaName": "Sai Baba Colony",
                        "costForTwo": "₹200 for two",
                        "cuisines": [
                            "Bakery",
                            "Desserts",
                            "Beverages",
                            "Ice Cream",
                            "Sweets",
                            "Juices",
                            "Bengali",
                            "Pizzas"
                        ],
                        "avgRating": 4.4,
                        "parentId": "1372",
                        "avgRatingString": "4.4",
                        "totalRatingsString": "100+",
                        "sla": {
                            "deliveryTime": 45,
                            "lastMileTravel": 9.3,
                            "serviceability": "SERVICEABLE",
                            "slaString": "45 mins",
                            "lastMileTravelString": "9.3 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-07 01:00:00",
                            "opened": true
                        },
                        "badges": {},
                        "isOpen": true,
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {},
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "aggregatedDiscountInfoV3": {
                            "header": "₹125 OFF",
                            "subHeader": "ABOVE ₹299",
                            "discountTag": "FLAT DEAL"
                        },
                        "loyaltyDiscoverPresentationInfo": {
                            "logoCtx": {
                                "text": "BENEFITS",
                                "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                            },
                            "freedelMessage": "FREE DELIVERY"
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/ovenfresh-cakes-and-desserts-srp-nagar-sai-baba-colony-coimbatore-690587",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                },
                {
                    "info": {
                        "id": "619682",
                        "name": "Madras Coffee House",
                        "cloudinaryImageId": "rju93101fkbtwpx3ixdz",
                        "locality": "Nava India Road",
                        "areaName": "Peelamedu",
                        "costForTwo": "₹150 for two",
                        "cuisines": [
                            "Snacks",
                            "Bakery",
                            "South Indian"
                        ],
                        "avgRating": 4.5,
                        "veg": true,
                        "parentId": "1750",
                        "avgRatingString": "4.5",
                        "totalRatingsString": "100+",
                        "sla": {
                            "deliveryTime": 44,
                            "lastMileTravel": 12.6,
                            "serviceability": "SERVICEABLE",
                            "slaString": "44 mins",
                            "lastMileTravelString": "12.6 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-06 20:00:00",
                            "opened": true
                        },
                        "badges": {},
                        "isOpen": true,
                        "aggregatedDiscountInfoV2": {},
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {},
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/madras-coffee-house-nava-india-road-peelamedu-coimbatore-619682",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                },
                {
                    "info": {
                        "id": "769671",
                        "name": "Oyalo Pizza",
                        "cloudinaryImageId": "32c516555a039fbb02f31461c7519b84",
                        "locality": "Periyanaickenpalayam",
                        "areaName": "vadamadurai thudiyalur",
                        "costForTwo": "₹249 for two",
                        "cuisines": [
                            "Pizzas"
                        ],
                        "avgRating": 3.7,
                        "parentId": "8699",
                        "avgRatingString": "3.7",
                        "totalRatingsString": "20+",
                        "sla": {
                            "deliveryTime": 43,
                            "lastMileTravel": 6.1,
                            "serviceability": "SERVICEABLE",
                            "slaString": "43 mins",
                            "lastMileTravelString": "6.1 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-06 23:00:00",
                            "opened": true
                        },
                        "badges": {},
                        "isOpen": true,
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {},
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "aggregatedDiscountInfoV3": {
                            "header": "50% OFF",
                            "subHeader": "UPTO ₹100"
                        },
                        "loyaltyDiscoverPresentationInfo": {
                            "logoCtx": {
                                "text": "BENEFITS",
                                "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                            },
                            "freedelMessage": "FREE DELIVERY"
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "isNewlyOnboarded": true,
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/oyalo-pizza-periyanaickenpalayam-vadamadurai-thudiyalur-coimbatore-769671",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                },
                {
                    "info": {
                        "id": "58560",
                        "name": "PVR Cafe",
                        "cloudinaryImageId": "xyp9tmizijdx7l4v3p7h",
                        "locality": "Brookefields Mall",
                        "areaName": "RS Puram",
                        "costForTwo": "₹200 for two",
                        "cuisines": [
                            "Snacks",
                            "Fast Food",
                            "Beverages"
                        ],
                        "avgRating": 4.3,
                        "parentId": "11664",
                        "avgRatingString": "4.3",
                        "totalRatingsString": "1K+",
                        "sla": {
                            "deliveryTime": 50,
                            "lastMileTravel": 11.2,
                            "serviceability": "SERVICEABLE",
                            "slaString": "50 mins",
                            "lastMileTravelString": "11.2 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-07 01:00:00",
                            "opened": true
                        },
                        "badges": {},
                        "isOpen": true,
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {},
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "aggregatedDiscountInfoV3": {
                            "header": "10% OFF",
                            "subHeader": "ABOVE ₹1000",
                            "discountTag": "FLAT DEAL"
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/pvr-cafe-brookefields-mall-rs-puram-coimbatore-58560",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                },
                {
                    "info": {
                        "id": "603726",
                        "name": "The Momo Co.",
                        "cloudinaryImageId": "9668a5819fcba35364dcff30d5f5cfbb",
                        "locality": "Mettupalayam Road",
                        "areaName": "Sivanadha Colony",
                        "costForTwo": "₹250 for two",
                        "cuisines": [
                            "Chinese",
                            "Asian",
                            "Tibetan",
                            "Desserts"
                        ],
                        "avgRating": 4.3,
                        "parentId": "11442",
                        "avgRatingString": "4.3",
                        "totalRatingsString": "100+",
                        "sla": {
                            "deliveryTime": 46,
                            "lastMileTravel": 8.4,
                            "serviceability": "SERVICEABLE",
                            "slaString": "46 mins",
                            "lastMileTravelString": "8.4 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-07 02:00:00",
                            "opened": true
                        },
                        "badges": {},
                        "isOpen": true,
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {},
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "aggregatedDiscountInfoV3": {
                            "header": "₹125 OFF",
                            "subHeader": "ABOVE ₹399",
                            "discountTag": "FLAT DEAL"
                        },
                        "loyaltyDiscoverPresentationInfo": {
                            "logoCtx": {
                                "text": "BENEFITS",
                                "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                            },
                            "freedelMessage": "FREE DELIVERY"
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/the-momo-co-mettupalayam-road-sivanadha-colony-coimbatore-603726",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                },
                {
                    "info": {
                        "id": "769054",
                        "name": "Havmor Havfunn Ice Cream",
                        "cloudinaryImageId": "380c5cce11e64e049f8d1643c9f46a0f",
                        "locality": "Jawahar Nagar",
                        "areaName": "Sai Baba Colony",
                        "costForTwo": "₹1 for two",
                        "cuisines": [
                            "Ice Cream",
                            "Desserts",
                            "Beverages"
                        ],
                        "avgRating": 4.3,
                        "veg": true,
                        "parentId": "94570",
                        "avgRatingString": "4.3",
                        "totalRatingsString": "8",
                        "sla": {
                            "deliveryTime": 41,
                            "lastMileTravel": 9.5,
                            "serviceability": "SERVICEABLE",
                            "slaString": "41 mins",
                            "lastMileTravelString": "9.5 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-06 23:59:00",
                            "opened": true
                        },
                        "badges": {},
                        "isOpen": true,
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {},
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "loyaltyDiscoverPresentationInfo": {
                            "logoCtx": {
                                "text": "BENEFITS",
                                "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                            },
                            "freedelMessage": "FREE DELIVERY"
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "isNewlyOnboarded": true,
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/havmor-havfunn-ice-cream-jawahar-nagar-sai-baba-colony-coimbatore-769054",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                },
                {
                    "info": {
                        "id": "58534",
                        "name": "Cookie Man",
                        "cloudinaryImageId": "9859734c76da085e6fa82ab6ff6f9324",
                        "locality": "Brookefields Mall",
                        "areaName": "RS Puram",
                        "costForTwo": "₹140 for two",
                        "cuisines": [
                            "Desserts",
                            "Ice Cream",
                            "Bakery"
                        ],
                        "avgRating": 4.2,
                        "parentId": "2420",
                        "avgRatingString": "4.2",
                        "totalRatingsString": "100+",
                        "sla": {
                            "deliveryTime": 46,
                            "lastMileTravel": 11.1,
                            "serviceability": "SERVICEABLE",
                            "slaString": "46 mins",
                            "lastMileTravelString": "11.1 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-06 22:00:00",
                            "opened": true
                        },
                        "badges": {},
                        "isOpen": true,
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {},
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "aggregatedDiscountInfoV3": {
                            "header": "40% OFF",
                            "subHeader": "UPTO ₹80"
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/cookie-man-brookefields-mall-rs-puram-coimbatore-58534",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                },
                {
                    "info": {
                        "id": "722815",
                        "name": "FNP Cakes By Ferns N Petals",
                        "cloudinaryImageId": "57f39df3b1e192cb54999ffbbdf40bf8",
                        "locality": "Sai Baba Colony",
                        "areaName": "PARK ROAD1",
                        "costForTwo": "₹499 for two",
                        "cuisines": [
                            "Bakery",
                            "Desserts"
                        ],
                        "avgRating": 4.5,
                        "veg": true,
                        "parentId": "339638",
                        "avgRatingString": "4.5",
                        "totalRatingsString": "50+",
                        "sla": {
                            "deliveryTime": 51,
                            "lastMileTravel": 9.3,
                            "serviceability": "SERVICEABLE",
                            "slaString": "51 mins",
                            "lastMileTravelString": "9.3 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-06 21:00:00",
                            "opened": true
                        },
                        "badges": {
                            "imageBadges": [
                                {
                                    "imageId": "v1695133679/badges/Pure_Veg111.png",
                                    "description": "pureveg"
                                }
                            ]
                        },
                        "isOpen": true,
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {
                                    "badgeObject": [
                                        {
                                            "attributes": {
                                                "description": "pureveg",
                                                "imageId": "v1695133679/badges/Pure_Veg111.png"
                                            }
                                        }
                                    ]
                                },
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "aggregatedDiscountInfoV3": {
                            "header": "₹125 OFF",
                            "subHeader": "ABOVE ₹599",
                            "discountTag": "FLAT DEAL"
                        },
                        "loyaltyDiscoverPresentationInfo": {
                            "logoCtx": {
                                "text": "BENEFITS",
                                "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                            },
                            "freedelMessage": "FREE DELIVERY"
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "isNewlyOnboarded": true,
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/fnp-cakes-by-ferns-n-petals-sai-baba-colony-park-road1-coimbatore-722815",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                },
                {
                    "info": {
                        "id": "289411",
                        "name": "Express By Ab's",
                        "cloudinaryImageId": "xaic3kajc56trg29tp7w",
                        "locality": "Peelamedu",
                        "areaName": "Peelamedu",
                        "costForTwo": "₹300 for two",
                        "cuisines": [
                            "North Indian",
                            "Barbecue",
                            "Kebabs",
                            "Biryani"
                        ],
                        "avgRating": 4.1,
                        "parentId": "10320",
                        "avgRatingString": "4.1",
                        "totalRatingsString": "100+",
                        "sla": {
                            "deliveryTime": 51,
                            "lastMileTravel": 13.7,
                            "serviceability": "SERVICEABLE",
                            "slaString": "51 mins",
                            "lastMileTravelString": "13.7 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-06 23:00:00",
                            "opened": true
                        },
                        "badges": {},
                        "isOpen": true,
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {},
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "aggregatedDiscountInfoV3": {
                            "header": "₹125 OFF",
                            "subHeader": "ABOVE ₹249",
                            "discountTag": "FLAT DEAL"
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/express-by-abs-peelamedu-coimbatore-289411",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                },
                {
                    "info": {
                        "id": "666307",
                        "name": "Kaati Zone Rolls & Wraps",
                        "cloudinaryImageId": "b6fb5a0d41200a54b88be85c7d28185b",
                        "locality": "Barathi Park",
                        "areaName": "Sai Baba Colony",
                        "costForTwo": "₹200 for two",
                        "cuisines": [
                            "Fast Food",
                            "Bengali",
                            "Beverages",
                            "Desserts"
                        ],
                        "avgRating": 4.1,
                        "parentId": "248306",
                        "avgRatingString": "4.1",
                        "totalRatingsString": "20+",
                        "sla": {
                            "deliveryTime": 50,
                            "lastMileTravel": 9.8,
                            "serviceability": "SERVICEABLE",
                            "slaString": "50 mins",
                            "lastMileTravelString": "9.8 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-07 02:00:00",
                            "opened": true
                        },
                        "badges": {},
                        "isOpen": true,
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {},
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "aggregatedDiscountInfoV3": {
                            "header": "₹150 OFF",
                            "subHeader": "ABOVE ₹499",
                            "discountTag": "FLAT DEAL"
                        },
                        "loyaltyDiscoverPresentationInfo": {
                            "logoCtx": {
                                "text": "BENEFITS",
                                "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                            },
                            "freedelMessage": "FREE DELIVERY"
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/kaati-zone-rolls-and-wraps-barathi-park-sai-baba-colony-coimbatore-666307",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                },
                {
                    "info": {
                        "id": "420288",
                        "name": "McDonald's Gourmet Burger Collection",
                        "cloudinaryImageId": "jeu21vovlgzkacvamunl",
                        "locality": "Prozone Mall",
                        "areaName": "Saravanampatty",
                        "costForTwo": "₹600 for two",
                        "cuisines": [
                            "Burgers",
                            "Beverages",
                            "Cafe",
                            "Desserts"
                        ],
                        "avgRating": 4.5,
                        "parentId": "10761",
                        "avgRatingString": "4.5",
                        "totalRatingsString": "100+",
                        "sla": {
                            "deliveryTime": 50,
                            "lastMileTravel": 11.6,
                            "serviceability": "SERVICEABLE",
                            "slaString": "50 mins",
                            "lastMileTravelString": "11.6 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-06 21:45:00",
                            "opened": true
                        },
                        "badges": {},
                        "isOpen": true,
                        "aggregatedDiscountInfoV2": {},
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {},
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/mcdonalds-gourmet-burger-collection-prozone-mall-saravanampatty-coimbatore-420288",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                },
                {
                    "info": {
                        "id": "666333",
                        "name": "Indiana Burgers",
                        "cloudinaryImageId": "56c20cff0d4859b758f332e9e93706e4",
                        "locality": "Coimbatore Corporation Ward-22",
                        "areaName": "Sai Baba Colony",
                        "costForTwo": "₹200 for two",
                        "cuisines": [
                            "Burgers",
                            "American",
                            "Fast Food",
                            "Beverages",
                            "Desserts"
                        ],
                        "avgRating": 4.4,
                        "parentId": "5714",
                        "avgRatingString": "4.4",
                        "totalRatingsString": "100+",
                        "sla": {
                            "deliveryTime": 46,
                            "lastMileTravel": 9.8,
                            "serviceability": "SERVICEABLE",
                            "slaString": "46 mins",
                            "lastMileTravelString": "9.8 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-07 02:00:00",
                            "opened": true
                        },
                        "badges": {},
                        "isOpen": true,
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {},
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "aggregatedDiscountInfoV3": {
                            "header": "₹150 OFF",
                            "subHeader": "ABOVE ₹499",
                            "discountTag": "FLAT DEAL"
                        },
                        "loyaltyDiscoverPresentationInfo": {
                            "logoCtx": {
                                "text": "BENEFITS",
                                "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                            },
                            "freedelMessage": "FREE DELIVERY"
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/indiana-burgers-corporation-ward-22-sai-baba-colony-coimbatore-666333",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                },
                {
                    "info": {
                        "id": "666330",
                        "name": "The Dessert Zone",
                        "cloudinaryImageId": "c447c9ce7d0bbe78e46141e866236762",
                        "locality": "Barathi Park",
                        "areaName": "Sai Baba Colony",
                        "costForTwo": "₹200 for two",
                        "cuisines": [
                            "Burgers",
                            "Beverages",
                            "Desserts",
                            "American",
                            "Cafe"
                        ],
                        "avgRating": 4.2,
                        "parentId": "10414",
                        "avgRatingString": "4.2",
                        "totalRatingsString": "50+",
                        "sla": {
                            "deliveryTime": 46,
                            "lastMileTravel": 9.8,
                            "serviceability": "SERVICEABLE",
                            "slaString": "46 mins",
                            "lastMileTravelString": "9.8 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-07 02:00:00",
                            "opened": true
                        },
                        "badges": {},
                        "isOpen": true,
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {},
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "aggregatedDiscountInfoV3": {
                            "header": "₹150 OFF",
                            "subHeader": "ABOVE ₹499",
                            "discountTag": "FLAT DEAL"
                        },
                        "loyaltyDiscoverPresentationInfo": {
                            "logoCtx": {
                                "text": "BENEFITS",
                                "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                            },
                            "freedelMessage": "FREE DELIVERY"
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/the-dessert-zone-barathi-park-sai-baba-colony-coimbatore-666330",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                },
                {
                    "info": {
                        "id": "59208",
                        "name": "Pizza Paradise",
                        "cloudinaryImageId": "ttqnxto0f25varsbui07",
                        "locality": "Thadagam Road",
                        "areaName": "RS Puram",
                        "costForTwo": "₹300 for two",
                        "cuisines": [
                            "Pizzas"
                        ],
                        "avgRating": 4.3,
                        "veg": true,
                        "parentId": "8997",
                        "avgRatingString": "4.3",
                        "totalRatingsString": "5K+",
                        "sla": {
                            "deliveryTime": 59,
                            "lastMileTravel": 11.2,
                            "serviceability": "SERVICEABLE",
                            "slaString": "59 mins",
                            "lastMileTravelString": "11.2 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-06 22:30:00",
                            "opened": true
                        },
                        "badges": {
                            "imageBadges": [
                                {
                                    "imageId": "v1695133679/badges/Pure_Veg111.png",
                                    "description": "pureveg"
                                }
                            ]
                        },
                        "isOpen": true,
                        "aggregatedDiscountInfoV2": {},
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {
                                    "badgeObject": [
                                        {
                                            "attributes": {
                                                "description": "pureveg",
                                                "imageId": "v1695133679/badges/Pure_Veg111.png"
                                            }
                                        }
                                    ]
                                },
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/pizza-paradise-thadagam-road-rs-puram-coimbatore-59208",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                },
                {
                    "info": {
                        "id": "327245",
                        "name": "Delights by INOX",
                        "cloudinaryImageId": "b857fcf611707fedd3773eb02688f925",
                        "locality": "Prozone Mall",
                        "areaName": "Saravanampatty",
                        "costForTwo": "₹400 for two",
                        "cuisines": [
                            "Snacks"
                        ],
                        "avgRating": 4,
                        "parentId": "385095",
                        "avgRatingString": "4.0",
                        "totalRatingsString": "100+",
                        "sla": {
                            "deliveryTime": 45,
                            "lastMileTravel": 11.5,
                            "serviceability": "SERVICEABLE",
                            "slaString": "45 mins",
                            "lastMileTravelString": "11.5 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-06 23:00:00",
                            "opened": true
                        },
                        "badges": {
                            "imageBadges": [
                                {
                                    "imageId": "v1695133679/badges/Pure_Veg111.png",
                                    "description": "pureveg"
                                }
                            ]
                        },
                        "isOpen": true,
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {
                                    "badgeObject": [
                                        {
                                            "attributes": {
                                                "description": "pureveg",
                                                "imageId": "v1695133679/badges/Pure_Veg111.png"
                                            }
                                        }
                                    ]
                                },
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "aggregatedDiscountInfoV3": {
                            "header": "20% OFF",
                            "subHeader": "ABOVE ₹800",
                            "discountTag": "FLAT DEAL"
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/delights-by-inox-prozone-mall-saravanampatty-coimbatore-327245",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                },
                {
                    "info": {
                        "id": "415234",
                        "name": "Famous Jigarthanda",
                        "cloudinaryImageId": "zkcpx1qht2gl5f3qr5gh",
                        "locality": "Vivekanandar Street",
                        "areaName": "Ganapathy",
                        "costForTwo": "₹70 for two",
                        "cuisines": [
                            "Indian",
                            "Beverages"
                        ],
                        "avgRating": 4.3,
                        "parentId": "9195",
                        "avgRatingString": "4.3",
                        "totalRatingsString": "100+",
                        "sla": {
                            "deliveryTime": 41,
                            "lastMileTravel": 11.1,
                            "serviceability": "SERVICEABLE",
                            "slaString": "41 mins",
                            "lastMileTravelString": "11.1 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-06 23:59:00",
                            "opened": true
                        },
                        "badges": {},
                        "isOpen": true,
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {},
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "aggregatedDiscountInfoV3": {
                            "header": "₹100 OFF",
                            "subHeader": "ABOVE ₹999",
                            "discountTag": "FLAT DEAL"
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/famous-jigarthanda-vivekanandar-street-ganapathy-coimbatore-415234",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                },
                {
                    "info": {
                        "id": "575069",
                        "name": "Mehfil by Behrouz",
                        "cloudinaryImageId": "2b579171cefc545ce6479e21c0016798",
                        "locality": "Mettupalayam road",
                        "areaName": "Ranganathapuram",
                        "costForTwo": "₹700 for two",
                        "cuisines": [
                            "Biryani",
                            "North Indian",
                            "Kebabs",
                            "Mughlai",
                            "Lucknowi",
                            "Hyderabadi",
                            "Desserts",
                            "Beverages"
                        ],
                        "avgRating": 4.2,
                        "parentId": "344904",
                        "avgRatingString": "4.2",
                        "totalRatingsString": "20+",
                        "sla": {
                            "deliveryTime": 76,
                            "lastMileTravel": 10.2,
                            "serviceability": "SERVICEABLE",
                            "slaString": "76 mins",
                            "lastMileTravelString": "10.2 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-06 23:59:00",
                            "opened": true
                        },
                        "badges": {},
                        "isOpen": true,
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {},
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "aggregatedDiscountInfoV3": {
                            "header": "₹125 OFF",
                            "subHeader": "ABOVE ₹599",
                            "discountTag": "FLAT DEAL"
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/mehfil-by-behrouz-mettupalayam-road-ranganathapuram-coimbatore-575069",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                },
                {
                    "info": {
                        "id": "450462",
                        "name": "Gourmet Ice Cream Cakes by Baskin Robbins",
                        "cloudinaryImageId": "d679c532ca07a6f3fd6d89d603861412",
                        "locality": "BROOKEFIELDS MALL",
                        "areaName": "BROOKEFIELDS MALL",
                        "costForTwo": "₹250 for two",
                        "cuisines": [
                            "Desserts",
                            "Ice Cream"
                        ],
                        "avgRating": 5,
                        "veg": true,
                        "parentId": "21932",
                        "avgRatingString": "5.0",
                        "totalRatingsString": "10+",
                        "sla": {
                            "deliveryTime": 47,
                            "lastMileTravel": 11.2,
                            "serviceability": "SERVICEABLE",
                            "slaString": "47 mins",
                            "lastMileTravelString": "11.2 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-06 22:30:00",
                            "opened": true
                        },
                        "badges": {
                            "imageBadges": [
                                {
                                    "imageId": "v1695133679/badges/Pure_Veg111.png",
                                    "description": "pureveg"
                                }
                            ]
                        },
                        "isOpen": true,
                        "aggregatedDiscountInfoV2": {},
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {
                                    "badgeObject": [
                                        {
                                            "attributes": {
                                                "description": "pureveg",
                                                "imageId": "v1695133679/badges/Pure_Veg111.png"
                                            }
                                        }
                                    ]
                                },
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/gourmet-ice-cream-cakes-by-baskin-robbins-brookefields-mall-coimbatore-450462",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                },
                {
                    "info": {
                        "id": "756261",
                        "name": "Crusto's - Cheese Burst Pizza",
                        "cloudinaryImageId": "c77fe42b7997c566f491e84b540701ca",
                        "locality": "Ramanandha Nagar",
                        "areaName": "Saravanampatty",
                        "costForTwo": "₹300 for two",
                        "cuisines": [
                            "Pizzas",
                            "Pastas",
                            "Fast Food",
                            "Snacks",
                            "Beverages"
                        ],
                        "avgRating": 4.6,
                        "parentId": "268955",
                        "avgRatingString": "4.6",
                        "totalRatingsString": "50+",
                        "sla": {
                            "deliveryTime": 45,
                            "lastMileTravel": 10.2,
                            "serviceability": "SERVICEABLE",
                            "slaString": "45 mins",
                            "lastMileTravelString": "10.2 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-06 23:59:00",
                            "opened": true
                        },
                        "badges": {},
                        "isOpen": true,
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {},
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "aggregatedDiscountInfoV3": {
                            "header": "₹125 OFF",
                            "subHeader": "ABOVE ₹249",
                            "discountTag": "FLAT DEAL"
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "isNewlyOnboarded": true,
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/crustos-cheese-burst-pizza-ramanandha-nagar-saravanampatty-coimbatore-756261",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                },
                {
                    "info": {
                        "id": "666312",
                        "name": "Cupcake Bliss Cake & Desserts",
                        "cloudinaryImageId": "40f193d8b23afb2988489dac1258962f",
                        "locality": "Barathi Park",
                        "areaName": "Sai Baba Colony",
                        "costForTwo": "₹200 for two",
                        "cuisines": [
                            "Bakery",
                            "Desserts",
                            "Ice Cream",
                            "Beverages"
                        ],
                        "avgRating": 3.9,
                        "parentId": "66732",
                        "avgRatingString": "3.9",
                        "totalRatingsString": "20+",
                        "sla": {
                            "deliveryTime": 49,
                            "lastMileTravel": 9.8,
                            "serviceability": "SERVICEABLE",
                            "slaString": "49 mins",
                            "lastMileTravelString": "9.8 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-07 02:00:00",
                            "opened": true
                        },
                        "badges": {},
                        "isOpen": true,
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {},
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "aggregatedDiscountInfoV3": {
                            "header": "₹150 OFF",
                            "subHeader": "ABOVE ₹499",
                            "discountTag": "FLAT DEAL"
                        },
                        "loyaltyDiscoverPresentationInfo": {
                            "logoCtx": {
                                "text": "BENEFITS",
                                "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                            },
                            "freedelMessage": "FREE DELIVERY"
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/cupcake-bliss-cake-and-desserts-barathi-park-sai-baba-colony-coimbatore-666312",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                },
                {
                    "info": {
                        "id": "666311",
                        "name": "Sundae Everyday Ice Creams",
                        "cloudinaryImageId": "438ceb57212cc8476461e9753643126f",
                        "locality": "Barathi Park",
                        "areaName": "Sai Baba Colony",
                        "costForTwo": "₹100 for two",
                        "cuisines": [
                            "Beverages",
                            "Ice Cream",
                            "Desserts"
                        ],
                        "avgRating": 3.4,
                        "veg": true,
                        "parentId": "20021",
                        "avgRatingString": "3.4",
                        "totalRatingsString": "20+",
                        "sla": {
                            "deliveryTime": 43,
                            "lastMileTravel": 9.8,
                            "serviceability": "SERVICEABLE",
                            "slaString": "43 mins",
                            "lastMileTravelString": "9.8 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-07 02:00:00",
                            "opened": true
                        },
                        "badges": {},
                        "isOpen": true,
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {},
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "aggregatedDiscountInfoV3": {
                            "header": "₹150 OFF",
                            "subHeader": "ABOVE ₹499",
                            "discountTag": "FLAT DEAL"
                        },
                        "loyaltyDiscoverPresentationInfo": {
                            "logoCtx": {
                                "text": "BENEFITS",
                                "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                            },
                            "freedelMessage": "FREE DELIVERY"
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/sundae-everyday-ice-creams-barathi-park-sai-baba-colony-coimbatore-666311",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                },
                {
                    "info": {
                        "id": "666305",
                        "name": "WarmOven Cake & Desserts",
                        "cloudinaryImageId": "e938fb5f416cc2c28b4b519cf27b04cc",
                        "locality": "Barathi Park",
                        "areaName": "Sai Baba Colony",
                        "costForTwo": "₹200 for two",
                        "cuisines": [
                            "Bakery",
                            "Ice Cream",
                            "Desserts"
                        ],
                        "avgRating": 3.9,
                        "parentId": "12853",
                        "avgRatingString": "3.9",
                        "totalRatingsString": "50+",
                        "sla": {
                            "deliveryTime": 46,
                            "lastMileTravel": 9.8,
                            "serviceability": "SERVICEABLE",
                            "slaString": "46 mins",
                            "lastMileTravelString": "9.8 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-07 02:00:00",
                            "opened": true
                        },
                        "badges": {},
                        "isOpen": true,
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {},
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "aggregatedDiscountInfoV3": {
                            "header": "₹150 OFF",
                            "subHeader": "ABOVE ₹499",
                            "discountTag": "FLAT DEAL"
                        },
                        "loyaltyDiscoverPresentationInfo": {
                            "logoCtx": {
                                "text": "BENEFITS",
                                "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                            },
                            "freedelMessage": "FREE DELIVERY"
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/warmoven-cake-and-desserts-barathi-park-sai-baba-colony-coimbatore-666305",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                },
                {
                    "info": {
                        "id": "666337",
                        "name": "Burger It Up",
                        "cloudinaryImageId": "b1d030eef349d4c44a6aacb4cd0c9ba5",
                        "locality": "Coimbatore Corporation Ward-22",
                        "areaName": "Sai Baba Colony",
                        "costForTwo": "₹200 for two",
                        "cuisines": [
                            "Burgers",
                            "Beverages",
                            "Desserts",
                            "American",
                            "Cafe"
                        ],
                        "avgRating": 3.9,
                        "parentId": "7864",
                        "avgRatingString": "3.9",
                        "totalRatingsString": "20+",
                        "sla": {
                            "deliveryTime": 46,
                            "lastMileTravel": 9.8,
                            "serviceability": "SERVICEABLE",
                            "slaString": "46 mins",
                            "lastMileTravelString": "9.8 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-07 02:00:00",
                            "opened": true
                        },
                        "badges": {},
                        "isOpen": true,
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {},
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "aggregatedDiscountInfoV3": {
                            "header": "₹150 OFF",
                            "subHeader": "ABOVE ₹499",
                            "discountTag": "FLAT DEAL"
                        },
                        "loyaltyDiscoverPresentationInfo": {
                            "logoCtx": {
                                "text": "BENEFITS",
                                "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                            },
                            "freedelMessage": "FREE DELIVERY"
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/burger-it-up-corporation-ward-22-sai-baba-colony-coimbatore-666337",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                },
                {
                    "info": {
                        "id": "666329",
                        "name": "Momo Zone - The Momo Company",
                        "cloudinaryImageId": "b1d030eef349d4c44a6aacb4cd0c9ba5",
                        "locality": "Barathi Park",
                        "areaName": "Sai Baba Colony",
                        "costForTwo": "₹200 for two",
                        "cuisines": [
                            "Chinese",
                            "Tibetan",
                            "Fast Food"
                        ],
                        "avgRating": 4.1,
                        "parentId": "382343",
                        "avgRatingString": "4.1",
                        "totalRatingsString": "50+",
                        "sla": {
                            "deliveryTime": 47,
                            "lastMileTravel": 9.8,
                            "serviceability": "SERVICEABLE",
                            "slaString": "47 mins",
                            "lastMileTravelString": "9.8 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-07 02:00:00",
                            "opened": true
                        },
                        "badges": {},
                        "isOpen": true,
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {},
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "aggregatedDiscountInfoV3": {
                            "header": "₹150 OFF",
                            "subHeader": "ABOVE ₹499",
                            "discountTag": "FLAT DEAL"
                        },
                        "loyaltyDiscoverPresentationInfo": {
                            "logoCtx": {
                                "text": "BENEFITS",
                                "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                            },
                            "freedelMessage": "FREE DELIVERY"
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/momo-zone-the-momo-company-barathi-park-sai-baba-colony-coimbatore-666329",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                },
                {
                    "info": {
                        "id": "706961",
                        "name": "Hotel Sri Lalitha's",
                        "cloudinaryImageId": "f34657e4f398eec0e714971b58f8be69",
                        "locality": "Cheran Nagar",
                        "areaName": "vadamadurai thudiyalur",
                        "costForTwo": "₹400 for two",
                        "cuisines": [
                            "Indian",
                            "South Indian"
                        ],
                        "avgRating": 4.4,
                        "veg": true,
                        "parentId": "422781",
                        "avgRatingString": "4.4",
                        "totalRatingsString": "50+",
                        "sla": {
                            "deliveryTime": 31,
                            "lastMileTravel": 5.6,
                            "serviceability": "SERVICEABLE",
                            "slaString": "31 mins",
                            "lastMileTravelString": "5.6 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-06 22:00:00",
                            "opened": true
                        },
                        "badges": {},
                        "isOpen": true,
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {},
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "loyaltyDiscoverPresentationInfo": {
                            "logoCtx": {
                                "text": "BENEFITS",
                                "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                            },
                            "freedelMessage": "FREE DELIVERY"
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/hotel-sri-lalithas-cheran-nagar-vadamadurai-thudiyalur-coimbatore-706961",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                },
                {
                    "info": {
                        "id": "785369",
                        "name": "Delight Dhaba",
                        "cloudinaryImageId": "85e6e427481332842d4413983ef45bdd",
                        "locality": "Thudiyalur Road",
                        "areaName": "Saravanampatti",
                        "costForTwo": "₹300 for two",
                        "cuisines": [
                            "Snacks",
                            "North Indian"
                        ],
                        "avgRating": 4,
                        "parentId": "70531",
                        "avgRatingString": "4.0",
                        "totalRatingsString": "50+",
                        "sla": {
                            "deliveryTime": 34,
                            "lastMileTravel": 7,
                            "serviceability": "SERVICEABLE",
                            "slaString": "34 mins",
                            "lastMileTravelString": "7.0 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-06 23:00:00",
                            "opened": true
                        },
                        "badges": {},
                        "isOpen": true,
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {},
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "aggregatedDiscountInfoV3": {
                            "header": "60% OFF",
                            "subHeader": "UPTO ₹120"
                        },
                        "loyaltyDiscoverPresentationInfo": {
                            "logoCtx": {
                                "text": "BENEFITS",
                                "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                            },
                            "freedelMessage": "FREE DELIVERY"
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "isNewlyOnboarded": true,
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/delight-dhaba-thudiyalur-road-saravanampatti-coimbatore-785369",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                },
                {
                    "info": {
                        "id": "69595",
                        "name": "A1 Chips & Snacks",
                        "cloudinaryImageId": "hdidq3wy7z3vkt05qwbr",
                        "locality": "Thudiyalur Road",
                        "areaName": "Saravanampatty",
                        "costForTwo": "₹200 for two",
                        "cuisines": [
                            "Snacks",
                            "Sweets",
                            "Desserts"
                        ],
                        "avgRating": 4.7,
                        "veg": true,
                        "parentId": "25074",
                        "avgRatingString": "4.7",
                        "totalRatingsString": "1K+",
                        "sla": {
                            "deliveryTime": 29,
                            "lastMileTravel": 8.5,
                            "serviceability": "SERVICEABLE",
                            "slaString": "29 mins",
                            "lastMileTravelString": "8.5 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-06 21:00:00",
                            "opened": true
                        },
                        "badges": {},
                        "isOpen": true,
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {},
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "loyaltyDiscoverPresentationInfo": {
                            "logoCtx": {
                                "text": "BENEFITS",
                                "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                            },
                            "freedelMessage": "FREE DELIVERY"
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/a1-chips-and-snacks-thudiyalur-road-saravanampatty-coimbatore-69595",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                },
                {
                    "info": {
                        "id": "57020",
                        "name": "Call For Cake",
                        "cloudinaryImageId": "rsdtyparhgp77l2r6djp",
                        "locality": "Vcs Nagar",
                        "areaName": "Thudiyalur",
                        "costForTwo": "₹150 for two",
                        "cuisines": [
                            "Desserts",
                            "Snacks",
                            "Bakery"
                        ],
                        "avgRating": 4.4,
                        "parentId": "5834",
                        "avgRatingString": "4.4",
                        "totalRatingsString": "5K+",
                        "sla": {
                            "deliveryTime": 30,
                            "lastMileTravel": 4.4,
                            "serviceability": "SERVICEABLE",
                            "slaString": "30 mins",
                            "lastMileTravelString": "4.4 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-06 21:00:00",
                            "opened": true
                        },
                        "badges": {},
                        "isOpen": true,
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {},
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "aggregatedDiscountInfoV3": {
                            "header": "20% OFF",
                            "subHeader": "ABOVE ₹1000",
                            "discountTag": "FLAT DEAL"
                        },
                        "loyaltyDiscoverPresentationInfo": {
                            "logoCtx": {
                                "text": "BENEFITS",
                                "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                            },
                            "freedelMessage": "FREE DELIVERY"
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/call-for-cake-vcs-nagar-thudiyalur-coimbatore-57020",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                },
                {
                    "info": {
                        "id": "785362",
                        "name": "Delight Restaurant",
                        "cloudinaryImageId": "a12ac42bcdfbf70c1a468ce8d41c012b",
                        "locality": "Tank Street",
                        "areaName": "Saravanampatti",
                        "costForTwo": "₹200 for two",
                        "cuisines": [
                            "South Indian",
                            "Biryani",
                            "Snacks"
                        ],
                        "avgRating": 4.2,
                        "parentId": "3356",
                        "avgRatingString": "4.2",
                        "totalRatingsString": "20+",
                        "sla": {
                            "deliveryTime": 33,
                            "lastMileTravel": 7,
                            "serviceability": "SERVICEABLE",
                            "slaString": "33 mins",
                            "lastMileTravelString": "7.0 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-06 23:00:00",
                            "opened": true
                        },
                        "badges": {},
                        "isOpen": true,
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {},
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "aggregatedDiscountInfoV3": {
                            "header": "60% OFF",
                            "subHeader": "UPTO ₹120"
                        },
                        "loyaltyDiscoverPresentationInfo": {
                            "logoCtx": {
                                "text": "BENEFITS",
                                "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                            },
                            "freedelMessage": "FREE DELIVERY"
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "isNewlyOnboarded": true,
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/delight-restaurant-tank-street-saravanampatti-coimbatore-785362",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                },
                {
                    "info": {
                        "id": "165117",
                        "name": "Original nellai lala periya lala sweets",
                        "cloudinaryImageId": "xu88njgj8tb0l7wkcuiv",
                        "locality": "Thangam Complex",
                        "areaName": "Saravanampatty",
                        "costForTwo": "₹100 for two",
                        "cuisines": [
                            "Sweets"
                        ],
                        "avgRating": 4.4,
                        "veg": true,
                        "parentId": "8178",
                        "avgRatingString": "4.4",
                        "totalRatingsString": "500+",
                        "sla": {
                            "deliveryTime": 34,
                            "lastMileTravel": 10,
                            "serviceability": "SERVICEABLE",
                            "slaString": "34 mins",
                            "lastMileTravelString": "10.0 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-06 22:00:00",
                            "opened": true
                        },
                        "badges": {
                            "imageBadges": [
                                {
                                    "imageId": "v1695133679/badges/Pure_Veg111.png",
                                    "description": "pureveg"
                                }
                            ]
                        },
                        "isOpen": true,
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {
                                    "badgeObject": [
                                        {
                                            "attributes": {
                                                "description": "pureveg",
                                                "imageId": "v1695133679/badges/Pure_Veg111.png"
                                            }
                                        }
                                    ]
                                },
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "loyaltyDiscoverPresentationInfo": {
                            "logoCtx": {
                                "text": "BENEFITS",
                                "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                            },
                            "freedelMessage": "FREE DELIVERY"
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/original-nellai-lala-periya-lala-sweets-thangam-complex-saravanampatty-coimbatore-165117",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                },
                {
                    "info": {
                        "id": "94987",
                        "name": "Mohabbath Restaurant",
                        "cloudinaryImageId": "nqkmcaxxhptnlmnvtpvu",
                        "locality": "Sakthi Road",
                        "areaName": "Saravanampatty",
                        "costForTwo": "₹200 for two",
                        "cuisines": [
                            "Kerala",
                            "South Indian",
                            "North Indian",
                            "Biryani",
                            "Beverages"
                        ],
                        "avgRating": 4.2,
                        "parentId": "18286",
                        "avgRatingString": "4.2",
                        "totalRatingsString": "5K+",
                        "sla": {
                            "deliveryTime": 37,
                            "lastMileTravel": 9.4,
                            "serviceability": "SERVICEABLE",
                            "slaString": "37 mins",
                            "lastMileTravelString": "9.4 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-06 22:30:00",
                            "opened": true
                        },
                        "badges": {},
                        "isOpen": true,
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {},
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "loyaltyDiscoverPresentationInfo": {
                            "logoCtx": {
                                "text": "BENEFITS",
                                "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                            },
                            "freedelMessage": "FREE DELIVERY"
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/mohabbath-restaurant-sakthi-road-saravanampatty-coimbatore-94987",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                },
                {
                    "info": {
                        "id": "434642",
                        "name": "Aagaaram Cafe",
                        "cloudinaryImageId": "z2xadgkysqlg8omkpqf1",
                        "locality": "Udayampalayam Road",
                        "areaName": "Kavundampalayam",
                        "costForTwo": "₹200 for two",
                        "cuisines": [
                            "South Indian"
                        ],
                        "avgRating": 4.2,
                        "veg": true,
                        "parentId": "262494",
                        "avgRatingString": "4.2",
                        "totalRatingsString": "1K+",
                        "sla": {
                            "deliveryTime": 39,
                            "lastMileTravel": 5,
                            "serviceability": "SERVICEABLE",
                            "slaString": "39 mins",
                            "lastMileTravelString": "5.0 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-06 22:00:00",
                            "opened": true
                        },
                        "badges": {},
                        "isOpen": true,
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {},
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "aggregatedDiscountInfoV3": {
                            "header": "₹100 OFF",
                            "subHeader": "ABOVE ₹249",
                            "discountTag": "FLAT DEAL"
                        },
                        "loyaltyDiscoverPresentationInfo": {
                            "logoCtx": {
                                "text": "BENEFITS",
                                "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                            },
                            "freedelMessage": "FREE DELIVERY"
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/aagaaram-cafe-udayampalayam-road-kavundampalayam-coimbatore-434642",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                },
                {
                    "info": {
                        "id": "90250",
                        "name": "KNP Chicken Stall",
                        "cloudinaryImageId": "igk2id61pniv4v7lebvr",
                        "locality": "Thondamuthur Road",
                        "areaName": "Vadavalli",
                        "costForTwo": "₹200 for two",
                        "cuisines": [
                            "Indian"
                        ],
                        "avgRating": 4.3,
                        "parentId": "18302",
                        "avgRatingString": "4.3",
                        "totalRatingsString": "1K+",
                        "sla": {
                            "deliveryTime": 36,
                            "lastMileTravel": 11.5,
                            "serviceability": "SERVICEABLE",
                            "slaString": "36 mins",
                            "lastMileTravelString": "11.5 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-06 23:15:00",
                            "opened": true
                        },
                        "badges": {},
                        "isOpen": true,
                        "aggregatedDiscountInfoV2": {},
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {},
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/knp-chicken-stall-thondamuthur-road-vadavalli-coimbatore-90250",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                },
                {
                    "info": {
                        "id": "806732",
                        "name": "Midhavai Hotal",
                        "cloudinaryImageId": "f1bc9ddf53de574cdc35ab2f717df234",
                        "locality": "Narasimanaickenpalayam",
                        "areaName": "Periyanaickenpalayam",
                        "costForTwo": "₹250 for two",
                        "cuisines": [
                            "South Indian",
                            "Biryani",
                            "Snacks"
                        ],
                        "avgRating": 4.4,
                        "parentId": "481394",
                        "avgRatingString": "4.4",
                        "totalRatingsString": "10+",
                        "sla": {
                            "deliveryTime": 27,
                            "lastMileTravel": 1.3,
                            "serviceability": "SERVICEABLE",
                            "slaString": "27 mins",
                            "lastMileTravelString": "1.3 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-06 23:00:00",
                            "opened": true
                        },
                        "badges": {},
                        "isOpen": true,
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {},
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "loyaltyDiscoverPresentationInfo": {
                            "logoCtx": {
                                "text": "BENEFITS",
                                "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                            },
                            "freedelMessage": "FREE DELIVERY"
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "isNewlyOnboarded": true,
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/midhavai-hotal-narasimanaickenpalayam-periyanaickenpalayam-coimbatore-806732",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                },
                {
                    "info": {
                        "id": "616633",
                        "name": "Madurai Jigarthanda",
                        "cloudinaryImageId": "pte0rgdpgmpgeljxy6rw",
                        "locality": "Savanampatti",
                        "areaName": "Saravanampatty",
                        "costForTwo": "₹150 for two",
                        "cuisines": [
                            "Beverages"
                        ],
                        "avgRating": 3.8,
                        "veg": true,
                        "parentId": "5828",
                        "avgRatingString": "3.8",
                        "totalRatingsString": "7",
                        "sla": {
                            "deliveryTime": 34,
                            "lastMileTravel": 8.8,
                            "serviceability": "SERVICEABLE",
                            "slaString": "34 mins",
                            "lastMileTravelString": "8.8 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-06 22:30:00",
                            "opened": true
                        },
                        "badges": {},
                        "isOpen": true,
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {},
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "loyaltyDiscoverPresentationInfo": {
                            "logoCtx": {
                                "text": "BENEFITS",
                                "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                            },
                            "freedelMessage": "FREE DELIVERY"
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/madurai-jigarthanda-savanampatti-saravanampatty-coimbatore-616633",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                },
                {
                    "info": {
                        "id": "753023",
                        "name": "Baker's Table",
                        "cloudinaryImageId": "fcee676df41abe3fa8b474ece9d2b77d",
                        "locality": "Thudiyalur Rd",
                        "areaName": "Saravanampatti",
                        "costForTwo": "₹250 for two",
                        "cuisines": [
                            "Beverages"
                        ],
                        "parentId": "40291",
                        "avgRatingString": "NEW",
                        "sla": {
                            "deliveryTime": 39,
                            "lastMileTravel": 8.3,
                            "serviceability": "SERVICEABLE",
                            "slaString": "39 mins",
                            "lastMileTravelString": "8.3 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-06 21:00:00",
                            "opened": true
                        },
                        "badges": {},
                        "isOpen": true,
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {},
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "loyaltyDiscoverPresentationInfo": {
                            "logoCtx": {
                                "text": "BENEFITS",
                                "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                            },
                            "freedelMessage": "FREE DELIVERY"
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "isNewlyOnboarded": true,
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/bakers-table-thudiyalur-rd-saravanampatti-coimbatore-753023",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                },
                {
                    "info": {
                        "id": "123014",
                        "name": "Burger Bytes",
                        "cloudinaryImageId": "y7q5guu3rqghrn5wtwtl",
                        "locality": "Vinyakapuram",
                        "areaName": "Saravanampatty",
                        "costForTwo": "₹250 for two",
                        "cuisines": [
                            "Snacks"
                        ],
                        "avgRating": 4,
                        "parentId": "8936",
                        "avgRatingString": "4.0",
                        "totalRatingsString": "500+",
                        "sla": {
                            "deliveryTime": 39,
                            "lastMileTravel": 9.2,
                            "serviceability": "SERVICEABLE",
                            "slaString": "39 mins",
                            "lastMileTravelString": "9.2 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-06 23:00:00",
                            "opened": true
                        },
                        "badges": {},
                        "isOpen": true,
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {},
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "aggregatedDiscountInfoV3": {
                            "header": "₹125 OFF",
                            "subHeader": "ABOVE ₹999",
                            "discountTag": "FLAT DEAL"
                        },
                        "loyaltyDiscoverPresentationInfo": {
                            "logoCtx": {
                                "text": "BENEFITS",
                                "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                            },
                            "freedelMessage": "FREE DELIVERY"
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/burger-bytes-vinyakapuram-saravanampatty-coimbatore-123014",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                },
                {
                    "info": {
                        "id": "627558",
                        "name": "Juice World",
                        "cloudinaryImageId": "cbq6k0eg5z2wwb5rfqft",
                        "locality": "Sathy Road",
                        "areaName": "Saravanampatty",
                        "costForTwo": "₹300 for two",
                        "cuisines": [
                            "Desserts",
                            "Fast Food"
                        ],
                        "avgRating": 4.5,
                        "veg": true,
                        "parentId": "111971",
                        "avgRatingString": "4.5",
                        "totalRatingsString": "50+",
                        "sla": {
                            "deliveryTime": 37,
                            "lastMileTravel": 10,
                            "serviceability": "SERVICEABLE",
                            "slaString": "37 mins",
                            "lastMileTravelString": "10.0 km",
                            "iconType": "ICON_TYPE_EMPTY"
                        },
                        "availability": {
                            "nextCloseTime": "2024-01-06 21:50:00",
                            "opened": true
                        },
                        "badges": {
                            "imageBadges": [
                                {
                                    "imageId": "v1695133679/badges/Pure_Veg111.png",
                                    "description": "pureveg"
                                }
                            ]
                        },
                        "isOpen": true,
                        "type": "F",
                        "badgesV2": {
                            "entityBadges": {
                                "imageBased": {
                                    "badgeObject": [
                                        {
                                            "attributes": {
                                                "description": "pureveg",
                                                "imageId": "v1695133679/badges/Pure_Veg111.png"
                                            }
                                        }
                                    ]
                                },
                                "textBased": {},
                                "textExtendedBadges": {}
                            }
                        },
                        "loyaltyDiscoverPresentationInfo": {
                            "logoCtx": {
                                "text": "BENEFITS",
                                "logo": "v1634558776/swiggy_one/OneLogo_3x.png"
                            },
                            "freedelMessage": "FREE DELIVERY"
                        },
                        "orderabilityCommunication": {
                            "title": {},
                            "subTitle": {},
                            "message": {},
                            "customIcon": {}
                        },
                        "differentiatedUi": {
                            "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                            "differentiatedUiMediaDetails": {
                                "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                "lottie": {},
                                "video": {}
                            }
                        },
                        "reviewsSummary": {},
                        "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                        "restaurantOfferPresentationInfo": {}
                    },
                    "analytics": {
                        "context": "seo-data-ea116053-9832-4f78-abd9-b05da61627d9"
                    },
                    "cta": {
                        "link": "https://www.swiggy.com/restaurants/juice-world-sathy-road-saravanampatty-coimbatore-627558",
                        "text": "RESTAURANT_MENU",
                        "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                }
                ],
                "theme": "SeoRestaurantListingGridWidget"
              }
            }
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.seo.widgets.v1.ShowMoreButton",
            "message": "Show More",
            "id": "show_more_button"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.seo.widgets.v1.BrandsContent",
            "title": "Best Places to Eat Across Cities",
            "brands": [
              {
                "text": "Best Restaurants in Bangalore",
                "link": "https://www.swiggy.com/city/bangalore/best-restaurants"
              },
              {
                "text": "Best Restaurants in Pune",
                "link": "https://www.swiggy.com/city/pune/best-restaurants"
              },
              {
                "text": "Best Restaurants in Mumbai",
                "link": "https://www.swiggy.com/city/mumbai/best-restaurants"
              },
              {
                "text": "Best Restaurants in Delhi",
                "link": "https://www.swiggy.com/city/delhi/best-restaurants"
              },
              {
                "text": "Best Restaurants in Hyderabad",
                "link": "https://www.swiggy.com/city/hyderabad/best-restaurants"
              },
              {
                "text": "Best Restaurants in Kolkata",
                "link": "https://www.swiggy.com/city/kolkata/best-restaurants"
              },
              {
                "text": "Best Restaurants in Chennai",
                "link": "https://www.swiggy.com/city/chennai/best-restaurants"
              },
              {
                "text": "Best Restaurants in Chandigarh",
                "link": "https://www.swiggy.com/city/chandigarh/best-restaurants"
              },
              {
                "text": "Best Restaurants in Ahmedabad",
                "link": "https://www.swiggy.com/city/ahmedabad/best-restaurants"
              },
              {
                "text": "Best Restaurants in Jaipur",
                "link": "https://www.swiggy.com/city/jaipur/best-restaurants"
              },
              {
                "text": "Best Restaurants in Nagpur",
                "link": "https://www.swiggy.com/city/nagpur/best-restaurants"
              },
              {
                "text": "Best Restaurants in Bhubaneswar",
                "link": "https://www.swiggy.com/city/bhubaneswar/best-restaurants"
              },
              {
                "text": "Best Restaurants in Kochi",
                "link": "https://www.swiggy.com/city/kochi/best-restaurants"
              },
              {
                "text": "Best Restaurants in Surat",
                "link": "https://www.swiggy.com/city/surat/best-restaurants"
              },
              {
                "text": "Best Restaurants in Dehradun",
                "link": "https://www.swiggy.com/city/dehradun/best-restaurants"
              },
              {
                "text": "Best Restaurants in Ludhiana",
                "link": "https://www.swiggy.com/city/ludhiana/best-restaurants"
              },
              {
                "text": "Best Restaurants in Patna",
                "link": "https://www.swiggy.com/city/patna/best-restaurants"
              },
              {
                "text": "Best Restaurants in Mangaluru",
                "link": "https://www.swiggy.com/city/mangaluru/best-restaurants"
              },
              {
                "text": "Best Restaurants in Bhopal",
                "link": "https://www.swiggy.com/city/bhopal/best-restaurants"
              },
              {
                "text": "Best Restaurants in Gurgaon",
                "link": "https://www.swiggy.com/city/gurgaon/best-restaurants"
              },
              {
                "text": "Best Restaurants in Coimbatore",
                "link": "https://www.swiggy.com/city/coimbatore/best-restaurants"
              },
              {
                "text": "Best Restaurants in Agra",
                "link": "https://www.swiggy.com/city/agra/best-restaurants"
              },
              {
                "text": "Best Restaurants in Noida",
                "link": "https://www.swiggy.com/city/noida/best-restaurants"
              },
              {
                "text": "Best Restaurants in Vijayawada",
                "link": "https://www.swiggy.com/city/vijayawada/best-restaurants"
              },
              {
                "text": "Best Restaurants in Guwahati",
                "link": "https://www.swiggy.com/city/guwahati/best-restaurants"
              },
              {
                "text": "Best Restaurants in Mysore",
                "link": "https://www.swiggy.com/city/mysore/best-restaurants"
              },
              {
                "text": "Best Restaurants in Pondicherry",
                "link": "https://www.swiggy.com/city/pondicherry/best-restaurants"
              },
              {
                "text": "Best Restaurants in Thiruvananthapuram",
                "link": "https://www.swiggy.com/city/thiruvananthapuram/best-restaurants"
              },
              {
                "text": "Best Restaurants in Ranchi",
                "link": "https://www.swiggy.com/city/ranchi/best-restaurants"
              },
              {
                "text": "Best Restaurants in Vizag",
                "link": "https://www.swiggy.com/city/vizag/best-restaurants"
              },
              {
                "text": "Best Restaurants in Udaipur",
                "link": "https://www.swiggy.com/city/udaipur/best-restaurants"
              },
              {
                "text": "Best Restaurants in Vadodara",
                "link": "https://www.swiggy.com/city/vadodara/best-restaurants"
              }
            ],
            "id": "restaurant_near_me_links"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.seo.widgets.v1.BrandsContent",
            "title": "Best Cuisines Near Me",
            "brands": [
              {
                "text": "Chinese Restaurant Near Me",
                "link": "https://www.swiggy.com/chinese-restaurants-near-me"
              },
              {
                "text": "South Indian Restaurant Near Me",
                "link": "https://www.swiggy.com/south-indian-restaurants-near-me"
              },
              {
                "text": "Indian Restaurant Near Me",
                "link": "https://www.swiggy.com/indian-restaurants-near-me"
              },
              {
                "text": "Kerala Restaurant Near Me",
                "link": "https://www.swiggy.com/kerala-restaurants-near-me"
              },
              {
                "text": "Korean Restaurant Near Me",
                "link": "https://www.swiggy.com/korean-restaurants-near-me"
              },
              {
                "text": "North Indian Restaurant Near Me",
                "link": "https://www.swiggy.com/north-indian-restaurants-near-me"
              },
              {
                "text": "Seafood Restaurant Near Me",
                "link": "https://www.swiggy.com/seafood-restaurants-near-me"
              },
              {
                "text": "Bengali Restaurant Near Me",
                "link": "https://www.swiggy.com/bengali-restaurants-near-me"
              },
              {
                "text": "Punjabi Restaurant Near Me",
                "link": "https://www.swiggy.com/punjabi-restaurants-near-me"
              },
              {
                "text": "Italian Restaurant Near Me",
                "link": "https://www.swiggy.com/italian-restaurants-near-me"
              },
              {
                "text": "Andhra Restaurant Near Me",
                "link": "https://www.swiggy.com/andhra-restaurants-near-me"
              },
              {
                "text": "Biryani Restaurant Near Me",
                "link": "https://www.swiggy.com/biryani-restaurants-near-me"
              },
              {
                "text": "Japanese Restaurant Near Me",
                "link": "https://www.swiggy.com/japanese-restaurants-near-me"
              },
              {
                "text": "Arabian Restaurant Near Me",
                "link": "https://www.swiggy.com/arabian-restaurants-near-me"
              },
              {
                "text": "Fast Food Restaurant Near Me",
                "link": "https://www.swiggy.com/fast-food-restaurants-near-me"
              },
              {
                "text": "Jain Restaurant Near Me",
                "link": "https://www.swiggy.com/jain-restaurants-near-me"
              },
              {
                "text": "Gujarati Restaurant Near Me",
                "link": "https://www.swiggy.com/gujarati-restaurants-near-me"
              },
              {
                "text": "Thai Restaurant Near Me",
                "link": "https://www.swiggy.com/thai-restaurants-near-me"
              },
              {
                "text": "Pizzas Restaurant Near Me",
                "link": "https://www.swiggy.com/pizzas-restaurants-near-me"
              },
              {
                "text": "Asian Restaurant Near Me",
                "link": "https://www.swiggy.com/asian-restaurants-near-me"
              },
              {
                "text": "Cafe Restaurant Near Me",
                "link": "https://www.swiggy.com/cafe-restaurants-near-me"
              },
              {
                "text": "Continental Restaurant Near Me",
                "link": "https://www.swiggy.com/continental-restaurants-near-me"
              },
              {
                "text": "Mexican Restaurant Near Me",
                "link": "https://www.swiggy.com/mexican-restaurants-near-me"
              },
              {
                "text": "Mughlai Restaurant Near Me",
                "link": "https://www.swiggy.com/mughlai-restaurants-near-me"
              },
              {
                "text": "Sushi Restaurant Near Me",
                "link": "https://www.swiggy.com/sushi-restaurants-near-me"
              },
              {
                "text": "Mangalorean Restaurant Near Me",
                "link": "https://www.swiggy.com/mangalorean-restaurants-near-me"
              },
              {
                "text": "Tibetan Restaurant Near Me",
                "link": "https://www.swiggy.com/tibetan-restaurants-near-me"
              },
              {
                "text": "Barbecue Restaurant Near Me",
                "link": "https://www.swiggy.com/barbecue-restaurants-near-me"
              },
              {
                "text": "Maharashtrian Restaurant Near Me",
                "link": "https://www.swiggy.com/maharashtrian-restaurants-near-me"
              },
              {
                "text": "Nepalese Restaurant Near Me",
                "link": "https://www.swiggy.com/nepalese-restaurants-near-me"
              },
              {
                "text": "Rajasthani Restaurant Near Me",
                "link": "https://www.swiggy.com/rajasthani-restaurants-near-me"
              },
              {
                "text": "Turkish Restaurant Near Me",
                "link": "https://www.swiggy.com/turkish-restaurants-near-me"
              }
            ],
            "id": "restaurant_near_me_links"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.seo.widgets.v1.BrandsContent",
            "title": "Explore Every Restaurants Near Me",
            "brands": [
              {
                "text": "Explore Restaurants Near Me",
                "link": "https://www.swiggy.com/restaurants-near-me"
              },
              {
                "text": "Explore Top Rated Restaurants Near Me",
                "link": "https://www.swiggy.com/best-restaurants-near-me"
              }
            ],
            "id": "restaurant_near_me_links"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.seo.widgets.v1.AppInstallLinks",
            "title": "For better experience,download the Swiggy app now",
            "androidAppImage": "portal/m/play_store.png",
            "androidAppLink": "https://play.google.com/store/apps/details?id=in.swiggy.android&referrer=utm_source%3Dswiggy%26utm_medium%3Dheader",
            "iosAppImage": "portal/m/app_store.png",
            "iosAppLink": "https://itunes.apple.com/in/app/id989540920?referrer=utm_source%3Dswiggy%26utm_medium%3Dhomepage",
            "id": "app_install_links"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.seo.widgets.v1.FooterContent",
            "cities": [
              {
                "text": "Bangalore",
                "link": "https://www.swiggy.com/city/bangalore"
              },
              {
                "text": "Gurgaon",
                "link": "https://www.swiggy.com/city/gurgaon"
              },
              {
                "text": "Hyderabad",
                "link": "https://www.swiggy.com/city/hyderabad"
              },
              {
                "text": "Delhi",
                "link": "https://www.swiggy.com/city/delhi"
              },
              {
                "text": "Mumbai",
                "link": "https://www.swiggy.com/city/mumbai"
              },
              {
                "text": "Pune",
                "link": "https://www.swiggy.com/city/pune"
              },
              {
                "text": "Kolkata",
                "link": "https://www.swiggy.com/city/kolkata"
              },
              {
                "text": "Chennai",
                "link": "https://www.swiggy.com/city/chennai"
              },
              {
                "text": "Ahmedabad",
                "link": "https://www.swiggy.com/city/ahmedabad"
              },
              {
                "text": "Chandigarh",
                "link": "https://www.swiggy.com/city/chandigarh"
              },
              {
                "text": "Jaipur",
                "link": "https://www.swiggy.com/city/jaipur"
              },
              {
                "text": "Kochi",
                "link": "https://www.swiggy.com/city/kochi"
              },
              {
                "text": "Coimbatore",
                "link": "https://www.swiggy.com/city/coimbatore"
              },
              {
                "text": "Lucknow",
                "link": "https://www.swiggy.com/city/lucknow"
              },
              {
                "text": "Nagpur",
                "link": "https://www.swiggy.com/city/nagpur"
              },
              {
                "text": "Vadodara",
                "link": "https://www.swiggy.com/city/vadodara"
              },
              {
                "text": "Indore",
                "link": "https://www.swiggy.com/city/indore"
              },
              {
                "text": "Guwahati",
                "link": "https://www.swiggy.com/city/guwahati"
              },
              {
                "text": "Vizag",
                "link": "https://www.swiggy.com/city/vizag"
              },
              {
                "text": "Surat",
                "link": "https://www.swiggy.com/city/surat"
              },
              {
                "text": "Dehradun",
                "link": "https://www.swiggy.com/city/dehradun"
              },
              {
                "text": "Noida",
                "link": "https://www.swiggy.com/city/noida"
              },
              {
                "text": "Ludhiana",
                "link": "https://www.swiggy.com/city/ludhiana"
              },
              {
                "text": "Trichy",
                "link": "https://www.swiggy.com/city/trichy"
              },
              {
                "text": "Vijayawada",
                "link": "https://www.swiggy.com/city/vijayawada"
              },
              {
                "text": "Kanpur",
                "link": "https://www.swiggy.com/city/kanpur"
              },
              {
                "text": "Mysore",
                "link": "https://www.swiggy.com/city/mysore"
              },
              {
                "text": "Nashik",
                "link": "https://www.swiggy.com/city/nashik"
              },
              {
                "text": "Udaipur",
                "link": "https://www.swiggy.com/city/udaipur"
              },
              {
                "text": "Pondicherry",
                "link": "https://www.swiggy.com/city/pondicherry"
              },
              {
                "text": "Agra",
                "link": "https://www.swiggy.com/city/agra"
              },
              {
                "text": "Aurangabad",
                "link": "https://www.swiggy.com/city/aurangabad"
              },
              {
                "text": "Jalandhar",
                "link": "https://www.swiggy.com/city/jalandhar"
              },
              {
                "text": "Kota",
                "link": "https://www.swiggy.com/city/kota"
              },
              {
                "text": "Madurai",
                "link": "https://www.swiggy.com/city/madurai"
              },
              {
                "text": "Allahabad",
                "link": "https://www.swiggy.com/city/allahabad"
              },
              {
                "text": "Manipal",
                "link": "https://www.swiggy.com/city/manipal"
              },
              {
                "text": "Amritsar",
                "link": "https://www.swiggy.com/city/amritsar"
              },
              {
                "text": "Bareilly",
                "link": "https://www.swiggy.com/city/bareilly"
              },
              {
                "text": "Meerut",
                "link": "https://www.swiggy.com/city/meerut"
              },
              {
                "text": "Bhopal",
                "link": "https://www.swiggy.com/city/bhopal"
              },
              {
                "text": "Ooty",
                "link": "https://www.swiggy.com/city/ooty"
              },
              {
                "text": "Bhubaneswar",
                "link": "https://www.swiggy.com/city/bhubaneswar"
              },
              {
                "text": "Raipur",
                "link": "https://www.swiggy.com/city/raipur"
              },
              {
                "text": "Bikaner",
                "link": "https://www.swiggy.com/city/bikaner"
              },
              {
                "text": "Rajkot",
                "link": "https://www.swiggy.com/city/rajkot"
              },
              {
                "text": "Kozhikode",
                "link": "https://www.swiggy.com/city/kozhikode"
              },
              {
                "text": "Central Goa",
                "link": "https://www.swiggy.com/city/central-goa"
              },
              {
                "text": "Sirsa",
                "link": "https://www.swiggy.com/city/sirsa"
              },
              {
                "text": "Gwalior",
                "link": "https://www.swiggy.com/city/gwalior"
              },
              {
                "text": "Thrissur",
                "link": "https://www.swiggy.com/city/thrissur"
              },
              {
                "text": "Kharagpur",
                "link": "https://www.swiggy.com/city/kharagpur"
              },
              {
                "text": "Tirupati",
                "link": "https://www.swiggy.com/city/tirupati"
              },
              {
                "text": "Tirupur",
                "link": "https://www.swiggy.com/city/tirupur"
              },
              {
                "text": "Vellore",
                "link": "https://www.swiggy.com/city/vellore"
              },
              {
                "text": "Thiruvananthapuram",
                "link": "https://www.swiggy.com/city/thiruvananthapuram"
              },
              {
                "text": "Warangal",
                "link": "https://www.swiggy.com/city/warangal"
              },
              {
                "text": "Varanasi",
                "link": "https://www.swiggy.com/city/varanasi"
              },
              {
                "text": "Mangaluru",
                "link": "https://www.swiggy.com/city/mangaluru"
              },
              {
                "text": "Patna",
                "link": "https://www.swiggy.com/city/patna"
              },
              {
                "text": "Ranchi",
                "link": "https://www.swiggy.com/city/ranchi"
              },
              {
                "text": "Faridabad",
                "link": "https://www.swiggy.com/city/faridabad"
              },
              {
                "text": "Guntur",
                "link": "https://www.swiggy.com/city/guntur"
              },
              {
                "text": "Ujjain",
                "link": "https://www.swiggy.com/city/ujjain"
              },
              {
                "text": "Patiala",
                "link": "https://www.swiggy.com/city/patiala"
              },
              {
                "text": "Karnal",
                "link": "https://www.swiggy.com/city/karnal"
              },
              {
                "text": "Kakinada",
                "link": "https://www.swiggy.com/city/kakinada"
              },
              {
                "text": "Rajahmundry",
                "link": "https://www.swiggy.com/city/rajahmundry"
              },
              {
                "text": "Bilaspur",
                "link": "https://www.swiggy.com/city/bilaspur"
              },
              {
                "text": "Bhilai",
                "link": "https://www.swiggy.com/city/bhilai"
              },
              {
                "text": "Anand",
                "link": "https://www.swiggy.com/city/anand"
              },
              {
                "text": "Bhavnagar",
                "link": "https://www.swiggy.com/city/bhavnagar"
              },
              {
                "text": "Jammu",
                "link": "https://www.swiggy.com/city/jammu"
              },
              {
                "text": "Muktsar",
                "link": "https://www.swiggy.com/city/muktsar"
              },
              {
                "text": "Panipat",
                "link": "https://www.swiggy.com/city/panipat"
              },
              {
                "text": "Dhanbad",
                "link": "https://www.swiggy.com/city/dhanbad"
              },
              {
                "text": "Hubli",
                "link": "https://www.swiggy.com/city/hubli"
              },
              {
                "text": "Belgaum",
                "link": "https://www.swiggy.com/city/belgaum"
              },
              {
                "text": "Jabalpur",
                "link": "https://www.swiggy.com/city/jabalpur"
              },
              {
                "text": "Kolhapur",
                "link": "https://www.swiggy.com/city/kolhapur"
              },
              {
                "text": "Solapur",
                "link": "https://www.swiggy.com/city/solapur"
              },
              {
                "text": "Shillong",
                "link": "https://www.swiggy.com/city/shillong"
              },
              {
                "text": "Cuttack",
                "link": "https://www.swiggy.com/city/cuttack"
              },
              {
                "text": "Aligarh",
                "link": "https://www.swiggy.com/city/aligarh"
              },
              {
                "text": "Salem",
                "link": "https://www.swiggy.com/city/salem"
              },
              {
                "text": "Jodhpur",
                "link": "https://www.swiggy.com/city/jodhpur"
              },
              {
                "text": "Ajmer",
                "link": "https://www.swiggy.com/city/ajmer"
              },
              {
                "text": "Jhansi",
                "link": "https://www.swiggy.com/city/jhansi"
              },
              {
                "text": "Gorakhpur",
                "link": "https://www.swiggy.com/city/gorakhpur"
              },
              {
                "text": "Thanjavur",
                "link": "https://www.swiggy.com/city/thanjavur"
              },
              {
                "text": "Erode",
                "link": "https://www.swiggy.com/city/erode"
              },
              {
                "text": "Nellore",
                "link": "https://www.swiggy.com/city/nellore"
              },
              {
                "text": "Rourkela",
                "link": "https://www.swiggy.com/city/rourkela"
              },
              {
                "text": "Anantapur",
                "link": "https://www.swiggy.com/city/anantapur"
              },
              {
                "text": "Kurnool",
                "link": "https://www.swiggy.com/city/kurnool"
              },
              {
                "text": "Ahmednagar",
                "link": "https://www.swiggy.com/city/ahmednagar"
              },
              {
                "text": "Phagwara",
                "link": "https://www.swiggy.com/city/phagwara"
              },
              {
                "text": "Ambala",
                "link": "https://www.swiggy.com/city/ambala"
              },
              {
                "text": "Ballari",
                "link": "https://www.swiggy.com/city/ballari"
              },
              {
                "text": "Saharanpur",
                "link": "https://www.swiggy.com/city/saharanpur"
              },
              {
                "text": "Tirunelveli",
                "link": "https://www.swiggy.com/city/tirunelveli"
              },
              {
                "text": "Bathinda",
                "link": "https://www.swiggy.com/city/bathinda"
              },
              {
                "text": "Mathura",
                "link": "https://www.swiggy.com/city/mathura"
              },
              {
                "text": "Haridwar",
                "link": "https://www.swiggy.com/city/haridwar"
              },
              {
                "text": "Ratnagiri",
                "link": "https://www.swiggy.com/city/ratnagiri"
              },
              {
                "text": "Sangli",
                "link": "https://www.swiggy.com/city/sangli"
              },
              {
                "text": "Amravati",
                "link": "https://www.swiggy.com/city/amravati"
              },
              {
                "text": "Rishikesh",
                "link": "https://www.swiggy.com/city/rishikesh"
              },
              {
                "text": "Nagercoil",
                "link": "https://www.swiggy.com/city/nagercoil"
              },
              {
                "text": "KanyaKumari",
                "link": "https://www.swiggy.com/city/kanyakumari"
              },
              {
                "text": "Kadapa",
                "link": "https://www.swiggy.com/city/kadapa"
              },
              {
                "text": "Nizamabad",
                "link": "https://www.swiggy.com/city/nizamabad"
              },
              {
                "text": "Shivamogga",
                "link": "https://www.swiggy.com/city/shivamogga"
              },
              {
                "text": "Davanagere",
                "link": "https://www.swiggy.com/city/davanagere"
              },
              {
                "text": "Roorkee",
                "link": "https://www.swiggy.com/city/roorkee"
              },
              {
                "text": "Nanded",
                "link": "https://www.swiggy.com/city/nanded"
              },
              {
                "text": "Rewa",
                "link": "https://www.swiggy.com/city/rewa"
              },
              {
                "text": "Satna",
                "link": "https://www.swiggy.com/city/satna"
              },
              {
                "text": "Muzaffarpur",
                "link": "https://www.swiggy.com/city/muzaffarpur"
              },
              {
                "text": "Valsad",
                "link": "https://www.swiggy.com/city/valsad"
              },
              {
                "text": "Vapi",
                "link": "https://www.swiggy.com/city/vapi"
              },
              {
                "text": "Chhapra",
                "link": "https://www.swiggy.com/city/chhapra"
              },
              {
                "text": "Dharamshala",
                "link": "https://www.swiggy.com/city/dharamshala"
              },
              {
                "text": "Kollam",
                "link": "https://www.swiggy.com/city/kollam"
              },
              {
                "text": "Silchar",
                "link": "https://www.swiggy.com/city/silchar"
              },
              {
                "text": "Alappuzha",
                "link": "https://www.swiggy.com/city/alappuzha"
              },
              {
                "text": "Sonipat",
                "link": "https://www.swiggy.com/city/sonipat"
              },
              {
                "text": "Rohtak",
                "link": "https://www.swiggy.com/city/rohtak"
              },
              {
                "text": "Mehsana",
                "link": "https://www.swiggy.com/city/mehsana"
              },
              {
                "text": "Kullu",
                "link": "https://www.swiggy.com/city/kullu"
              },
              {
                "text": "Dhule",
                "link": "https://www.swiggy.com/city/dhule"
              },
              {
                "text": "Dharwad",
                "link": "https://www.swiggy.com/city/dharwad"
              },
              {
                "text": "Latur",
                "link": "https://www.swiggy.com/city/latur"
              },
              {
                "text": "Vizianagaram",
                "link": "https://www.swiggy.com/city/vizianagaram"
              },
              {
                "text": "Khammam",
                "link": "https://www.swiggy.com/city/khammam"
              },
              {
                "text": "Hampi",
                "link": "https://www.swiggy.com/city/hampi"
              },
              {
                "text": "Nainital",
                "link": "https://www.swiggy.com/city/nainital"
              },
              {
                "text": "Akola",
                "link": "https://www.swiggy.com/city/akola"
              },
              {
                "text": "Kalaburagi",
                "link": "https://www.swiggy.com/city/kalaburagi"
              },
              {
                "text": "Gaya",
                "link": "https://www.swiggy.com/city/gaya"
              },
              {
                "text": "Muzaffarnagar",
                "link": "https://www.swiggy.com/city/muzaffarnagar"
              },
              {
                "text": "Dewas",
                "link": "https://www.swiggy.com/city/dewas"
              },
              {
                "text": "Korba",
                "link": "https://www.swiggy.com/city/korba"
              },
              {
                "text": "Mussoorie",
                "link": "https://www.swiggy.com/city/mussoorie"
              },
              {
                "text": "Jalgaon",
                "link": "https://www.swiggy.com/city/jalgaon"
              },
              {
                "text": "Yamuna Nagar",
                "link": "https://www.swiggy.com/city/yamuna-nagar"
              },
              {
                "text": "Bhagalpur",
                "link": "https://www.swiggy.com/city/bhagalpur"
              },
              {
                "text": "Hapur",
                "link": "https://www.swiggy.com/city/hapur"
              },
              {
                "text": "Morena",
                "link": "https://www.swiggy.com/city/morena"
              },
              {
                "text": "Hassan",
                "link": "https://www.swiggy.com/city/hassan"
              },
              {
                "text": "Hisar",
                "link": "https://www.swiggy.com/city/hisar"
              },
              {
                "text": "Godhra",
                "link": "https://www.swiggy.com/city/godhra"
              },
              {
                "text": "Kolar ",
                "link": "https://www.swiggy.com/city/kolar"
              },
              {
                "text": "Rampur",
                "link": "https://www.swiggy.com/city/rampur"
              },
              {
                "text": "Sitapur",
                "link": "https://www.swiggy.com/city/sitapur"
              },
              {
                "text": "Etawah",
                "link": "https://www.swiggy.com/city/etawah"
              },
              {
                "text": "Porbandar",
                "link": "https://www.swiggy.com/city/porbandar"
              },
              {
                "text": "Nadiad",
                "link": "https://www.swiggy.com/city/nadiad"
              },
              {
                "text": "Sagar",
                "link": "https://www.swiggy.com/city/sagar"
              },
              {
                "text": "Morbi",
                "link": "https://www.swiggy.com/city/morbi"
              },
              {
                "text": "Chhindwara",
                "link": "https://www.swiggy.com/city/chhindwara"
              },
              {
                "text": "Tumakuru",
                "link": "https://www.swiggy.com/city/tumakuru"
              },
              {
                "text": "Singrauli",
                "link": "https://www.swiggy.com/city/singrauli"
              },
              {
                "text": "Thoothukudi",
                "link": "https://www.swiggy.com/city/thoothukudi"
              },
              {
                "text": "Katni",
                "link": "https://www.swiggy.com/city/katni"
              },
              {
                "text": "Khandwa",
                "link": "https://www.swiggy.com/city/khandwa"
              },
              {
                "text": "Eluru",
                "link": "https://www.swiggy.com/city/eluru"
              },
              {
                "text": "Malappuram",
                "link": "https://www.swiggy.com/city/malappuram"
              },
              {
                "text": "Dibrugarh",
                "link": "https://www.swiggy.com/city/dibrugarh"
              },
              {
                "text": "Deoghar",
                "link": "https://www.swiggy.com/city/deoghar"
              },
              {
                "text": "Khanna",
                "link": "https://www.swiggy.com/city/khanna"
              },
              {
                "text": "Bidar",
                "link": "https://www.swiggy.com/city/bidar"
              },
              {
                "text": "Madikeri",
                "link": "https://www.swiggy.com/city/madikeri"
              },
              {
                "text": "Haldwani",
                "link": "https://www.swiggy.com/city/haldwani"
              },
              {
                "text": "Farrukhabad",
                "link": "https://www.swiggy.com/city/farrukhabad"
              },
              {
                "text": "Malegaon",
                "link": "https://www.swiggy.com/city/malegaon"
              },
              {
                "text": "Dindigul",
                "link": "https://www.swiggy.com/city/dindigul"
              },
              {
                "text": "Shahjahanpur",
                "link": "https://www.swiggy.com/city/shahjahanpur"
              },
              {
                "text": "Beed",
                "link": "https://www.swiggy.com/city/beed"
              },
              {
                "text": "Junagadh",
                "link": "https://www.swiggy.com/city/junagadh"
              },
              {
                "text": "Asansol",
                "link": "https://www.swiggy.com/city/asansol"
              },
              {
                "text": "Beawar",
                "link": "https://www.swiggy.com/city/beawar"
              },
              {
                "text": "Kishangarh",
                "link": "https://www.swiggy.com/city/kishangarh"
              },
              {
                "text": "Parbhani",
                "link": "https://www.swiggy.com/city/parbhani"
              },
              {
                "text": "Gondia",
                "link": "https://www.swiggy.com/city/gondia"
              },
              {
                "text": "Ichalkaranji",
                "link": "https://www.swiggy.com/city/ichalkaranji"
              },
              {
                "text": "Jalna",
                "link": "https://www.swiggy.com/city/jalna"
              },
              {
                "text": "Yavatmal",
                "link": "https://www.swiggy.com/city/yavatmal"
              },
              {
                "text": "Shivpuri",
                "link": "https://www.swiggy.com/city/shivpuri"
              },
              {
                "text": "Moga",
                "link": "https://www.swiggy.com/city/moga"
              },
              {
                "text": "Abohar",
                "link": "https://www.swiggy.com/city/abohar"
              },
              {
                "text": "Adoni",
                "link": "https://www.swiggy.com/city/adoni"
              },
              {
                "text": "Madanapalle",
                "link": "https://www.swiggy.com/city/madanapalle"
              },
              {
                "text": "Tiruvannamalai",
                "link": "https://www.swiggy.com/city/tiruvannamalai"
              },
              {
                "text": "Satara",
                "link": "https://www.swiggy.com/city/satara"
              },
              {
                "text": "Ambur",
                "link": "https://www.swiggy.com/city/ambur"
              },
              {
                "text": "Karimnagar",
                "link": "https://www.swiggy.com/city/karimnagar"
              },
              {
                "text": "Ratlam",
                "link": "https://www.swiggy.com/city/ratlam"
              },
              {
                "text": "Moradabad",
                "link": "https://www.swiggy.com/city/moradabad"
              },
              {
                "text": "Machilipatnam",
                "link": "https://www.swiggy.com/city/machilipatnam"
              },
              {
                "text": "Ongole",
                "link": "https://www.swiggy.com/city/ongole"
              },
              {
                "text": "Kottayam",
                "link": "https://www.swiggy.com/city/kottayam"
              },
              {
                "text": "Darbhanga",
                "link": "https://www.swiggy.com/city/darbhanga"
              },
              {
                "text": "Kurukshetra",
                "link": "https://www.swiggy.com/city/kurukshetra"
              },
              {
                "text": "Unnao",
                "link": "https://www.swiggy.com/city/unnao"
              },
              {
                "text": "Bulandshahr",
                "link": "https://www.swiggy.com/city/bulandshahr"
              },
              {
                "text": "Durgapur",
                "link": "https://www.swiggy.com/city/durgapur"
              },
              {
                "text": "Siliguri",
                "link": "https://www.swiggy.com/city/siliguri"
              },
              {
                "text": "Pali",
                "link": "https://www.swiggy.com/city/pali"
              },
              {
                "text": "Tadepalligudem",
                "link": "https://www.swiggy.com/city/tadepalligudem"
              },
              {
                "text": "Ramagundam",
                "link": "https://www.swiggy.com/city/ramagundam"
              },
              {
                "text": "Mahbubnagar",
                "link": "https://www.swiggy.com/city/mahbubnagar"
              },
              {
                "text": "Bhiwani",
                "link": "https://www.swiggy.com/city/bhiwani"
              },
              {
                "text": "Cuddalore",
                "link": "https://www.swiggy.com/city/cuddalore"
              },
              {
                "text": "Kaithal",
                "link": "https://www.swiggy.com/city/kaithal"
              },
              {
                "text": "Jagtial",
                "link": "https://www.swiggy.com/city/jagtial"
              },
              {
                "text": "Palakkad",
                "link": "https://www.swiggy.com/city/palakkad"
              },
              {
                "text": "Guna",
                "link": "https://www.swiggy.com/city/guna"
              },
              {
                "text": "Kumbakonam",
                "link": "https://www.swiggy.com/city/kumbakonam"
              },
              {
                "text": "Maunath Bhanjan",
                "link": "https://www.swiggy.com/city/maunath-bhanjan"
              },
              {
                "text": "Baripada",
                "link": "https://www.swiggy.com/city/baripada"
              },
              {
                "text": "Orai",
                "link": "https://www.swiggy.com/city/orai"
              },
              {
                "text": "Bhadrak",
                "link": "https://www.swiggy.com/city/bhadrak"
              },
              {
                "text": "Batala",
                "link": "https://www.swiggy.com/city/batala"
              },
              {
                "text": "Firozpur",
                "link": "https://www.swiggy.com/city/firozpur"
              },
              {
                "text": "Barnala",
                "link": "https://www.swiggy.com/city/barnala"
              },
              {
                "text": "Raigarh",
                "link": "https://www.swiggy.com/city/raigarh"
              },
              {
                "text": "Nagaon",
                "link": "https://www.swiggy.com/city/nagaon"
              },
              {
                "text": "Mainpuri",
                "link": "https://www.swiggy.com/city/mainpuri"
              },
              {
                "text": "Balurghat",
                "link": "https://www.swiggy.com/city/balurghat"
              },
              {
                "text": "Giridih",
                "link": "https://www.swiggy.com/city/giridih"
              },
              {
                "text": "Ghazipur",
                "link": "https://www.swiggy.com/city/ghazipur"
              },
              {
                "text": "Jagdalpur",
                "link": "https://www.swiggy.com/city/jagdalpur"
              },
              {
                "text": "Vidisha",
                "link": "https://www.swiggy.com/city/vidisha"
              },
              {
                "text": "Dimapur",
                "link": "https://www.swiggy.com/city/dimapur"
              },
              {
                "text": "Shikohabad",
                "link": "https://www.swiggy.com/city/shikohabad"
              },
              {
                "text": "Imphal",
                "link": "https://www.swiggy.com/city/imphal"
              },
              {
                "text": "Lakhimpur",
                "link": "https://www.swiggy.com/city/lakhimpur"
              },
              {
                "text": "Rudrapur",
                "link": "https://www.swiggy.com/city/rudrapur"
              },
              {
                "text": "Ambikapur",
                "link": "https://www.swiggy.com/city/ambikapur"
              },
              {
                "text": "Rae Bareli",
                "link": "https://www.swiggy.com/city/rae-bareli"
              },
              {
                "text": "Tinsukia",
                "link": "https://www.swiggy.com/city/tinsukia"
              },
              {
                "text": "Rajapalayam",
                "link": "https://www.swiggy.com/city/rajapalayam"
              },
              {
                "text": "Rajnandgaon",
                "link": "https://www.swiggy.com/city/rajnandgaon"
              },
              {
                "text": "Kashipur",
                "link": "https://www.swiggy.com/city/kashipur"
              },
              {
                "text": "Ranibennur",
                "link": "https://www.swiggy.com/city/ranibennur"
              },
              {
                "text": "Burhanpur",
                "link": "https://www.swiggy.com/city/burhanpur"
              },
              {
                "text": "Bhadravati",
                "link": "https://www.swiggy.com/city/bhadravati"
              },
              {
                "text": "Chittoor",
                "link": "https://www.swiggy.com/city/chittoor"
              },
              {
                "text": "Pudukkottai",
                "link": "https://www.swiggy.com/city/pudukkottai"
              },
              {
                "text": "Hardoi",
                "link": "https://www.swiggy.com/city/hardoi"
              },
              {
                "text": "Basti",
                "link": "https://www.swiggy.com/city/basti"
              },
              {
                "text": "Karaikkudi",
                "link": "https://www.swiggy.com/city/karaikkudi"
              },
              {
                "text": "Lalitpur",
                "link": "https://www.swiggy.com/city/lalitpur"
              },
              {
                "text": "Hospet",
                "link": "https://www.swiggy.com/city/hospet"
              },
              {
                "text": "Budaun",
                "link": "https://www.swiggy.com/city/budaun"
              },
              {
                "text": "Neemuch",
                "link": "https://www.swiggy.com/city/neemuch"
              },
              {
                "text": "Pilibhit",
                "link": "https://www.swiggy.com/city/pilibhit"
              },
              {
                "text": "Barshi",
                "link": "https://www.swiggy.com/city/barshi"
              },
              {
                "text": "Sri Ganganagar",
                "link": "https://www.swiggy.com/city/sri-ganganagar"
              },
              {
                "text": "Wardha",
                "link": "https://www.swiggy.com/city/wardha"
              },
              {
                "text": "Sehore",
                "link": "https://www.swiggy.com/city/sehore"
              },
              {
                "text": "Bhimavaram",
                "link": "https://www.swiggy.com/city/bhimavaram"
              },
              {
                "text": "Hanumangarh",
                "link": "https://www.swiggy.com/city/hanumangarh"
              },
              {
                "text": "Pathankot",
                "link": "https://www.swiggy.com/city/pathankot"
              },
              {
                "text": "Puri",
                "link": "https://www.swiggy.com/city/puri"
              },
              {
                "text": "Fatehpur",
                "link": "https://www.swiggy.com/city/fatehpur"
              },
              {
                "text": "Surendranagar Dudhrej",
                "link": "https://www.swiggy.com/city/surendranagar-dudhrej"
              },
              {
                "text": "Jamnagar",
                "link": "https://www.swiggy.com/city/jamnagar"
              },
              {
                "text": "Bhuj",
                "link": "https://www.swiggy.com/city/bhuj"
              },
              {
                "text": "Gandhidham",
                "link": "https://www.swiggy.com/city/gandhidham"
              },
              {
                "text": "Bharuch",
                "link": "https://www.swiggy.com/city/bharuch"
              },
              {
                "text": "Navsari",
                "link": "https://www.swiggy.com/city/navsari"
              },
              {
                "text": "Amreli",
                "link": "https://www.swiggy.com/city/amreli"
              },
              {
                "text": "Palanpur",
                "link": "https://www.swiggy.com/city/palanpur"
              },
              {
                "text": "Bhilwara",
                "link": "https://www.swiggy.com/city/bhilwara"
              },
              {
                "text": "Suratgarh",
                "link": "https://www.swiggy.com/city/suratgarh"
              },
              {
                "text": "Sikar",
                "link": "https://www.swiggy.com/city/sikar"
              },
              {
                "text": "Churu",
                "link": "https://www.swiggy.com/city/churu"
              },
              {
                "text": "Alwar",
                "link": "https://www.swiggy.com/city/alwar"
              },
              {
                "text": "Bhiwadi",
                "link": "https://www.swiggy.com/city/bhiwadi"
              },
              {
                "text": "Bharatpur",
                "link": "https://www.swiggy.com/city/bharatpur"
              },
              {
                "text": "Mount Abu",
                "link": "https://www.swiggy.com/city/mount-abu"
              },
              {
                "text": "Bundi",
                "link": "https://www.swiggy.com/city/bundi"
              },
              {
                "text": "Sawai Madhopur",
                "link": "https://www.swiggy.com/city/sawai-madhopur"
              },
              {
                "text": "Purulia",
                "link": "https://www.swiggy.com/city/purulia"
              },
              {
                "text": "Bardhaman",
                "link": "https://www.swiggy.com/city/bardhaman"
              },
              {
                "text": "Raniganj",
                "link": "https://www.swiggy.com/city/raniganj"
              },
              {
                "text": "Darjeeling",
                "link": "https://www.swiggy.com/city/darjeeling"
              },
              {
                "text": "Jalpaiguri",
                "link": "https://www.swiggy.com/city/jalpaiguri"
              },
              {
                "text": "Chittorgarh",
                "link": "https://www.swiggy.com/city/chittorgarh"
              },
              {
                "text": "Dholpur",
                "link": "https://www.swiggy.com/city/dholpur"
              },
              {
                "text": "Uluberia",
                "link": "https://www.swiggy.com/city/uluberia"
              },
              {
                "text": "Nabadwip",
                "link": "https://www.swiggy.com/city/nabadwip"
              },
              {
                "text": "Bongaon",
                "link": "https://www.swiggy.com/city/bongaon"
              },
              {
                "text": "Kanchrapara",
                "link": "https://www.swiggy.com/city/kanchrapara"
              },
              {
                "text": "Habra",
                "link": "https://www.swiggy.com/city/habra"
              },
              {
                "text": "Firozabad",
                "link": "https://www.swiggy.com/city/firozabad"
              },
              {
                "text": "Nalgonda",
                "link": "https://www.swiggy.com/city/nalgonda"
              },
              {
                "text": "Chandrapur",
                "link": "https://www.swiggy.com/city/chandrapur"
              },
              {
                "text": "Bijapur",
                "link": "https://www.swiggy.com/city/bijapur"
              },
              {
                "text": "Bhusawal",
                "link": "https://www.swiggy.com/city/bhusawal"
              },
              {
                "text": "Raichur",
                "link": "https://www.swiggy.com/city/raichur"
              },
              {
                "text": "Bahraich",
                "link": "https://www.swiggy.com/city/bahraich"
              },
              {
                "text": "Azamgarh",
                "link": "https://www.swiggy.com/city/azamgarh"
              },
              {
                "text": "Bahadurgarh",
                "link": "https://www.swiggy.com/city/bahadurgarh"
              },
              {
                "text": "Jind",
                "link": "https://www.swiggy.com/city/jind"
              },
              {
                "text": "Rewari",
                "link": "https://www.swiggy.com/city/rewari"
              },
              {
                "text": "Palwal",
                "link": "https://www.swiggy.com/city/palwal"
              },
              {
                "text": "Hathras",
                "link": "https://www.swiggy.com/city/hathras"
              },
              {
                "text": "Sambalpur",
                "link": "https://www.swiggy.com/city/sambalpur"
              },
              {
                "text": "Banda",
                "link": "https://www.swiggy.com/city/banda"
              },
              {
                "text": "Hoshiarpur",
                "link": "https://www.swiggy.com/city/hoshiarpur"
              },
              {
                "text": "Faridkot",
                "link": "https://www.swiggy.com/city/faridkot"
              },
              {
                "text": "Mandsaur",
                "link": "https://www.swiggy.com/city/mandsaur"
              },
              {
                "text": "Suryapet",
                "link": "https://www.swiggy.com/city/suryapet"
              },
              {
                "text": "Adilabad",
                "link": "https://www.swiggy.com/city/adilabad"
              },
              {
                "text": "Narasaraopet",
                "link": "https://www.swiggy.com/city/narasaraopet"
              },
              {
                "text": "Faizabad",
                "link": "https://www.swiggy.com/city/faizabad"
              },
              {
                "text": "Tadpatri",
                "link": "https://www.swiggy.com/city/tadpatri"
              },
              {
                "text": "Gonda",
                "link": "https://www.swiggy.com/city/gonda"
              },
              {
                "text": "Mughalsarai",
                "link": "https://www.swiggy.com/city/mughalsarai"
              },
              {
                "text": "Medinipur",
                "link": "https://www.swiggy.com/city/medinipur"
              },
              {
                "text": "Nagda",
                "link": "https://www.swiggy.com/city/nagda"
              },
              {
                "text": "Raiganj",
                "link": "https://www.swiggy.com/city/raiganj"
              },
              {
                "text": "Deoria City",
                "link": "https://www.swiggy.com/city/deoria-city"
              },
              {
                "text": "Sultanpur",
                "link": "https://www.swiggy.com/city/sultanpur"
              },
              {
                "text": "Shamli",
                "link": "https://www.swiggy.com/city/shamli"
              },
              {
                "text": "Krishnanagar",
                "link": "https://www.swiggy.com/city/krishnanagar"
              },
              {
                "text": "Ballia",
                "link": "https://www.swiggy.com/city/ballia"
              },
              {
                "text": "Guntakal",
                "link": "https://www.swiggy.com/city/guntakal"
              },
              {
                "text": "Miryalaguda",
                "link": "https://www.swiggy.com/city/miryalaguda"
              },
              {
                "text": "Etah",
                "link": "https://www.swiggy.com/city/etah"
              },
              {
                "text": "Berhampore",
                "link": "https://www.swiggy.com/city/berhampore"
              },
              {
                "text": "Gudivada",
                "link": "https://www.swiggy.com/city/gudivada"
              },
              {
                "text": "Haldia",
                "link": "https://www.swiggy.com/city/haldia"
              },
              {
                "text": "Santipur",
                "link": "https://www.swiggy.com/city/santipur"
              },
              {
                "text": "Basirhat",
                "link": "https://www.swiggy.com/city/basirhat"
              },
              {
                "text": "Udgir",
                "link": "https://www.swiggy.com/city/udgir"
              },
              {
                "text": "Proddatur",
                "link": "https://www.swiggy.com/city/proddatur"
              },
              {
                "text": "Nagapattinam",
                "link": "https://www.swiggy.com/city/nagapattinam"
              },
              {
                "text": "Chikmagalur",
                "link": "https://www.swiggy.com/city/chikmagalur"
              },
              {
                "text": "Chandausi",
                "link": "https://www.swiggy.com/city/chandausi"
              },
              {
                "text": "Bhind",
                "link": "https://www.swiggy.com/city/bhind"
              },
              {
                "text": "Mandya",
                "link": "https://www.swiggy.com/city/mandya"
              },
              {
                "text": "Bagalkot",
                "link": "https://www.swiggy.com/city/bagalkot"
              },
              {
                "text": "Nandurbar",
                "link": "https://www.swiggy.com/city/nandurbar"
              },
              {
                "text": "Chitradurga",
                "link": "https://www.swiggy.com/city/chitradurga"
              },
              {
                "text": "Osmanabad",
                "link": "https://www.swiggy.com/city/osmanabad"
              },
              {
                "text": "Modinagar",
                "link": "https://www.swiggy.com/city/modinagar"
              },
              {
                "text": "Gadag-Betigeri",
                "link": "https://www.swiggy.com/city/gadag-betigeri"
              },
              {
                "text": "Hoshangabad",
                "link": "https://www.swiggy.com/city/hoshangabad"
              },
              {
                "text": "Jaunpur",
                "link": "https://www.swiggy.com/city/jaunpur"
              },
              {
                "text": "Port Blair",
                "link": "https://www.swiggy.com/city/port-blair"
              },
              {
                "text": "Jorhat",
                "link": "https://www.swiggy.com/city/jorhat"
              },
              {
                "text": "Nandyal",
                "link": "https://www.swiggy.com/city/nandyal"
              },
              {
                "text": "Biharsharif",
                "link": "https://www.swiggy.com/city/biharsharif"
              },
              {
                "text": "Buxar",
                "link": "https://www.swiggy.com/city/buxar"
              },
              {
                "text": "Siwan",
                "link": "https://www.swiggy.com/city/siwan"
              },
              {
                "text": "Dehri",
                "link": "https://www.swiggy.com/city/dehri"
              },
              {
                "text": "Bettiah",
                "link": "https://www.swiggy.com/city/bettiah"
              },
              {
                "text": "Kishanganj",
                "link": "https://www.swiggy.com/city/kishanganj"
              },
              {
                "text": "Saharsa",
                "link": "https://www.swiggy.com/city/saharsa"
              },
              {
                "text": "Hajipur",
                "link": "https://www.swiggy.com/city/hajipur"
              },
              {
                "text": "Motihari",
                "link": "https://www.swiggy.com/city/motihari"
              },
              {
                "text": "Sasaram",
                "link": "https://www.swiggy.com/city/sasaram"
              },
              {
                "text": "Munger",
                "link": "https://www.swiggy.com/city/munger"
              },
              {
                "text": "Katihar",
                "link": "https://www.swiggy.com/city/katihar"
              },
              {
                "text": "Arrah",
                "link": "https://www.swiggy.com/city/arrah"
              },
              {
                "text": "Srikakulam",
                "link": "https://www.swiggy.com/city/srikakulam"
              },
              {
                "text": "Begusarai",
                "link": "https://www.swiggy.com/city/begusarai"
              },
              {
                "text": "Neyveli",
                "link": "https://www.swiggy.com/city/neyveli"
              },
              {
                "text": "Waidhan",
                "link": "https://www.swiggy.com/city/waidhan"
              },
              {
                "text": "Markapur",
                "link": "https://www.swiggy.com/city/markapur"
              },
              {
                "text": "Chikkaballapur",
                "link": "https://www.swiggy.com/city/chikkaballapur"
              },
              {
                "text": "Bhatkal",
                "link": "https://www.swiggy.com/city/bhatkal"
              },
              {
                "text": "Gokak",
                "link": "https://www.swiggy.com/city/gokak"
              },
              {
                "text": "Itarsi",
                "link": "https://www.swiggy.com/city/itarsi"
              },
              {
                "text": "Dhar",
                "link": "https://www.swiggy.com/city/dhar"
              },
              {
                "text": "Chalisgaon",
                "link": "https://www.swiggy.com/city/chalisgaon"
              },
              {
                "text": "Thiruvallur",
                "link": "https://www.swiggy.com/city/thiruvallur"
              },
              {
                "text": "Namakkal",
                "link": "https://www.swiggy.com/city/namakkal"
              },
              {
                "text": "Dharmapuri",
                "link": "https://www.swiggy.com/city/dharmapuri"
              },
              {
                "text": "Bhandara",
                "link": "https://www.swiggy.com/city/bhandara"
              },
              {
                "text": "Virudhunagar",
                "link": "https://www.swiggy.com/city/virudhunagar"
              },
              {
                "text": "Siddipet",
                "link": "https://www.swiggy.com/city/siddipet"
              },
              {
                "text": "Gadwal",
                "link": "https://www.swiggy.com/city/gadwal"
              },
              {
                "text": "Bodhan-Rural",
                "link": "https://www.swiggy.com/city/bodhan-rural"
              },
              {
                "text": "Kamareddy",
                "link": "https://www.swiggy.com/city/kamareddy"
              },
              {
                "text": "Jhunjhunu",
                "link": "https://www.swiggy.com/city/jhunjhunu"
              },
              {
                "text": "Kapurthala",
                "link": "https://www.swiggy.com/city/kapurthala"
              },
              {
                "text": "Sangrur",
                "link": "https://www.swiggy.com/city/sangrur"
              },
              {
                "text": "Gurdaspur",
                "link": "https://www.swiggy.com/city/gurdaspur"
              },
              {
                "text": "Ramgarh",
                "link": "https://www.swiggy.com/city/ramgarh"
              },
              {
                "text": "Bantwal",
                "link": "https://www.swiggy.com/city/bantwal"
              },
              {
                "text": "Doddaballapura",
                "link": "https://www.swiggy.com/city/doddaballapura"
              },
              {
                "text": "Buldana",
                "link": "https://www.swiggy.com/city/buldana"
              },
              {
                "text": "Karad",
                "link": "https://www.swiggy.com/city/karad"
              },
              {
                "text": "Krishnagiri",
                "link": "https://www.swiggy.com/city/krishnagiri"
              },
              {
                "text": "Tiptur",
                "link": "https://www.swiggy.com/city/tiptur"
              },
              {
                "text": "Bhadrachalam",
                "link": "https://www.swiggy.com/city/bhadrachalam"
              },
              {
                "text": "Mancherial",
                "link": "https://www.swiggy.com/city/mancherial"
              },
              {
                "text": "Balrampur",
                "link": "https://www.swiggy.com/city/balrampur"
              },
              {
                "text": "Bharabanki",
                "link": "https://www.swiggy.com/city/bharabanki"
              },
              {
                "text": "Malout",
                "link": "https://www.swiggy.com/city/malout"
              },
              {
                "text": "Fatehgarh Sahib",
                "link": "https://www.swiggy.com/city/fatehgarh-sahib"
              },
              {
                "text": "Ropar",
                "link": "https://www.swiggy.com/city/ropar"
              },
              {
                "text": "Nangal",
                "link": "https://www.swiggy.com/city/nangal"
              },
              {
                "text": "Narnaul",
                "link": "https://www.swiggy.com/city/narnaul"
              },
              {
                "text": "Naraingarh",
                "link": "https://www.swiggy.com/city/naraingarh"
              },
              {
                "text": "Himmatnagar",
                "link": "https://www.swiggy.com/city/himmatnagar"
              },
              {
                "text": "Dausa",
                "link": "https://www.swiggy.com/city/dausa"
              },
              {
                "text": "Jahanabad",
                "link": "https://www.swiggy.com/city/jahanabad"
              },
              {
                "text": "Samastipur",
                "link": "https://www.swiggy.com/city/samastipur"
              },
              {
                "text": "Purnea",
                "link": "https://www.swiggy.com/city/purnea"
              },
              {
                "text": "Berhampur",
                "link": "https://www.swiggy.com/city/berhampur"
              },
              {
                "text": "Malda",
                "link": "https://www.swiggy.com/city/malda"
              },
              {
                "text": "Tuni",
                "link": "https://www.swiggy.com/city/tuni"
              },
              {
                "text": "Puttur",
                "link": "https://www.swiggy.com/city/puttur"
              },
              {
                "text": "Rayachoty",
                "link": "https://www.swiggy.com/city/rayachoty"
              },
              {
                "text": "Nirmal",
                "link": "https://www.swiggy.com/city/nirmal"
              },
              {
                "text": "Mirzapur",
                "link": "https://www.swiggy.com/city/mirzapur"
              },
              {
                "text": "Tanuku",
                "link": "https://www.swiggy.com/city/tanuku"
              },
              {
                "text": "Dahod",
                "link": "https://www.swiggy.com/city/dahod"
              },
              {
                "text": "Barmer",
                "link": "https://www.swiggy.com/city/barmer"
              },
              {
                "text": "Gangapur City",
                "link": "https://www.swiggy.com/city/gangapur-city"
              },
              {
                "text": "Mandi Gobindgarh",
                "link": "https://www.swiggy.com/city/mandi-gobindgarh"
              },
              {
                "text": "Tarn Taran Sahib",
                "link": "https://www.swiggy.com/city/tarn-taran-sahib"
              },
              {
                "text": "Nakodar",
                "link": "https://www.swiggy.com/city/nakodar"
              },
              {
                "text": "Ankleshwar",
                "link": "https://www.swiggy.com/city/ankleshwar"
              },
              {
                "text": "Vyara",
                "link": "https://www.swiggy.com/city/vyara"
              },
              {
                "text": "Bardoli",
                "link": "https://www.swiggy.com/city/bardoli"
              },
              {
                "text": "Halol",
                "link": "https://www.swiggy.com/city/halol"
              },
              {
                "text": "Bijnor",
                "link": "https://www.swiggy.com/city/bijnor"
              },
              {
                "text": "Sangamner",
                "link": "https://www.swiggy.com/city/sangamner"
              },
              {
                "text": "Baramati",
                "link": "https://www.swiggy.com/city/baramati"
              },
              {
                "text": "Betul",
                "link": "https://www.swiggy.com/city/betul"
              },
              {
                "text": "Chhatarpur",
                "link": "https://www.swiggy.com/city/chhatarpur"
              },
              {
                "text": "Balaghat",
                "link": "https://www.swiggy.com/city/balaghat"
              },
              {
                "text": "Sivakasi",
                "link": "https://www.swiggy.com/city/sivakasi"
              },
              {
                "text": "Viluppuram",
                "link": "https://www.swiggy.com/city/viluppuram"
              },
              {
                "text": "Ramanathapuram",
                "link": "https://www.swiggy.com/city/ramanathapuram"
              },
              {
                "text": "Sirsi",
                "link": "https://www.swiggy.com/city/sirsi"
              },
              {
                "text": "Theni",
                "link": "https://www.swiggy.com/city/theni"
              },
              {
                "text": "Karur",
                "link": "https://www.swiggy.com/city/karur"
              },
              {
                "text": "Karwar",
                "link": "https://www.swiggy.com/city/karwar"
              },
              {
                "text": "Sindhanur",
                "link": "https://www.swiggy.com/city/sindhanur"
              },
              {
                "text": "Kannur",
                "link": "https://www.swiggy.com/city/kannur"
              },
              {
                "text": "Noida 1",
                "link": "https://www.swiggy.com/city/noida-1"
              },
              {
                "text": "Thiruvalla",
                "link": "https://www.swiggy.com/city/thiruvalla"
              },
              {
                "text": "Thodupuzha",
                "link": "https://www.swiggy.com/city/thodupuzha"
              },
              {
                "text": "Kadiri",
                "link": "https://www.swiggy.com/city/kadiri"
              },
              {
                "text": "Kavali",
                "link": "https://www.swiggy.com/city/kavali"
              },
              {
                "text": "Tezpur",
                "link": "https://www.swiggy.com/city/tezpur"
              },
              {
                "text": "Kayamkulam",
                "link": "https://www.swiggy.com/city/kayamkulam"
              },
              {
                "text": "Kottarakkara",
                "link": "https://www.swiggy.com/city/kottarakkara"
              },
              {
                "text": "Mandi Dabwali",
                "link": "https://www.swiggy.com/city/mandi-dabwali"
              },
              {
                "text": "Fatehabad",
                "link": "https://www.swiggy.com/city/fatehabad"
              },
              {
                "text": "Jagraon",
                "link": "https://www.swiggy.com/city/jagraon"
              },
              {
                "text": "Mansa",
                "link": "https://www.swiggy.com/city/mansa"
              },
              {
                "text": "Pinjore City",
                "link": "https://www.swiggy.com/city/pinjore-city"
              },
              {
                "text": "Fazilka",
                "link": "https://www.swiggy.com/city/fazilka"
              },
              {
                "text": "Baddi",
                "link": "https://www.swiggy.com/city/baddi"
              },
              {
                "text": "Solan",
                "link": "https://www.swiggy.com/city/solan"
              },
              {
                "text": "Daltonganj",
                "link": "https://www.swiggy.com/city/daltonganj"
              },
              {
                "text": "Balangir",
                "link": "https://www.swiggy.com/city/balangir"
              },
              {
                "text": "Kothagudem",
                "link": "https://www.swiggy.com/city/kothagudem"
              },
              {
                "text": "Hansi",
                "link": "https://www.swiggy.com/city/hansi"
              },
              {
                "text": "Aurangabad_Bihar",
                "link": "https://www.swiggy.com/city/aurangabadbihar"
              },
              {
                "text": "Gopalganj",
                "link": "https://www.swiggy.com/city/gopalganj"
              },
              {
                "text": "Jharsuguda",
                "link": "https://www.swiggy.com/city/jharsuguda"
              },
              {
                "text": "Tohana",
                "link": "https://www.swiggy.com/city/tohana"
              },
              {
                "text": "Jhalawar",
                "link": "https://www.swiggy.com/city/jhalawar"
              },
              {
                "text": "Sivasagar",
                "link": "https://www.swiggy.com/city/sivasagar"
              },
              {
                "text": "Bagdogra",
                "link": "https://www.swiggy.com/city/bagdogra"
              },
              {
                "text": "Kendrapada",
                "link": "https://www.swiggy.com/city/kendrapada"
              },
              {
                "text": "Mallapuram (Do not Use)",
                "link": "https://www.swiggy.com/city/mallapuram-do-not-use"
              },
              {
                "text": "Veraval",
                "link": "https://www.swiggy.com/city/veraval"
              },
              {
                "text": "Daman",
                "link": "https://www.swiggy.com/city/daman"
              },
              {
                "text": "Chiplun",
                "link": "https://www.swiggy.com/city/chiplun"
              },
              {
                "text": "Silvassa",
                "link": "https://www.swiggy.com/city/silvassa"
              },
              {
                "text": "Lonavla",
                "link": "https://www.swiggy.com/city/lonavla"
              },
              {
                "text": "Bongaigaon",
                "link": "https://www.swiggy.com/city/bongaigaon"
              },
              {
                "text": "Golaghat",
                "link": "https://www.swiggy.com/city/golaghat"
              },
              {
                "text": "Duliajan",
                "link": "https://www.swiggy.com/city/duliajan"
              },
              {
                "text": "Bolpur",
                "link": "https://www.swiggy.com/city/bolpur"
              },
              {
                "text": "Madhubani",
                "link": "https://www.swiggy.com/city/madhubani"
              },
              {
                "text": "Balasore",
                "link": "https://www.swiggy.com/city/balasore"
              },
              {
                "text": "Palampur",
                "link": "https://www.swiggy.com/city/palampur"
              },
              {
                "text": "Kotdwar",
                "link": "https://www.swiggy.com/city/kotdwar"
              },
              {
                "text": "Koppal",
                "link": "https://www.swiggy.com/city/koppal"
              },
              {
                "text": "Chikhli",
                "link": "https://www.swiggy.com/city/chikhli"
              },
              {
                "text": "Dahanu",
                "link": "https://www.swiggy.com/city/dahanu"
              },
              {
                "text": "Itanagar",
                "link": "https://www.swiggy.com/city/itanagar"
              },
              {
                "text": "Rangpo",
                "link": "https://www.swiggy.com/city/rangpo"
              },
              {
                "text": "Aizawl",
                "link": "https://www.swiggy.com/city/aizawl"
              },
              {
                "text": "Gangtok",
                "link": "https://www.swiggy.com/city/gangtok"
              },
              {
                "text": "Mayiladuthurai",
                "link": "https://www.swiggy.com/city/mayiladuthurai"
              },
              {
                "text": "Kannauj",
                "link": "https://www.swiggy.com/city/kannauj"
              },
              {
                "text": "Cooch Behar",
                "link": "https://www.swiggy.com/city/cooch-behar"
              },
              {
                "text": "Palani",
                "link": "https://www.swiggy.com/city/palani"
              },
              {
                "text": "Bilimora",
                "link": "https://www.swiggy.com/city/bilimora"
              },
              {
                "text": "Boisar",
                "link": "https://www.swiggy.com/city/boisar"
              },
              {
                "text": "Kohima",
                "link": "https://www.swiggy.com/city/kohima"
              },
              {
                "text": "Naharlagun",
                "link": "https://www.swiggy.com/city/naharlagun"
              },
              {
                "text": "Dumka",
                "link": "https://www.swiggy.com/city/dumka"
              },
              {
                "text": "Rajsamand",
                "link": "https://www.swiggy.com/city/rajsamand"
              },
              {
                "text": "Gauriganj",
                "link": "https://www.swiggy.com/city/gauriganj"
              },
              {
                "text": "Bodinayakanur",
                "link": "https://www.swiggy.com/city/bodinayakanur"
              },
              {
                "text": "Bhawanipatna",
                "link": "https://www.swiggy.com/city/bhawanipatna"
              },
              {
                "text": "Baran",
                "link": "https://www.swiggy.com/city/baran"
              },
              {
                "text": "Narsinghpur",
                "link": "https://www.swiggy.com/city/narsinghpur"
              },
              {
                "text": "Kovilpatti",
                "link": "https://www.swiggy.com/city/kovilpatti"
              },
              {
                "text": "Pusad",
                "link": "https://www.swiggy.com/city/pusad"
              },
              {
                "text": "Kendujhar",
                "link": "https://www.swiggy.com/city/kendujhar"
              },
              {
                "text": "Manali",
                "link": "https://www.swiggy.com/city/manali"
              },
              {
                "text": "Diu",
                "link": "https://www.swiggy.com/city/diu"
              },
              {
                "text": "Khamgaon",
                "link": "https://www.swiggy.com/city/khamgaon"
              },
              {
                "text": "Ramanagara",
                "link": "https://www.swiggy.com/city/ramanagara"
              },
              {
                "text": "Alipurduar",
                "link": "https://www.swiggy.com/city/alipurduar"
              },
              {
                "text": "Almora",
                "link": "https://www.swiggy.com/city/almora"
              },
              {
                "text": "Jhargram",
                "link": "https://www.swiggy.com/city/jhargram"
              },
              {
                "text": "Arambagh",
                "link": "https://www.swiggy.com/city/arambagh"
              },
              {
                "text": "Bhadohi",
                "link": "https://www.swiggy.com/city/bhadohi"
              },
              {
                "text": "Tenkasi",
                "link": "https://www.swiggy.com/city/tenkasi"
              },
              {
                "text": "Srivilliputhur",
                "link": "https://www.swiggy.com/city/srivilliputhur"
              },
              {
                "text": "Chidambaram",
                "link": "https://www.swiggy.com/city/chidambaram"
              },
              {
                "text": "Rajgarh",
                "link": "https://www.swiggy.com/city/rajgarh"
              },
              {
                "text": "Pratapgarh",
                "link": "https://www.swiggy.com/city/pratapgarh"
              },
              {
                "text": "Washim",
                "link": "https://www.swiggy.com/city/washim"
              },
              {
                "text": "Raghunathpur",
                "link": "https://www.swiggy.com/city/raghunathpur"
              },
              {
                "text": "Suri",
                "link": "https://www.swiggy.com/city/suri"
              },
              {
                "text": "Kadayanallur",
                "link": "https://www.swiggy.com/city/kadayanallur"
              },
              {
                "text": "Thiruvarur",
                "link": "https://www.swiggy.com/city/thiruvarur"
              },
              {
                "text": "Ranaghat-WB",
                "link": "https://www.swiggy.com/city/ranaghat-wb"
              },
              {
                "text": "Wayanad",
                "link": "https://www.swiggy.com/city/wayanad"
              },
              {
                "text": "Perambalur",
                "link": "https://www.swiggy.com/city/perambalur"
              },
              {
                "text": "Paramakudi",
                "link": "https://www.swiggy.com/city/paramakudi"
              },
              {
                "text": "Bela Pratapgarh",
                "link": "https://www.swiggy.com/city/bela-pratapgarh"
              },
              {
                "text": "Mahoba",
                "link": "https://www.swiggy.com/city/mahoba"
              },
              {
                "text": "Sitamarhi",
                "link": "https://www.swiggy.com/city/sitamarhi"
              },
              {
                "text": "Chakdaha",
                "link": "https://www.swiggy.com/city/chakdaha"
              },
              {
                "text": "Khalilabad",
                "link": "https://www.swiggy.com/city/khalilabad"
              },
              {
                "text": "Pattukkottai",
                "link": "https://www.swiggy.com/city/pattukkottai"
              },
              {
                "text": "Tindivanam",
                "link": "https://www.swiggy.com/city/tindivanam"
              },
              {
                "text": "Tiruttani",
                "link": "https://www.swiggy.com/city/tiruttani"
              },
              {
                "text": "Gangarampur",
                "link": "https://www.swiggy.com/city/gangarampur"
              },
              {
                "text": "Dharapuram",
                "link": "https://www.swiggy.com/city/dharapuram"
              },
              {
                "text": "Arakkonam",
                "link": "https://www.swiggy.com/city/arakkonam"
              },
              {
                "text": "Sirkali",
                "link": "https://www.swiggy.com/city/sirkali"
              },
              {
                "text": "Mettupalayam",
                "link": "https://www.swiggy.com/city/mettupalayam"
              },
              {
                "text": "Digboi",
                "link": "https://www.swiggy.com/city/digboi"
              },
              {
                "text": "Biswanath Chariali",
                "link": "https://www.swiggy.com/city/biswanath-chariali"
              },
              {
                "text": "Nalbari",
                "link": "https://www.swiggy.com/city/nalbari"
              },
              {
                "text": "Shirdi city",
                "link": "https://www.swiggy.com/city/shirdi-city"
              },
              {
                "text": "Mukerian",
                "link": "https://www.swiggy.com/city/mukerian"
              },
              {
                "text": "Hosur",
                "link": "https://www.swiggy.com/city/hosur"
              },
              {
                "text": "Palakollu",
                "link": "https://www.swiggy.com/city/palakollu"
              },
              {
                "text": "Ravulapalem",
                "link": "https://www.swiggy.com/city/ravulapalem"
              },
              {
                "text": "Barh",
                "link": "https://www.swiggy.com/city/barh"
              },
              {
                "text": "Palghar",
                "link": "https://www.swiggy.com/city/palghar"
              },
              {
                "text": "Kushalnagar",
                "link": "https://www.swiggy.com/city/kushalnagar"
              },
              {
                "text": "Dungarpur",
                "link": "https://www.swiggy.com/city/dungarpur"
              },
              {
                "text": "Chaibasa",
                "link": "https://www.swiggy.com/city/chaibasa"
              },
              {
                "text": "Haveri",
                "link": "https://www.swiggy.com/city/haveri"
              },
              {
                "text": "Karaikal",
                "link": "https://www.swiggy.com/city/karaikal"
              },
              {
                "text": "Jjajjar",
                "link": "https://www.swiggy.com/city/jjajjar"
              },
              {
                "text": "Kokrajhar",
                "link": "https://www.swiggy.com/city/kokrajhar"
              },
              {
                "text": "Rangia",
                "link": "https://www.swiggy.com/city/rangia"
              },
              {
                "text": "Hamirpur",
                "link": "https://www.swiggy.com/city/hamirpur"
              },
              {
                "text": "Una",
                "link": "https://www.swiggy.com/city/una"
              },
              {
                "text": "Sulthan Bathery",
                "link": "https://www.swiggy.com/city/sulthan-bathery"
              },
              {
                "text": "Rayagada",
                "link": "https://www.swiggy.com/city/rayagada"
              },
              {
                "text": "Paradeep",
                "link": "https://www.swiggy.com/city/paradeep"
              },
              {
                "text": "Mandapeta",
                "link": "https://www.swiggy.com/city/mandapeta"
              },
              {
                "text": "Jamui",
                "link": "https://www.swiggy.com/city/jamui"
              },
              {
                "text": "Pilkhuwa",
                "link": "https://www.swiggy.com/city/pilkhuwa"
              },
              {
                "text": "Parvathipuram",
                "link": "https://www.swiggy.com/city/parvathipuram"
              },
              {
                "text": "Ambajogai",
                "link": "https://www.swiggy.com/city/ambajogai"
              },
              {
                "text": "Araria",
                "link": "https://www.swiggy.com/city/araria"
              },
              {
                "text": "North Lakhimpur",
                "link": "https://www.swiggy.com/city/north-lakhimpur"
              },
              {
                "text": "Rajampet",
                "link": "https://www.swiggy.com/city/rajampet"
              },
              {
                "text": "Udumalaipettai",
                "link": "https://www.swiggy.com/city/udumalaipettai"
              },
              {
                "text": "Tirupattur",
                "link": "https://www.swiggy.com/city/tirupattur"
              },
              {
                "text": "Hojai",
                "link": "https://www.swiggy.com/city/hojai"
              },
              {
                "text": "Khagaria",
                "link": "https://www.swiggy.com/city/khagaria"
              },
              {
                "text": "Dasuya",
                "link": "https://www.swiggy.com/city/dasuya"
              },
              {
                "text": "Gudur",
                "link": "https://www.swiggy.com/city/gudur"
              },
              {
                "text": "Sullurpeta",
                "link": "https://www.swiggy.com/city/sullurpeta"
              },
              {
                "text": "Piler",
                "link": "https://www.swiggy.com/city/piler"
              },
              {
                "text": "SankaranKoil",
                "link": "https://www.swiggy.com/city/sankarankoil"
              },
              {
                "text": "Nabha",
                "link": "https://www.swiggy.com/city/nabha"
              },
              {
                "text": "LPU - Phagwara",
                "link": "https://www.swiggy.com/city/lpu-phagwara"
              },
              {
                "text": "Jangipur",
                "link": "https://www.swiggy.com/city/jangipur"
              },
              {
                "text": "Roha",
                "link": "https://www.swiggy.com/city/roha"
              }
            ],
            "id": "footer_content"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.seo.widgets.v1.MetaContext",
            "citySlug": "coimbatore",
            "lat": "11.099638",
            "lng": "76.9401231",
            "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/113.0.0.0 Safari/537.36",
            "gandalfRequest": "{\"sortAttribute\":\"relevance\",\"isFiltered\":false,\"queryId\":\"seo-data-887ce4ba-440e-42a4-91d5-727f4138ecc7\",\"seoParams\":{\"apiName\":\"FoodHomePage\",\"brandId\":\"\",\"seoUrl\":\"www.swiggy.com\",\"pageType\":\"FOOD_HOME_PAGE\"}}",
            "id": "meta_data",
            "metaInfo": {
              "pageType": "FOOD_HOME_PAGE",
              "pageTitle": "Order Food Online from India's Best Food Delivery Service | Swiggy",
              "pageMetaDescription": "Order food online from restaurants and get it delivered. Serving in Bangalore, Hyderabad, Delhi and more. Order Pizzas, Biryanis, from Swiggy.",
              "pageKeywords": "Food delivery, Online food order, Online food dleivery"
            },
            "screenType": "filteredCollection",
            "seoParams": {
              "apiName": "FoodHomePage",
              "seoUrl": "www.swiggy.com",
              "pageType": "FOOD_HOME_PAGE"
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "cacheExpiryTime": 240,
    "nextFetch": 1
  },
  "tid": "2bc5c148-30e7-4b58-a408-99491b18d85d",
  "sid": "b737b0a5-26d0-4abe-b59c-04eded966716",
  "deviceId": "97dcf0ae-1c11-1b18-375d-e6c5284bdc19",
  "csrfToken": "69YQPatM0U9G-Kebw7hy61N6-htU5kqWp7BfXRKk"
}
